// var site_url = 'http://sistema.globalcond.com.br';
var site_url = window.location.origin;
var api = site_url + '/api/v1/';

/***

Metronic AngularJS App Main Script
***/

/* Metronic App */
var app = angular.module("app", [
    "ui.router",
    "ui.bootstrap",
    "oc.lazyLoad",
    "ngSanitize",
    "ui.utils.masks",
    "colorpicker.module",
    "wysiwyg.module",
    "ui.bootstrap.datetimepicker",
    "ui.date",
    "chart.js"
]);

//Traduzindo ui-date
jQuery(function ($) {
    $.datepicker.regional['pt'] = {
        closeText: 'Fechar',
        prevText: '<Anterior',
        nextText: 'Seguinte',
        currentText: 'Hoje',
        monthNames: ['Janeiro', 'Fevereiro', 'Mar&ccedil;o', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
        'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        dayNames: ['Domingo', 'Segunda-feira', 'Ter&ccedil;a-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'S&aacute;bado'],
        dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'S&aacute;b'],
        dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'S&aacute;b'],
        weekHeader: 'Sem',
        dateFormat: 'dd/mm/yy',
        firstDay: 0,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: ''
    };
    $.datepicker.setDefaults($.datepicker.regional['pt']);
});

//Função global para retornar data num formato específico
function now(now,showMinute = true) {
    if(typeof now === 'string') {
      now = new Date(now);
    }

    now = now || new Date();
    month = (now.getMonth() + 1);
    month = month < 10 ? '0'+month : month;
    let minutes = "";
    if(showMinute){
      minutes =' ' +now.getHours() + ':' + (now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes());
    }

    return (now.getFullYear() + '-'
            + month + '-'
            + (now.getDate() < 10 ? '0'+now.getDate() : now.getDate())
            + minutes);
}

//Adicionando opções ao toastr
toastr.options = {
  "closeButton": true,
  "debug": false,
  "newestOnTop": false,
  "progressBar": true,
  "positionClass": "toast-top-right",
  "preventDuplicates": false,
  "onclick": null,
  "showDuration": "300",
  "hideDuration": "1000",
  "timeOut": "5000",
  "extendedTimeOut": "1000",
  "showEasing": "swing",
  "hideEasing": "linear",
  "showMethod": "fadeIn",
  "hideMethod": "fadeOut"
};

/* Configure ocLazyLoader(refer: https://github.com/ocombe/ocLazyLoad) */
app.config(['$ocLazyLoadProvider', function($ocLazyLoadProvider) {
    $ocLazyLoadProvider.config({
        // global configs go here
    });
}]);

//AngularJS v1.3.x workaround for old style controller declarition in HTML
app.config(['$controllerProvider', function($controllerProvider) {
  // this option might be handy for migrating old apps, but please don't use it
  // in new ones!
  $controllerProvider.allowGlobals();
}]);

app.config(['$compileProvider', function ($compileProvider) {
  // disable debug info
  $compileProvider.debugInfoEnabled(false);
}]);

//Mudar a cor do CHART
app.config(['ChartJsProvider',function(ChartJsProvider){
  ChartJsProvider.setOptions({
    chartColors: ['#6488ff', '#ff5b5b', '#80b6ff', '#c980ff'],
    responsive: true
  })
}])

/********************************************
 END: BREAKING CHANGE in AngularJS v1.3.x:
*********************************************/

/* Setup global settings */
app.factory('settings', ['$rootScope', function($rootScope) {
    // supported languages
    var settings = {
        layout: {
            pageSidebarClosed: false, // sidebar menu state
            pageContentWhite: true, // set page content layout
            pageBodySolid: false, // solid body color state
            pageAutoScrollOnLoad: 1000 // auto scroll to top on page load
        },
        assetsPath: '../assets',
        globalPath: '../assets/global',
        layoutPath: '../assets/layouts/layout',
    };

    $rootScope.settings = settings;

    return settings;
}]);

/* Init global settings and run the app */
app.run([
  "$rootScope",
  "settings",
  "$state",
  "StorageService",
  "Session",
  "EmpreendimentoService",
  function($rootScope, settings, $state, StorageService, Session, EmpreendimentoService) {
    $rootScope.$state = $state; // state to be accessed from view
    $rootScope.$settings = settings; // state to be accessed from view

    Session.user = StorageService.getJson('usuario');
    Session.token = StorageService.getJson('token');
	Session.empreendimento = StorageService.getJson('empreendimentoSel');

	if(Session.user) {
      if(Session.user.usuario_tipo.titulo === 'Portaria') {
         $rootScope.isPortaria = true;
      } else if(Session.user.usuario_tipo.titulo === 'Mensageria') {
         $rootScope.isMensageria = true;
      } else if(Session.user.usuario_tipo.titulo === 'Recepção') {
         $rootScope.isRecepcao = true;
      }
    }

	$rootScope.isUserLogged = !(Session.user === undefined || Session.user === null) && !(Session.token === undefined || Session.token === null);

    if($rootScope.isUserLogged) {
		if(StorageService.get('empreendimento') == 'null'){
			$rootScope.client_visible = true;
			$rootScope.client_hide_title = false;
		}else{
			$rootScope.client_visible = true;
			$rootScope.client_hide_title = true;
		}
    } else {
		$state.go("login");
    }

    $rootScope.$on("$stateChangeError", function(event, toState, toParams, fromState, fromParams, error) {
		console.log('error');
        if (error === "AUTH_REQUIRED") {
            $rootScope.isUserLogged = false;
            $state.go("login");
        }
    });
}]);

//metronic (4.5.7)
(function() {
    app.config([
        '$stateProvider', '$urlRouterProvider',
        function($stateProvider, $urlRouterProvider) {
        // Redirect any unmatched url
        $urlRouterProvider.otherwise("/login.html");

        $stateProvider
            // Dashboard
            .state('dashboard', {
                url: "/dashboard.html",
                templateUrl: "views/dashboard.html",
                data: {pageTitle: 'Administração'},
                controller: "DashboardController as dashboardCtrl",
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            // User Profile
            .state("profile", {
                url: "/profile",
                templateUrl: "views/profile/main.html",
                data: {pageTitle: 'User Profile'},
                controller: "UserProfileController",
                resolve: {
                    deps: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load({
                            name: 'app',
                            insertBefore: '#ng_load_plugins_before', // load the above css files before '#ng_load_plugins_before'
                            files: [
                                '../assets/global/plugins/bootstrap-fileinput/bootstrap-fileinput.css',
                                '../assets/pages/css/profile.css',

                                '../assets/global/plugins/jquery.sparkline.min.js',
                                '../assets/global/plugins/bootstrap-fileinput/bootstrap-fileinput.js',

                                '../assets/pages/scripts/profile.min.js',

                                'js/controllers/UserProfileController.js'
                            ]
                        });
                    }]
                }
            })

            // User Profile Dashboard
            .state("profile.dashboard", {
                url: "/dashboard",
                templateUrl: "views/profile/dashboard.html",
                data: {pageTitle: 'User Profile'},
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            // User Profile Account
            .state("profile.account", {
                url: "/account",
                templateUrl: "views/profile/account.html",
                data: {pageTitle: 'User Account'},
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            //CUSTOM ROUTES
            .state("empreendimento", {
                url:'/empreendimento',
                templateUrl: 'views/empreendimentos/empreendimento.html',
                data: {pageTitle: 'Empreendimentos'},
                controller: 'EmpreendimentoController as empreendimentoCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("empreendimento-cadastro", {
                url:'/empreendimento-cadastro/:id',
                templateUrl: 'views/empreendimentos/empreendimento-cadastro.html',
                data: {pageTitle: 'Cadastro de Empreendimento'},
                controller: 'EmpreendimentoCadastroController as empreendimentoCadastroCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("conjunto", {
                url:'/conjunto',
                templateUrl: 'views/conjuntos/conjunto.html',
                data: {pageTitle: 'Conjuntos'},
                controller: 'ConjuntoController as conjuntoCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("conjunto-cadastro", {
                url:'/conjunto-cadastro/:id',
                templateUrl: 'views/conjuntos/conjunto-cadastro.html',
                data: {pageTitle: 'Cadastro de Conjunto'},
                controller: 'ConjuntoCadastroController as conjuntoCadastroCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("conjunto-tipo", {
                url:'/conjunto-tipo',
                templateUrl: 'views/conjuntos/conjunto-tipo.html',
                data: {pageTitle: 'Tipos de Conjunto'},
                controller: 'ConjuntoTipoController as conjuntoTipoCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("conjunto-tipo-cadastro", {
                url:'/conjunto-tipo-cadastro/:id',
                templateUrl: 'views/conjuntos/conjunto-tipo-cadastro.html',
                data: {pageTitle: 'Cadastro de Tipo de Conjunto'},
                controller: 'ConjuntoTipoCadastroController as conjuntoTipoCadastroCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("dependencia", {
                url:'/dependencia',
                templateUrl: 'views/dependencias/dependencia.html',
                data: {pageTitle: 'Dependências'},
                controller: 'DependenciaController as dependenciaCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("dependencia-cadastro", {
                url:'/dependencia-cadastro/:id',
                templateUrl: 'views/dependencias/dependencia-cadastro.html',
                data: {pageTitle: 'Cadastro de Dependência'},
                controller: 'DependenciaCadastroController as dependenciaCadastroCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

			.state("agendamento", {
                url:'/agendamento',
                templateUrl: 'views/agendamentos/agendamento.html',
                data: {pageTitle: 'Agendamentos'},
                controller: 'AgendamentoController as agendamentoCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })
			.state("agendamento-calendario", {
                url:'/agendamento-calendario',
                templateUrl: 'views/agendamentos/agendamento-calendario.html',
                data: {pageTitle: 'Agendamentos - Calendário'},
                controller: 'AgendamentoCalendarioController as agendamentoCalendarioCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

			.state("agendamento-cadastro", {
                url:'/agendamento-cadastro/:id',
                templateUrl: 'views/agendamentos/agendamento-cadastro.html',
                data: {pageTitle: 'Cadastro de Agendamento'},
                controller: 'AgendamentoCadastroController as agendamentoCadastroCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("moradia", {
                url:'/moradia',
                templateUrl: 'views/moradias/moradia.html',
                data: {pageTitle: 'Unidades'},
                controller: 'MoradiaController as moradiaCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("moradia-cadastro", {
                url:'/moradia-cadastro/:id',
                templateUrl: 'views/moradias/moradia-cadastro.html',
                data: {pageTitle: 'Cadastro de Unidade'},
                controller: 'MoradiaCadastroController as moradiaCadastroCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("permissao", {
                url:'/permissao',
                templateUrl: 'views/permissoes/permissao.html',
                data: {pageTitle: 'Permissões'},
                controller: 'PermissaoController as permissaoCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("permissao-cadastro", {
                url:'/permissao-cadastro/:id',
                templateUrl: 'views/permissoes/permissao-cadastro.html',
                data: {pageTitle: 'Cadastro de permissao'},
                controller: 'PermissaoCadastroController as permissaoCadastroCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("frase", {
                url:'/frase',
                templateUrl: 'views/frases/frase.html',
                data: {pageTitle: 'Frases'},
                controller: 'FraseController as fraseCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("frase-cadastro", {
                url:'/frase-cadastro/:id',
                templateUrl: 'views/frases/frase-cadastro.html',
                data: {pageTitle: 'Cadastro de Frase'},
                controller: 'FraseCadastroController as fraseCadastroCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("usuario-tipo", {
                url:'/usuario-tipo',
                templateUrl: 'views/usuarios/usuario-tipo.html',
                data: {pageTitle: 'Tipos de Usuário'},
                controller: 'UsuarioTipoController as usuarioTipoCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("usuario-tipo-cadastro", {
                url:'/usuario-tipo-cadastro/:id',
                templateUrl: 'views/usuarios/usuario-tipo-cadastro.html',
                data: {pageTitle: 'Cadastro de Tipo de Usuário'},
                controller: 'UsuarioTipoCadastroController as usuarioTipoCadastroCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("usuario", {
                url:'/usuario',
                templateUrl: 'views/usuarios/usuario.html',
                data: {pageTitle: 'Usuários'},
                controller: 'UsuarioController as usuarioCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("usuario-cadastro", {
                url:'/usuario-cadastro/:id',
                templateUrl: 'views/usuarios/usuario-cadastro.html',
                data: {pageTitle: 'Cadastro de Usuário'},
                controller: 'UsuarioCadastroController as usuarioCadastroCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("usuario-view", {
                url:'/usuario-view/:id',
                templateUrl: 'views/usuarios/usuario-view.html',
                data: {pageTitle: 'Visualização de Usuário'},
                controller: 'UsuarioViewController as usuarioViewCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("post", {
                url:'/post',
                templateUrl: 'views/posts/post.html',
                data: {pageTitle: 'Postagem'},
                controller: 'PostController as postCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("post-cadastro", {
                url:'/post-cadastro/:id',
                templateUrl: 'views/posts/post-cadastro.html',
                data: {pageTitle: 'Cadastro de Post'},
                controller: 'PostCadastroController as postCadastroCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("post-view", {
                url:'/post-view/:id',
                templateUrl: 'views/posts/post-view.html',
                data: {pageTitle: 'Visualização de Post'},
                controller: 'PostViewController as postViewCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("post-tipo", {
                url:'/post-tipo',
                templateUrl: 'views/posts/post-tipo.html',
                data: {pageTitle: 'Tipo de Post'},
                controller: 'PostTipoController as postTipoCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("post-tipo-cadastro", {
                url:'/post-tipo-cadastro/:id',
                templateUrl: 'views/posts/post-tipo-cadastro.html',
                data: {pageTitle: 'Cadastro de Tipo de Post'},
                controller: 'PostTipoCadastroController as postTipoCadastroCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("chamado-tipo", {
                url:'/chamado-tipo',
                templateUrl: 'views/chamados/chamado-tipo.html',
                data: {pageTitle: 'Tipos de Chamados'},
                controller: 'ChamadoTipoController as chamadoTipoCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("chamado-tipo-cadastro", {
                url:'/chamado-tipo-cadastro/:id',
                templateUrl: 'views/chamados/chamado-tipo-cadastro.html',
                data: {pageTitle: 'Cadastro de Tipo de Chamado'},
                controller: 'ChamadoTipoCadastroController as chamadoTipoCadastroCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("chamado-assunto", {
                url:'/chamado-assunto',
                templateUrl: 'views/chamados/chamado-assunto.html',
                data: {pageTitle: 'Assuntos de Chamados'},
                controller: 'ChamadoAssuntoController as chamadoAssuntoCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("chamado-assunto-cadastro", {
                url:'/chamado-assunto-cadastro/:id',
                templateUrl: 'views/chamados/chamado-assunto-cadastro.html',
                data: {pageTitle: 'Cadastro de Assunto de Chamado'},
                controller: 'ChamadoAssuntoCadastroController as chamadoAssuntoCadastroCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("chamados-em-aberto", {
                url:'/chamados-em-aberto/:id',
                templateUrl: 'views/chamados/chamados-em-aberto.html',
                data: {pageTitle: 'Chamados'},
                controller: 'ChamadosEmAbertoController as chamadosEmAbertoCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("chamado", {
                url:'/chamado/:id',
                templateUrl: 'views/chamados/chamado.html',
                data: {pageTitle: 'Chamado'},
                controller: 'ChamadoController as chamadoCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("telefones-uteis", {
                url:'/telefones-uteis',
                templateUrl: 'views/telefones_uteis/telefones-uteis.html',
                data: {pageTitle: 'Telefones Úteis'},
                controller: 'TelefoneUtilController as telefoneUtilCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("telefones-uteis-cadastro", {
                url:'/telefones-uteis-cadastro/:id',
                templateUrl: 'views/telefones_uteis/telefones-uteis-cadastro.html',
                data: {pageTitle: 'Cadastro de Telefone Útil'},
                controller: 'TelefoneUtilCadastroController as telefoneUtilCadastroCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("destaques", {
                url:'/destaques',
                templateUrl: 'views/posts/destaques/destaques.html',
                data: {pageTitle: 'Destaques'},
                controller: 'DestaquesController as destaquesCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("informacao", {
                url:'/informacao',
                templateUrl: 'views/posts/informacoes/informacao.html',
                data: {pageTitle: 'Informações'},
                controller: 'InformacaoController as informacaoCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("informacao-cadastro", {
                url:'/informacao-cadastro/:id',
                templateUrl: 'views/posts/informacoes/informacao-cadastro.html',
                data: {pageTitle: 'Cadastro de Informação'},
                controller: 'InformacaoCadastroController as informacaoCadastroCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("transparencia", {
                url:'/transparencia',
                templateUrl: 'views/posts/transparencia/transparencia.html',
                data: {pageTitle: 'Transparência'},
                controller: 'TransparenciaController as transparenciaCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("transparencia-cadastro", {
                url:'/transparencia-cadastro/:id',
                templateUrl: 'views/posts/transparencia/transparencia-cadastro.html',
                data: {pageTitle: 'Cadastro de Transparência'},
                controller: 'TransparenciaCadastroController as transparenciaCadastroCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })
            .state("documento-nao-auditado", {
              url:'/documento-nao-auditado',
              templateUrl: 'views/posts/documento_nao_auditado/documento_nao_auditado.html',
              data: {pageTitle: 'Documentos não auditados'},
              controller: 'DocumentoNaoAuditadoController as DocumentoNaoAuditadoCtrl',
              resolve: {
                  "currentAuth": [
                      "AuthService",
                      function (AuthService) {
                          return AuthService.requireSignIn();
                      }
                  ]
              }
          })

          .state("documento-nao-auditado-cadastro", {
              url:'/documento-nao-auditado-cadastro/:id',
              templateUrl: 'views/posts/documento_nao_auditado/documento_nao_auditado-cadastro.html',
              data: {pageTitle: 'Cadastro do documento não auditado'},
              controller: 'DocumentoNaoAuditadoCadastroController as DocumentoNaoAuditadoCadastroCtrl',
              resolve: {
                  "currentAuth": [
                      "AuthService",
                      function (AuthService) {
                          return AuthService.requireSignIn();
                      }
                  ]
              }
          })
            .state("evento", {
                url:'/evento',
                templateUrl: 'views/posts/eventos/evento.html',
                data: {pageTitle: 'Eventos'},
                controller: 'EventoController as eventoCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("evento-cadastro", {
                url:'/evento-cadastro/:id',
                templateUrl: 'views/posts/eventos/evento-cadastro.html',
                data: {pageTitle: 'Cadastro de Evento'},
                controller: 'EventoCadastroController as eventoCadastroCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("forum", {
                url:'/forum',
                templateUrl: 'views/posts/forum/forum.html',
                data: {pageTitle: 'Forum'},
                controller: 'ForumController as forumCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("forum-cadastro", {
                url:'/forum-cadastro/:id',
                templateUrl: 'views/posts/forum/forum-cadastro.html',
                data: {pageTitle: 'Cadastro de Post'},
                controller: 'ForumCadastroController as forumCadastroCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("classificado", {
                url:'/classificado',
                templateUrl: 'views/posts/classificados/classificado.html',
                data: {pageTitle: 'Classificados'},
                controller: 'ClassificadoController as classificadoCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("classificado-cadastro", {
                url:'/classificado-cadastro/:id',
                templateUrl: 'views/posts/classificados/classificado-cadastro.html',
                data: {pageTitle: 'Cadastro de Classificado'},
                controller: 'ClassificadoCadastroController as classificadoCadastroCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("visitante", {
                url:'/visitantes',
                templateUrl: 'views/visitantes/visitante.html',
                data: {pageTitle: 'Visitantes'},
                controller: 'VisitanteController as visitanteCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })
            .state("meu-visitante", {
                url:'/meu-visitante',
                templateUrl: 'views/visitantes/meu-visitante.html',
                data: {pageTitle: 'Meus Visitantes'},
                controller: 'MeusVisitantesController as meusVisitantesCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("visitante-lista", {
                url:'/visitantes-lista',
                templateUrl: 'views/visitantes/visitante-lista.html',
                data: {pageTitle: 'Visitantes'},
                controller: 'VisitanteListaController as visitanteListaCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("listas", {
                url:'/listas',
                templateUrl: 'views/visitantes/listas.html',
                data: {pageTitle: 'Listas'},
                controller: 'ListasController as listaCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("visitante-autorizado", {
                url:'/visitantes-autorizados',
                templateUrl: 'views/visitantes/visitante-autorizado.html',
                data: {pageTitle: 'Visitantes Autorizados'},
                controller: 'VisitanteAutorizadoController as visitanteAutorizadoCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

			.state("visitante-relatorio", {
                url:'/visitante-relatorio',
                templateUrl: 'views/visitantes/visitante-relatorio.html',
                data: {pageTitle: 'Visitantes Relatório'},
                controller: 'VisitanteRelatorioController as visitanteRelatorioCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })
            .state("visitante-estatistica", {
              url:'/visitante-estatistica',
              templateUrl: 'views/visitantes/visitante-estatistica.html',
              data: {pageTitle: 'Visitantes Estatística'},
              controller: 'VisitanteEstatisticaController as visitanteEstatisticaCtrl',
              resolve: {
                  "currentAuth": [
                      "AuthService",
                      function (AuthService) {
                          return AuthService.requireSignIn();
                      }
                  ]
              }
          })

            .state("visitante-cadastro", {
                url:'/visitante-cadastro/:id',
                templateUrl: 'views/visitantes/visitante-cadastro.html',
                data: {pageTitle: 'Cadastro de Visitantes'},
                controller: 'VisitanteCadastroController as visitanteCadastroCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("visitante-lista-cadastro", {
                url:'/visitante-lista-cadastro/:id',
                templateUrl: 'views/visitantes/visitante-lista-cadastro.html',
                data: {pageTitle: 'Cadastro de Visitantes'},
                controller: 'VisitanteListaCadastroController as visitanteListaCadastroCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("prestador", {
                url:'/prestador',
                templateUrl: 'views/prestadores/prestador.html',
                data: {pageTitle: 'Prestador de Serviço'},
                controller: 'PrestadorController as prestadorCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

			.state("prestador-todos", {
                url:'/prestador-todos',
                templateUrl: 'views/prestadores/prestador-todos.html',
                data: {pageTitle: 'Prestador de Serviço - Todos'},
                controller: 'PrestadorTodosController as prestadorTodosCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("prestador-cadastro", {
                url:'/prestador-cadastro/:id',
                templateUrl: 'views/prestadores/prestador-cadastro.html',
                data: {pageTitle: 'Cadastro de Prestador de Serviço'},
                controller: 'PrestadorCadastroController as prestadorCadastroCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("notificacoes", {
                url:'/notificacoes',
                templateUrl: 'views/notificacoes/notificacoes.html',
                data: {pageTitle: 'Notificações'},
                controller: 'NotificacoesController as notificacoesCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("notificacoes-usuario-cadastro", {
                url:'/notificacoes-usuario-cadastro',
                templateUrl: 'views/notificacoes/notificacao-usuario-cadastro.html',
                data: {pageTitle: 'Nova Notificação'},
                controller: 'NotificacaoCadastroUsuarioController as notificacoesUsuarioCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("notificacoes-mensageria-cadastro", {
                url:'/notificacoes-mensageria-cadastro',
                templateUrl: 'views/notificacoes/notificacao-mensageria-cadastro.html',
                data: {pageTitle: 'Nova Notificação'},
                controller: 'NotificacaoCadastroMensageriaController as mensageriaCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state("notificacoes-conjunto-cadastro", {
                url:'/notificacoes-conjunto-cadastro',
                templateUrl: 'views/notificacoes/notificacao-conjunto-cadastro.html',
                data: {pageTitle: 'Nova Notificação'},
                controller: 'NotificacaoCadastroConjuntoController as notificacoesConjuntoCtrl',
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })

            .state('login', {
                url: "/login.html",
                templateUrl: "views/public/login.html",
                data: {pageTitle: 'Login'},
                controller: "LoginController as loginCtrl"
            })

            .state('recuperar-senha', {
                url: "/recuperar-senha.html",
                templateUrl: "views/public/recuperar-senha.html",
                data: {pageTitle: 'Recuperar Senha'},
                controller: "RecuperarSenhaController as recuperarSenhaCtrl"
            })

            .state('perfil', {
                url: "/perfil.html",
                templateUrl: "views/user/profile.html",
                data: {pageTitle: 'Meu Perfil'},
                controller: "ProfileController as profileCtrl",
                resolve: {
                    "currentAuth": [
                        "AuthService",
                        function (AuthService) {
                            return AuthService.requireSignIn();
                        }
                    ]
                }
            })
            .state('relatorio-acesso', {
              url: "/relatorio-acesso.html",
              templateUrl: "views/relatorio_acesso/relatorio-acesso.html",
              data: {pageTitle: 'Relatório de acesso'},
              controller: "RelatorioAcessoController as RelatorioAcessoCtrl",
              resolve: {
                  "currentAuth": [
                      "AuthService",
                      function (AuthService) {
                          return AuthService.requireSignIn();
                      }
                  ]
              }
          })
            .state('configuracao', {
              url: "/configuracao.html",
              templateUrl: "views/configuracao/configuracao.html",
              data: {pageTitle: 'Configuração'},
              controller: "ConfiguracaoController as configuracaoCtrl",
              resolve: {
                  "currentAuth": [
                      "AuthService",
                      function (AuthService) {
                          return AuthService.requireSignIn();
                      }
                  ]
              }
          })
    }]);
})();

//metronic (4.5.7)
/***
GLobal Directives
***/

// Route State Load Spinner(used on page or content load)
app.directive('ngSpinnerBar', ['$rootScope', '$state',
    function($rootScope, $state) {
        return {
            link: function(scope, element, attrs) {
                // by defult hide the spinner bar
                element.addClass('hide'); // hide spinner bar by default

                $rootScope.$on('ajaxStartLoad', function() {
                    element.removeClass('hide');
                });

                $rootScope.$on('ajaxFinishLoad', function() {
                    element.addClass('hide');
                });

                // display the spinner bar whenever the route changes(the content part started loading)
                $rootScope.$on('$stateChangeStart', function() {
                    element.removeClass('hide'); // show spinner bar
                });

                // hide the spinner bar on rounte change success(after the content loaded)
                $rootScope.$on('$stateChangeSuccess', function(event) {
                    element.addClass('hide'); // hide spinner bar
                    $('body').removeClass('page-on-load'); // remove page loading indicator
                    Layout.setAngularJsSidebarMenuActiveLink('match', null, event.currentScope.$state); // activate selected link in the sidebar menu

                    // auto scorll to page top
                    setTimeout(function () {
                        App.scrollTop(); // scroll to the top on content load
                    }, $rootScope.settings.layout.pageAutoScrollOnLoad);
                });

                // handle errors
                $rootScope.$on('$stateNotFound', function() {
                    element.addClass('hide'); // hide spinner bar
                });

                // handle errors
                $rootScope.$on('$stateChangeError', function() {
                    element.addClass('hide'); // hide spinner bar
                });
            }
        };
    }
])

// Handle global LINK click
app.directive('a', function() {
    return {
        restrict: 'E',
        link: function(scope, elem, attrs) {
            if (attrs.ngClick || attrs.href === '' || attrs.href === '#') {
                elem.on('click', function(e) {
                    e.preventDefault(); // prevent link click for above criteria
                });
            }
        }
    };
});

// Handle Dropdown Hover Plugin Integration
app.directive('dropdownMenuHover', function () {
  return {
    link: function (scope, elem) {
      elem.dropdownHover();
    }
  };
});

//FileUpload
app.directive('fileModel', [
    '$parse',
    '$rootScope',
    'MidiaService',
    'Session',
    '$http',
    function ($parse, $rootScope, MidiaService, Session, $http) {
    return {
       restrict: 'A',
       require: '?ngModel',
       link: function(scope, element, attrs, ngModel) {
          var model = $parse(attrs.fileModel);
          var modelSetter = model.assign;
          var dataset = element.context.dataset;

          element.bind('change', function(event){
             scope.$apply(function(){
                var fd = new FormData();

                if(element[0].files.length === 0)
                    return;

                angular.forEach(element[0].files, (element) => {
                    fd.append('file[]', element);
                });
                fd.append('timestamp', $rootScope.timestamp);
                fd.append('usuario_id', Session.user.id);
                fd.append('type', dataset.type);

                $rootScope.$broadcast('ajaxStartLoad');

                $http.post(api + 'midia', fd, {
                    transformRequest: angular.identity,
                    headers: {
                        'Content-Type': undefined,
                        'Authorization': 'Bearer ' + Session.token
                    }
                })
                .success(response => {
                    $rootScope.$broadcast('ajaxFinishLoad');
                    var modelValue = ngModel.$modelValue;

                    if(angular.isArray(modelValue)) {
                        response.midias.forEach(element => modelValue.push(element));
                    } else {
                        modelValue = response.midias[0];
                    }

                    ngModel.$setViewValue(modelValue);
                }).error(error => console.log(error));
             });
          });
       }
    };
}]);

//Detecta fim de ng-repeat
app.directive('onFinishRender',['$timeout', '$parse', function ($timeout, $parse) {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            if (scope.$last === true) {
                $timeout(function () {
                    scope.$emit('ngRepeatFinished');
                    if(!!attr.onFinishRender){
                      $parse(attr.onFinishRender)(scope);
                    }
                });
            }
        }
    }
}]);

//Filter trust html
app.filter('trusted', ['$sce', function($sce){
    return function(html){
        return $sce.trustAsHtml(html)
    }
}]);

//metronic (4.5.7)
var App=function(){var t,e=!1,o=!1,a=!1,i=!1,n=[],l="../assets/",s="global/img/",r="global/plugins/",c="global/css/",d={blue:"#89C4F4",red:"#F3565D",green:"#1bbc9b",purple:"#9b59b6",grey:"#95a5a6",yellow:"#F8CB00"},p=function(){"rtl"===$("body").css("direction")&&(e=!0),o=!!navigator.userAgent.match(/MSIE 8.0/),a=!!navigator.userAgent.match(/MSIE 9.0/),i=!!navigator.userAgent.match(/MSIE 10.0/),i&&$("html").addClass("ie10"),(i||a||o)&&$("html").addClass("ie")},h=function(){for(var t=0;t<n.length;t++){var e=n[t];e.call()}},u=function(){var t,e=$(window).width();if(o){var a;$(window).resize(function(){a!=document.documentElement.clientHeight&&(t&&clearTimeout(t),t=setTimeout(function(){h()},50),a=document.documentElement.clientHeight)})}else $(window).resize(function(){$(window).width()!=e&&(e=$(window).width(),t&&clearTimeout(t),t=setTimeout(function(){h()},50))})},f=function(){$("body").on("click",".portlet > .portlet-title > .tools > a.remove",function(t){t.preventDefault();var e=$(this).closest(".portlet");$("body").hasClass("page-portlet-fullscreen")&&$("body").removeClass("page-portlet-fullscreen"),e.find(".portlet-title .fullscreen").tooltip("destroy"),e.find(".portlet-title > .tools > .reload").tooltip("destroy"),e.find(".portlet-title > .tools > .remove").tooltip("destroy"),e.find(".portlet-title > .tools > .config").tooltip("destroy"),e.find(".portlet-title > .tools > .collapse, .portlet > .portlet-title > .tools > .expand").tooltip("destroy"),e.remove()}),$("body").on("click",".portlet > .portlet-title .fullscreen",function(t){t.preventDefault();var e=$(this).closest(".portlet");if(e.hasClass("portlet-fullscreen"))$(this).removeClass("on"),e.removeClass("portlet-fullscreen"),$("body").removeClass("page-portlet-fullscreen"),e.children(".portlet-body").css("height","auto");else{var o=App.getViewPort().height-e.children(".portlet-title").outerHeight()-parseInt(e.children(".portlet-body").css("padding-top"))-parseInt(e.children(".portlet-body").css("padding-bottom"));$(this).addClass("on"),e.addClass("portlet-fullscreen"),$("body").addClass("page-portlet-fullscreen"),e.children(".portlet-body").css("height",o)}}),$("body").on("click",".portlet > .portlet-title > .tools > a.reload",function(t){t.preventDefault();var e=$(this).closest(".portlet").children(".portlet-body"),o=$(this).attr("data-url"),a=$(this).attr("data-error-display");o?(App.blockUI({target:e,animate:!0,overlayColor:"none"}),$.ajax({type:"GET",cache:!1,url:o,dataType:"html",success:function(t){App.unblockUI(e),e.html(t),App.initAjax()},error:function(t,o,i){App.unblockUI(e);var n="Error on reloading the content. Please check your connection and try again.";"toastr"==a&&toastr?toastr.error(n):"notific8"==a&&$.notific8?($.notific8("zindex",11500),$.notific8(n,{theme:"ruby",life:3e3})):alert(n)}})):(App.blockUI({target:e,animate:!0,overlayColor:"none"}),window.setTimeout(function(){App.unblockUI(e)},1e3))}),$('.portlet .portlet-title a.reload[data-load="true"]').click(),$("body").on("click",".portlet > .portlet-title > .tools > .collapse, .portlet .portlet-title > .tools > .expand",function(t){t.preventDefault();var e=$(this).closest(".portlet").children(".portlet-body");$(this).hasClass("collapse")?($(this).removeClass("collapse").addClass("expand"),e.slideUp(200)):($(this).removeClass("expand").addClass("collapse"),e.slideDown(200))})},b=function(){if($("body").on("click",".md-checkbox > label, .md-radio > label",function(){var t=$(this),e=$(this).children("span:first-child");e.addClass("inc");var o=e.clone(!0);e.before(o),$("."+e.attr("class")+":last",t).remove()}),$("body").hasClass("page-md")){var t,e,o,a,i;$("body").on("click","a.btn, button.btn, input.btn, label.btn",function(n){t=$(this),0==t.find(".md-click-circle").length&&t.prepend("<span class='md-click-circle'></span>"),e=t.find(".md-click-circle"),e.removeClass("md-click-animate"),e.height()||e.width()||(o=Math.max(t.outerWidth(),t.outerHeight()),e.css({height:o,width:o})),a=n.pageX-t.offset().left-e.width()/2,i=n.pageY-t.offset().top-e.height()/2,e.css({top:i+"px",left:a+"px"}).addClass("md-click-animate"),setTimeout(function(){e.remove()},1e3)})}var n=function(t){""!=t.val()?t.addClass("edited"):t.removeClass("edited")};$("body").on("keydown",".form-md-floating-label .form-control",function(t){n($(this))}),$("body").on("blur",".form-md-floating-label .form-control",function(t){n($(this))}),$(".form-md-floating-label .form-control").each(function(){$(this).val().length>0&&$(this).addClass("edited")})},g=function(){$().iCheck&&$(".icheck").each(function(){var t=$(this).attr("data-checkbox")?$(this).attr("data-checkbox"):"icheckbox_minimal-grey",e=$(this).attr("data-radio")?$(this).attr("data-radio"):"iradio_minimal-grey";t.indexOf("_line")>-1||e.indexOf("_line")>-1?$(this).iCheck({checkboxClass:t,radioClass:e,insert:'<div class="icheck_line-icon"></div>'+$(this).attr("data-label")}):$(this).iCheck({checkboxClass:t,radioClass:e})})},m=function(){$().bootstrapSwitch&&$(".make-switch").bootstrapSwitch()},v=function(){$().confirmation&&$("[data-toggle=confirmation]").confirmation({btnOkClass:"btn btn-sm btn-success",btnCancelClass:"btn btn-sm btn-danger"})},y=function(){$("body").on("shown.bs.collapse",".accordion.scrollable",function(t){App.scrollTo($(t.target))})},C=function(){if(encodeURI(location.hash)){var t=encodeURI(location.hash.substr(1));$('a[href="#'+t+'"]').parents(".tab-pane:hidden").each(function(){var t=$(this).attr("id");$('a[href="#'+t+'"]').click()}),$('a[href="#'+t+'"]').click()}$().tabdrop&&$(".tabbable-tabdrop .nav-pills, .tabbable-tabdrop .nav-tabs").tabdrop({text:'<i class="fa fa-ellipsis-v"></i>&nbsp;<i class="fa fa-angle-down"></i>'})},w=function(){$("body").on("hide.bs.modal",function(){$(".modal:visible").size()>1&&$("html").hasClass("modal-open")===!1?$("html").addClass("modal-open"):$(".modal:visible").size()<=1&&$("html").removeClass("modal-open")}),$("body").on("show.bs.modal",".modal",function(){$(this).hasClass("modal-scroll")&&$("body").addClass("modal-open-noscroll")}),$("body").on("hidden.bs.modal",".modal",function(){$("body").removeClass("modal-open-noscroll")}),$("body").on("hidden.bs.modal",".modal:not(.modal-cached)",function(){$(this).removeData("bs.modal")})},x=function(){$(".tooltips").tooltip(),$(".portlet > .portlet-title .fullscreen").tooltip({trigger:"hover",container:"body",title:"Fullscreen"}),$(".portlet > .portlet-title > .tools > .reload").tooltip({trigger:"hover",container:"body",title:"Reload"}),$(".portlet > .portlet-title > .tools > .remove").tooltip({trigger:"hover",container:"body",title:"Remove"}),$(".portlet > .portlet-title > .tools > .config").tooltip({trigger:"hover",container:"body",title:"Settings"}),$(".portlet > .portlet-title > .tools > .collapse, .portlet > .portlet-title > .tools > .expand").tooltip({trigger:"hover",container:"body",title:"Collapse/Expand"})},k=function(){$("body").on("click",".dropdown-menu.hold-on-click",function(t){t.stopPropagation()})},I=function(){$("body").on("click",'[data-close="alert"]',function(t){$(this).parent(".alert").hide(),$(this).closest(".note").hide(),t.preventDefault()}),$("body").on("click",'[data-close="note"]',function(t){$(this).closest(".note").hide(),t.preventDefault()}),$("body").on("click",'[data-remove="note"]',function(t){$(this).closest(".note").remove(),t.preventDefault()})},A=function(){"function"==typeof autosize&&autosize(document.querySelectorAll("textarea.autosizeme"))},S=function(){$(".popovers").popover(),$(document).on("click.bs.popover.data-api",function(e){t&&t.popover("hide")})},z=function(){App.initSlimScroll(".scroller")},P=function(){jQuery.fancybox&&$(".fancybox-button").size()>0&&$(".fancybox-button").fancybox({groupAttr:"data-rel",prevEffect:"none",nextEffect:"none",closeBtn:!0,helpers:{title:{type:"inside"}}})},T=function(){$().counterUp&&$("[data-counter='counterup']").counterUp({delay:10,time:1e3})},D=function(){(o||a)&&$("input[placeholder]:not(.placeholder-no-fix), textarea[placeholder]:not(.placeholder-no-fix)").each(function(){var t=$(this);""===t.val()&&""!==t.attr("placeholder")&&t.addClass("placeholder").val(t.attr("placeholder")),t.focus(function(){t.val()==t.attr("placeholder")&&t.val("")}),t.blur(function(){""!==t.val()&&t.val()!=t.attr("placeholder")||t.val(t.attr("placeholder"))})})},U=function(){$().select2&&($.fn.select2.defaults.set("theme","bootstrap"),$(".select2me").select2({placeholder:"Select",width:"auto",allowClear:!0}))},E=function(){$("[data-auto-height]").each(function(){var t=$(this),e=$("[data-height]",t),o=0,a=t.attr("data-mode"),i=parseInt(t.attr("data-offset")?t.attr("data-offset"):0);e.each(function(){"height"==$(this).attr("data-height")?$(this).css("height",""):$(this).css("min-height","");var t="base-height"==a?$(this).outerHeight():$(this).outerHeight(!0);t>o&&(o=t)}),o+=i,e.each(function(){"height"==$(this).attr("data-height")?$(this).css("height",o):$(this).css("min-height",o)}),t.attr("data-related")&&$(t.attr("data-related")).css("height",t.height())})};return{init:function(){p(),u(),b(),g(),m(),z(),P(),U(),f(),I(),k(),C(),x(),S(),y(),w(),v(),A(),T(),this.addResizeHandler(E),D()},initAjax:function(){g(),m(),z(),U(),P(),k(),x(),S(),y(),v()},initComponents:function(){this.initAjax()},setLastPopedPopover:function(e){t=e},addResizeHandler:function(t){n.push(t)},runResizeHandlers:function(){h()},scrollTo:function(t,e){var o=t&&t.size()>0?t.offset().top:0;t&&($("body").hasClass("page-header-fixed")?o-=$(".page-header").height():$("body").hasClass("page-header-top-fixed")?o-=$(".page-header-top").height():$("body").hasClass("page-header-menu-fixed")&&(o-=$(".page-header-menu").height()),o+=e?e:-1*t.height()),$("html,body").animate({scrollTop:o},"slow")},initSlimScroll:function(t){$().slimScroll&&$(t).each(function(){if(!$(this).attr("data-initialized")){var t;t=$(this).attr("data-height")?$(this).attr("data-height"):$(this).css("height"),$(this).slimScroll({allowPageScroll:!0,size:"7px",color:$(this).attr("data-handle-color")?$(this).attr("data-handle-color"):"#bbb",wrapperClass:$(this).attr("data-wrapper-class")?$(this).attr("data-wrapper-class"):"slimScrollDiv",railColor:$(this).attr("data-rail-color")?$(this).attr("data-rail-color"):"#eaeaea",position:e?"left":"right",height:t,alwaysVisible:"1"==$(this).attr("data-always-visible"),railVisible:"1"==$(this).attr("data-rail-visible"),disableFadeOut:!0}),$(this).attr("data-initialized","1")}})},destroySlimScroll:function(t){$().slimScroll&&$(t).each(function(){if("1"===$(this).attr("data-initialized")){$(this).removeAttr("data-initialized"),$(this).removeAttr("style");var t={};$(this).attr("data-handle-color")&&(t["data-handle-color"]=$(this).attr("data-handle-color")),$(this).attr("data-wrapper-class")&&(t["data-wrapper-class"]=$(this).attr("data-wrapper-class")),$(this).attr("data-rail-color")&&(t["data-rail-color"]=$(this).attr("data-rail-color")),$(this).attr("data-always-visible")&&(t["data-always-visible"]=$(this).attr("data-always-visible")),$(this).attr("data-rail-visible")&&(t["data-rail-visible"]=$(this).attr("data-rail-visible")),$(this).slimScroll({wrapperClass:$(this).attr("data-wrapper-class")?$(this).attr("data-wrapper-class"):"slimScrollDiv",destroy:!0});var e=$(this);$.each(t,function(t,o){e.attr(t,o)})}})},scrollTop:function(){App.scrollTo()},blockUI:function(t){t=$.extend(!0,{},t);var e="";if(e=t.animate?'<div class="loading-message '+(t.boxed?"loading-message-boxed":"")+'"><div class="block-spinner-bar"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div></div>':t.iconOnly?'<div class="loading-message '+(t.boxed?"loading-message-boxed":"")+'"><img src="'+this.getGlobalImgPath()+'loading-spinner-grey.gif" align=""></div>':t.textOnly?'<div class="loading-message '+(t.boxed?"loading-message-boxed":"")+'"><span>&nbsp;&nbsp;'+(t.message?t.message:"LOADING...")+"</span></div>":'<div class="loading-message '+(t.boxed?"loading-message-boxed":"")+'"><img src="'+this.getGlobalImgPath()+'loading-spinner-grey.gif" align=""><span>&nbsp;&nbsp;'+(t.message?t.message:"LOADING...")+"</span></div>",t.target){var o=$(t.target);o.height()<=$(window).height()&&(t.cenrerY=!0),o.block({message:e,baseZ:t.zIndex?t.zIndex:1e3,centerY:void 0!==t.cenrerY?t.cenrerY:!1,css:{top:"10%",border:"0",padding:"0",backgroundColor:"none"},overlayCSS:{backgroundColor:t.overlayColor?t.overlayColor:"#555",opacity:t.boxed?.05:.1,cursor:"wait"}})}else $.blockUI({message:e,baseZ:t.zIndex?t.zIndex:1e3,css:{border:"0",padding:"0",backgroundColor:"none"},overlayCSS:{backgroundColor:t.overlayColor?t.overlayColor:"#555",opacity:t.boxed?.05:.1,cursor:"wait"}})},unblockUI:function(t){t?$(t).unblock({onUnblock:function(){$(t).css("position",""),$(t).css("zoom","")}}):$.unblockUI()},startPageLoading:function(t){t&&t.animate?($(".page-spinner-bar").remove(),$("body").append('<div class="page-spinner-bar"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>')):($(".page-loading").remove(),$("body").append('<div class="page-loading"><img src="'+this.getGlobalImgPath()+'loading-spinner-grey.gif"/>&nbsp;&nbsp;<span>'+(t&&t.message?t.message:"Loading...")+"</span></div>"))},stopPageLoading:function(){$(".page-loading, .page-spinner-bar").remove()},alert:function(t){t=$.extend(!0,{container:"",place:"append",type:"success",message:"",close:!0,reset:!0,focus:!0,closeInSeconds:0,icon:""},t);var e=App.getUniqueID("App_alert"),o='<div id="'+e+'" class="custom-alerts alert alert-'+t.type+' fade in">'+(t.close?'<button type="button" class="close" data-dismiss="alert" aria-hidden="true"></button>':"")+(""!==t.icon?'<i class="fa-lg fa fa-'+t.icon+'"></i>  ':"")+t.message+"</div>";return t.reset&&$(".custom-alerts").remove(),t.container?"append"==t.place?$(t.container).append(o):$(t.container).prepend(o):1===$(".page-fixed-main-content").size()?$(".page-fixed-main-content").prepend(o):($("body").hasClass("page-container-bg-solid")||$("body").hasClass("page-content-white"))&&0===$(".page-head").size()?$(".page-title").after(o):$(".page-bar").size()>0?$(".page-bar").after(o):$(".page-breadcrumb, .breadcrumbs").after(o),t.focus&&App.scrollTo($("#"+e)),t.closeInSeconds>0&&setTimeout(function(){$("#"+e).remove()},1e3*t.closeInSeconds),e},initFancybox:function(){P()},getActualVal:function(t){return t=$(t),t.val()===t.attr("placeholder")?"":t.val()},getURLParameter:function(t){var e,o,a=window.location.search.substring(1),i=a.split("&");for(e=0;e<i.length;e++)if(o=i[e].split("="),o[0]==t)return unescape(o[1]);return null},isTouchDevice:function(){try{return document.createEvent("TouchEvent"),!0}catch(t){return!1}},getViewPort:function(){var t=window,e="inner";return"innerWidth"in window||(e="client",t=document.documentElement||document.body),{width:t[e+"Width"],height:t[e+"Height"]}},getUniqueID:function(t){return"prefix_"+Math.floor(Math.random()*(new Date).getTime())},isIE8:function(){return o},isIE9:function(){return a},isRTL:function(){return e},isAngularJsApp:function(){return"undefined"!=typeof angular},getAssetsPath:function(){return l},setAssetsPath:function(t){l=t},setGlobalImgPath:function(t){s=t},getGlobalImgPath:function(){return l+s},setGlobalPluginsPath:function(t){r=t},getGlobalPluginsPath:function(){return l+r},getGlobalCssPath:function(){return l+c},getBrandColor:function(t){return d[t]?d[t]:""},getResponsiveBreakpoint:function(t){var e={xs:480,sm:768,md:992,lg:1200};return e[t]?e[t]:0}}}();jQuery(document).ready(function(){App.init()});
//metronic (4.5.7)
var Layout=function(){var e="layouts/layout/img/",a="layouts/layout/css/",t=App.getResponsiveBreakpoint("md"),i=[],s=[],o=function(){var e,a=$(".page-content"),i=$(".page-sidebar"),s=$("body");if(s.hasClass("page-footer-fixed")===!0&&s.hasClass("page-sidebar-fixed")===!1){var o=App.getViewPort().height-$(".page-footer").outerHeight()-$(".page-header").outerHeight(),n=i.outerHeight();n>o&&(o=n+$(".page-footer").outerHeight()),a.height()<o&&a.css("min-height",o)}else{if(s.hasClass("page-sidebar-fixed"))e=l(),s.hasClass("page-footer-fixed")===!1&&(e-=$(".page-footer").outerHeight());else{var r=$(".page-header").outerHeight(),d=$(".page-footer").outerHeight();e=App.getViewPort().width<t?App.getViewPort().height-r-d:i.height()+20,e+r+d<=App.getViewPort().height&&(e=App.getViewPort().height-r-d)}a.css("min-height",e)}},n=function(e,a,i){var s=location.hash.toLowerCase(),o=$(".page-sidebar-menu");if("click"===e||"set"===e?a=$(a):"match"===e&&o.find("li > a").each(function(){var e=$(this).attr("ui-sref");if(i&&e){if(i.is(e))return void(a=$(this))}else{var t=$(this).attr("href");if(t&&(t=t.toLowerCase(),t.length>1&&s.substr(1,t.length-1)==t.substr(1)))return void(a=$(this))}}),a&&0!=a.size()&&"javascript:;"!=a.attr("href")&&"javascript:;"!=a.attr("ui-sref")&&"#"!=a.attr("href")&&"#"!=a.attr("ui-sref")){parseInt(o.data("slide-speed")),o.data("keep-expanded");o.hasClass("page-sidebar-menu-hover-submenu")===!1?o.find("li.nav-item.open").each(function(){var e=!1;$(this).find("li").each(function(){var t=$(this).attr("ui-sref");if(i&&t){if(i.is(t))return void(e=!0)}else if($(this).find(" > a").attr("href")===a.attr("href"))return void(e=!0)}),e!==!0&&($(this).removeClass("open"),$(this).find("> a > .arrow.open").removeClass("open"),$(this).find("> .sub-menu").slideUp())}):o.find("li.open").removeClass("open"),o.find("li.active").removeClass("active"),o.find("li > a > .selected").remove(),a.parents("li").each(function(){$(this).addClass("active"),$(this).find("> a > span.arrow").addClass("open"),1===$(this).parent("ul.page-sidebar-menu").size()&&$(this).find("> a").append('<span class="selected"></span>'),1===$(this).children("ul.sub-menu").size()&&$(this).addClass("open")}),"click"===e&&App.getViewPort().width<t&&$(".page-sidebar").hasClass("in")&&$(".page-header .responsive-toggler").click()}},r=function(){$(".page-sidebar-mobile-offcanvas .responsive-toggler").click(function(e){$("body").toggleClass("page-sidebar-mobile-offcanvas-open"),e.preventDefault(),e.stopPropagation()}),$("body").hasClass("page-sidebar-mobile-offcanvas")&&$(document).on("click",function(e){$("body").hasClass("page-sidebar-mobile-offcanvas-open")&&0===$(e.target).closest(".page-sidebar-mobile-offcanvas .responsive-toggler").length&&0===$(e.target).closest(".page-sidebar-wrapper").length&&($("body").removeClass("page-sidebar-mobile-offcanvas-open"),e.preventDefault(),e.stopPropagation())}),$(".page-sidebar-menu").on("click","li > a.nav-toggle, li > a > span.nav-toggle",function(e){var a=$(this).closest(".nav-item").children(".nav-link");if(!(App.getViewPort().width>=t&&!$(".page-sidebar-menu").attr("data-initialized")&&$("body").hasClass("page-sidebar-closed")&&1===a.parent("li").parent(".page-sidebar-menu").size())){var i=a.next().hasClass("sub-menu");if(!(App.getViewPort().width>=t&&1===a.parents(".page-sidebar-menu-hover-submenu").size())){if(i===!1)return void(App.getViewPort().width<t&&$(".page-sidebar").hasClass("in")&&$(".page-header .responsive-toggler").click());var s=a.parent().parent(),n=a,r=$(".page-sidebar-menu"),l=a.next(),d=r.data("auto-scroll"),p=parseInt(r.data("slide-speed")),c=r.data("keep-expanded");c||(s.children("li.open").children("a").children(".arrow").removeClass("open"),s.children("li.open").children(".sub-menu:not(.always-open)").slideUp(p),s.children("li.open").removeClass("open"));var h=-200;l.is(":visible")?($(".arrow",n).removeClass("open"),n.parent().removeClass("open"),l.slideUp(p,function(){d===!0&&$("body").hasClass("page-sidebar-closed")===!1&&($("body").hasClass("page-sidebar-fixed")?r.slimScroll({scrollTo:n.position().top}):App.scrollTo(n,h)),o()})):i&&($(".arrow",n).addClass("open"),n.parent().addClass("open"),l.slideDown(p,function(){d===!0&&$("body").hasClass("page-sidebar-closed")===!1&&($("body").hasClass("page-sidebar-fixed")?r.slimScroll({scrollTo:n.position().top}):App.scrollTo(n,h)),o()})),e.preventDefault()}}}),App.isAngularJsApp()&&$(".page-sidebar-menu li > a").on("click",function(e){App.getViewPort().width<t&&$(this).next().hasClass("sub-menu")===!1&&$(".page-header .responsive-toggler").click()}),$(".page-sidebar").on("click"," li > a.ajaxify",function(e){e.preventDefault(),App.scrollTop();var a=$(this).attr("href"),i=$(".page-sidebar ul");i.children("li.active").removeClass("active"),i.children("arrow.open").removeClass("open"),$(this).parents("li").each(function(){$(this).addClass("active"),$(this).children("a > span.arrow").addClass("open")}),$(this).parents("li").addClass("active"),App.getViewPort().width<t&&$(".page-sidebar").hasClass("in")&&$(".page-header .responsive-toggler").click(),Layout.loadAjaxContent(a,$(this))}),$(".page-content").on("click",".ajaxify",function(e){e.preventDefault(),App.scrollTop();var a=$(this).attr("href");App.getViewPort().width<t&&$(".page-sidebar").hasClass("in")&&$(".page-header .responsive-toggler").click(),Layout.loadAjaxContent(a)}),$(document).on("click",".page-header-fixed-mobile .page-header .responsive-toggler",function(){App.scrollTop()}),p(),$(".page-sidebar").on("click",".sidebar-search .remove",function(e){e.preventDefault(),$(".sidebar-search").removeClass("open")}),$(".page-sidebar .sidebar-search").on("keypress","input.form-control",function(e){return 13==e.which?($(".sidebar-search").submit(),!1):void 0}),$(".sidebar-search .submit").on("click",function(e){e.preventDefault(),$("body").hasClass("page-sidebar-closed")&&$(".sidebar-search").hasClass("open")===!1?(1===$(".page-sidebar-fixed").size()&&$(".page-sidebar .sidebar-toggler").click(),$(".sidebar-search").addClass("open")):$(".sidebar-search").submit()}),0!==$(".sidebar-search").size()&&($(".sidebar-search .input-group").on("click",function(e){e.stopPropagation()}),$("body").on("click",function(){$(".sidebar-search").hasClass("open")&&$(".sidebar-search").removeClass("open")}))},l=function(){var e=App.getViewPort().height-$(".page-header").outerHeight(!0);return $("body").hasClass("page-footer-fixed")&&(e-=$(".page-footer").outerHeight()),e},d=function(){var e=$(".page-sidebar-menu");return o(),0===$(".page-sidebar-fixed").size()?void App.destroySlimScroll(e):void(App.getViewPort().width>=t&&!$("body").hasClass("page-sidebar-menu-not-fixed")&&(e.attr("data-height",l()),App.destroySlimScroll(e),App.initSlimScroll(e),o()))},p=function(){$("body").hasClass("page-sidebar-fixed")&&$(".page-sidebar").on("mouseenter",function(){$("body").hasClass("page-sidebar-closed")&&$(this).find(".page-sidebar-menu").removeClass("page-sidebar-menu-closed")}).on("mouseleave",function(){$("body").hasClass("page-sidebar-closed")&&$(this).find(".page-sidebar-menu").addClass("page-sidebar-menu-closed")})},c=function(){$("body").on("click",".sidebar-toggler",function(e){var a=$("body"),t=$(".page-sidebar"),i=$(".page-sidebar-menu");$(".sidebar-search",t).removeClass("open"),a.hasClass("page-sidebar-closed")?(a.removeClass("page-sidebar-closed"),i.removeClass("page-sidebar-menu-closed"),Cookies&&Cookies.set("sidebar_closed","0")):(a.addClass("page-sidebar-closed"),i.addClass("page-sidebar-menu-closed"),a.hasClass("page-sidebar-fixed")&&i.trigger("mouseleave"),Cookies&&Cookies.set("sidebar_closed","1")),$(window).trigger("resize")})},h=function(){$(".page-header").on("click",'.hor-menu a[data-toggle="tab"]',function(e){e.preventDefault();var a=$(".hor-menu .nav"),t=a.find("li.current");$("li.active",t).removeClass("active"),$(".selected",t).remove();var i=$(this).parents("li").last();i.addClass("current"),i.find("a:first").append('<span class="selected"></span>')}),$(".page-header").on("click",".search-form",function(e){$(this).addClass("open"),$(this).find(".form-control").focus(),$(".page-header .search-form .form-control").on("blur",function(e){$(this).closest(".search-form").removeClass("open"),$(this).unbind("blur")})}),$(".page-header").on("keypress",".hor-menu .search-form .form-control",function(e){return 13==e.which?($(this).closest(".search-form").submit(),!1):void 0}),$(".page-header").on("mousedown",".search-form.open .submit",function(e){e.preventDefault(),e.stopPropagation(),$(this).closest(".search-form").submit()}),$(document).on("click",".mega-menu-dropdown .dropdown-menu",function(e){e.stopPropagation()})},u=function(){$("body").on("shown.bs.tab",'a[data-toggle="tab"]',function(){o()})},g=function(){var e=300,a=500;navigator.userAgent.match(/iPhone|iPad|iPod/i)?$(window).bind("touchend touchcancel touchleave",function(t){$(this).scrollTop()>e?$(".scroll-to-top").fadeIn(a):$(".scroll-to-top").fadeOut(a)}):$(window).scroll(function(){$(this).scrollTop()>e?$(".scroll-to-top").fadeIn(a):$(".scroll-to-top").fadeOut(a)}),$(".scroll-to-top").click(function(e){return e.preventDefault(),$("html, body").animate({scrollTop:0},a),!1})},f=function(){$(".full-height-content").each(function(){var e,a=$(this);if(e=App.getViewPort().height-$(".page-header").outerHeight(!0)-$(".page-footer").outerHeight(!0)-$(".page-title").outerHeight(!0)-$(".page-bar").outerHeight(!0),a.hasClass("portlet")){var i=a.find(".portlet-body");App.destroySlimScroll(i.find(".full-height-content-body")),e=e-a.find(".portlet-title").outerHeight(!0)-parseInt(a.find(".portlet-body").css("padding-top"))-parseInt(a.find(".portlet-body").css("padding-bottom"))-5,App.getViewPort().width>=t&&a.hasClass("full-height-content-scrollable")?(e-=35,i.find(".full-height-content-body").css("height",e),App.initSlimScroll(i.find(".full-height-content-body"))):i.css("min-height",e)}else App.destroySlimScroll(a.find(".full-height-content-body")),App.getViewPort().width>=t&&a.hasClass("full-height-content-scrollable")?(e-=35,a.find(".full-height-content-body").css("height",e),App.initSlimScroll(a.find(".full-height-content-body"))):a.css("min-height",e)})};return{initHeader:function(){h()},setSidebarMenuActiveLink:function(e,a){n(e,a,null)},setAngularJsSidebarMenuActiveLink:function(e,a,t){n(e,a,t)},initSidebar:function(e){d(),r(),c(),App.isAngularJsApp()&&n("match",null,e),App.addResizeHandler(d)},initContent:function(){f(),u(),App.addResizeHandler(o),App.addResizeHandler(f)},initFooter:function(){g()},init:function(){this.initHeader(),this.initSidebar(null),this.initContent(),this.initFooter()},loadAjaxContent:function(e,a){var t=$(".page-content .page-content-body");App.startPageLoading({animate:!0}),$.ajax({type:"GET",cache:!1,url:e,dataType:"html",success:function(e){App.stopPageLoading(),t.html(e);for(var s=0;s<i.length;s++)i[s].call(e);a.size()>0&&0===a.parents("li.open").size()&&$(".page-sidebar-menu > li.open > a").click(),Layout.fixContentHeight(),App.initAjax()},error:function(e,a,i){App.stopPageLoading(),t.html("<h4>Could not load the requested content.</h4>");for(var o=0;o<s.length;o++)s[o].call(e)}})},addAjaxContentSuccessCallback:function(e){i.push(e)},addAjaxContentErrorCallback:function(e){s.push(e)},fixContentHeight:function(){o()},initFixedSidebarHoverEffect:function(){p()},initFixedSidebar:function(){d()},getLayoutImgPath:function(){return App.getAssetsPath()+e},getLayoutCssPath:function(){return App.getAssetsPath()+a}}}();App.isAngularJsApp()===!1&&jQuery(document).ready(function(){Layout.init()});
//metronic (4.5.7)
var QuickSidebar=function(){var i=function(){$(".dropdown-quick-sidebar-toggler a, .page-quick-sidebar-toggler, .quick-sidebar-toggler").click(function(i){$("body").toggleClass("page-quick-sidebar-open")})},a=function(){var i=$(".page-quick-sidebar-wrapper"),a=i.find(".page-quick-sidebar-chat"),e=function(){var e,t=i.find(".page-quick-sidebar-chat-users");e=i.height()-i.find(".nav-tabs").outerHeight(!0),App.destroySlimScroll(t),t.attr("data-height",e),App.initSlimScroll(t);var r=a.find(".page-quick-sidebar-chat-user-messages"),s=e-a.find(".page-quick-sidebar-chat-user-form").outerHeight(!0);s-=a.find(".page-quick-sidebar-nav").outerHeight(!0),App.destroySlimScroll(r),r.attr("data-height",s),App.initSlimScroll(r)};e(),App.addResizeHandler(e),i.find(".page-quick-sidebar-chat-users .media-list > .media").click(function(){a.addClass("page-quick-sidebar-content-item-shown")}),i.find(".page-quick-sidebar-chat-user .page-quick-sidebar-back-to-list").click(function(){a.removeClass("page-quick-sidebar-content-item-shown")});var t=function(i){i.preventDefault();var e=a.find(".page-quick-sidebar-chat-user-messages"),t=a.find(".page-quick-sidebar-chat-user-form .form-control"),r=t.val();if(0!==r.length){var s=function(i,a,e,t,r){var s="";return s+='<div class="post '+i+'">',s+='<img class="avatar" alt="" src="'+Layout.getLayoutImgPath()+t+'.jpg"/>',s+='<div class="message">',s+='<span class="arrow"></span>',s+='<a href="#" class="name">Bob Nilson</a>&nbsp;',s+='<span class="datetime">'+a+"</span>",s+='<span class="body">',s+=r,s+="</span>",s+="</div>",s+="</div>"},n=new Date,c=s("out",n.getHours()+":"+n.getMinutes(),"Bob Nilson","avatar3",r);c=$(c),e.append(c),e.slimScroll({scrollTo:"1000000px"}),t.val(""),setTimeout(function(){var i=new Date,a=s("in",i.getHours()+":"+i.getMinutes(),"Ella Wong","avatar2","Lorem ipsum doloriam nibh...");a=$(a),e.append(a),e.slimScroll({scrollTo:"1000000px"})},3e3)}};a.find(".page-quick-sidebar-chat-user-form .btn").click(t),a.find(".page-quick-sidebar-chat-user-form .form-control").keypress(function(i){return 13==i.which?(t(i),!1):void 0})},e=function(){var i=$(".page-quick-sidebar-wrapper"),a=function(){var a,e=i.find(".page-quick-sidebar-alerts-list");a=i.height()-80-i.find(".nav-justified > .nav-tabs").outerHeight(),App.destroySlimScroll(e),e.attr("data-height",a),App.initSlimScroll(e)};a(),App.addResizeHandler(a)},t=function(){var i=$(".page-quick-sidebar-wrapper"),a=function(){var a,e=i.find(".page-quick-sidebar-settings-list");a=i.height()-80-i.find(".nav-justified > .nav-tabs").outerHeight(),App.destroySlimScroll(e),e.attr("data-height",a),App.initSlimScroll(e)};a(),App.addResizeHandler(a)};return{init:function(){i(),a(),e(),t()}}}();App.isAngularJsApp()===!1&&jQuery(document).ready(function(){QuickSidebar.init()});
//metronic (4.5.7)
var QuickNav=function(){return{init:function(){if($(".quick-nav").length>0){var i=$(".quick-nav");i.each(function(){var i=$(this),n=i.find(".quick-nav-trigger");n.on("click",function(n){n.preventDefault(),i.toggleClass("nav-is-visible")})}),$(document).on("click",function(n){!$(n.target).is(".quick-nav-trigger")&&!$(n.target).is(".quick-nav-trigger span")&&i.removeClass("nav-is-visible")})}}}}();QuickNav.init();
//metronic (4.5.7)
var Demo=function(){var e=function(){var e=$(".theme-panel");$("body").hasClass("page-boxed")===!1&&$(".layout-option",e).val("fluid"),$(".sidebar-option",e).val("default"),$(".page-header-option",e).val("fixed"),$(".page-footer-option",e).val("default"),$(".sidebar-pos-option").attr("disabled")===!1&&$(".sidebar-pos-option",e).val(App.isRTL()?"right":"left");var a=function(){$("body").removeClass("page-boxed").removeClass("page-footer-fixed").removeClass("page-sidebar-fixed").removeClass("page-header-fixed").removeClass("page-sidebar-reversed"),$(".page-header > .page-header-inner").removeClass("container"),1===$(".page-container").parent(".container").size()&&$(".page-container").insertAfter("body > .clearfix"),1===$(".page-footer > .container").size()?$(".page-footer").html($(".page-footer > .container").html()):1===$(".page-footer").parent(".container").size()&&($(".page-footer").insertAfter(".page-container"),$(".scroll-to-top").insertAfter(".page-footer")),$(".top-menu > .navbar-nav > li.dropdown").removeClass("dropdown-dark"),$("body > .container").remove()},o="",t=function(){var t=$(".layout-option",e).val(),i=$(".sidebar-option",e).val(),r=$(".page-header-option",e).val(),d=$(".page-footer-option",e).val(),s=$(".sidebar-pos-option",e).val(),n=$(".sidebar-style-option",e).val(),p=$(".sidebar-menu-option",e).val(),l=$(".page-header-top-dropdown-style-option",e).val();if("fixed"==i&&"default"==r&&(alert("Default Header with Fixed Sidebar option is not supported. Proceed with Fixed Header with Fixed Sidebar."),$(".page-header-option",e).val("fixed"),$(".sidebar-option",e).val("fixed"),i="fixed",r="fixed"),a(),"boxed"===t){$("body").addClass("page-boxed"),$(".page-header > .page-header-inner").addClass("container");$("body > .page-wrapper > .clearfix").after('<div class="container"></div>');$(".page-container").appendTo("body > .page-wrapper > .container"),"fixed"===d?$(".page-footer").html('<div class="container">'+$(".page-footer").html()+"</div>"):$(".page-footer").appendTo("body > .page-wrapper > .container")}o!=t&&App.runResizeHandlers(),o=t,"fixed"===r?($("body").addClass("page-header-fixed"),$(".page-header").removeClass("navbar-static-top").addClass("navbar-fixed-top")):($("body").removeClass("page-header-fixed"),$(".page-header").removeClass("navbar-fixed-top").addClass("navbar-static-top")),$("body").hasClass("page-full-width")===!1&&("fixed"===i?($("body").addClass("page-sidebar-fixed"),$("page-sidebar-menu").addClass("page-sidebar-menu-fixed"),$("page-sidebar-menu").removeClass("page-sidebar-menu-default"),Layout.initFixedSidebarHoverEffect()):($("body").removeClass("page-sidebar-fixed"),$("page-sidebar-menu").addClass("page-sidebar-menu-default"),$("page-sidebar-menu").removeClass("page-sidebar-menu-fixed"),$(".page-sidebar-menu").unbind("mouseenter").unbind("mouseleave"))),"dark"===l?$(".top-menu > .navbar-nav > li.dropdown").addClass("dropdown-dark"):$(".top-menu > .navbar-nav > li.dropdown").removeClass("dropdown-dark"),"fixed"===d?$("body").addClass("page-footer-fixed"):$("body").removeClass("page-footer-fixed"),"light"===n?$(".page-sidebar-menu").addClass("page-sidebar-menu-light"):$(".page-sidebar-menu").removeClass("page-sidebar-menu-light"),"hover"===p?"fixed"==i?($(".sidebar-menu-option",e).val("accordion"),alert("Hover Sidebar Menu is not compatible with Fixed Sidebar Mode. Select Default Sidebar Mode Instead.")):$(".page-sidebar-menu").addClass("page-sidebar-menu-hover-submenu"):$(".page-sidebar-menu").removeClass("page-sidebar-menu-hover-submenu"),App.isRTL()?"left"===s?($("body").addClass("page-sidebar-reversed"),$("#frontend-link").tooltip("destroy").tooltip({placement:"right"})):($("body").removeClass("page-sidebar-reversed"),$("#frontend-link").tooltip("destroy").tooltip({placement:"left"})):"right"===s?($("body").addClass("page-sidebar-reversed"),$("#frontend-link").tooltip("destroy").tooltip({placement:"left"})):($("body").removeClass("page-sidebar-reversed"),$("#frontend-link").tooltip("destroy").tooltip({placement:"right"})),Layout.fixContentHeight(),Layout.initFixedSidebar()},i=function(e){var a=App.isRTL()?e+"-rtl":e;$("#style_color").attr("href",Layout.getLayoutCssPath()+"themes/"+a+".min.css"),"light2"==e?$(".page-logo img").attr("src",Layout.getLayoutImgPath()+"logo-invert.png"):$(".page-logo img").attr("src",Layout.getLayoutImgPath()+"logo.png")};$(".toggler",e).click(function(){$(".toggler").hide(),$(".toggler-close").show(),$(".theme-panel > .theme-options").show()}),$(".toggler-close",e).click(function(){$(".toggler").show(),$(".toggler-close").hide(),$(".theme-panel > .theme-options").hide()}),$(".theme-colors > ul > li",e).click(function(){var a=$(this).attr("data-style");i(a),$("ul > li",e).removeClass("current"),$(this).addClass("current")}),$("body").hasClass("page-boxed")&&$(".layout-option",e).val("boxed"),$("body").hasClass("page-sidebar-fixed")&&$(".sidebar-option",e).val("fixed"),$("body").hasClass("page-header-fixed")&&$(".page-header-option",e).val("fixed"),$("body").hasClass("page-footer-fixed")&&$(".page-footer-option",e).val("fixed"),$("body").hasClass("page-sidebar-reversed")&&$(".sidebar-pos-option",e).val("right"),$(".page-sidebar-menu").hasClass("page-sidebar-menu-light")&&$(".sidebar-style-option",e).val("light"),$(".page-sidebar-menu").hasClass("page-sidebar-menu-hover-submenu")&&$(".sidebar-menu-option",e).val("hover");$(".sidebar-option",e).val(),$(".page-header-option",e).val(),$(".page-footer-option",e).val(),$(".sidebar-pos-option",e).val(),$(".sidebar-style-option",e).val(),$(".sidebar-menu-option",e).val();$(".layout-option, .page-header-option, .page-header-top-dropdown-style-option, .sidebar-option, .page-footer-option, .sidebar-pos-option, .sidebar-style-option, .sidebar-menu-option",e).change(t)},a=function(e){var a="rounded"===e?"components-rounded":"components";a=App.isRTL()?a+"-rtl":a,$("#style_components").attr("href",App.getGlobalCssPath()+a+".min.css"),"undefined"!=typeof Cookies&&Cookies.set("layout-style-option",e)};return{init:function(){e(),$(".theme-panel .layout-style-option").change(function(){a($(this).val())}),"undefined"!=typeof Cookies&&"rounded"===Cookies.get("layout-style-option")&&(a(Cookies.get("layout-style-option")),$(".theme-panel .layout-style-option").val(Cookies.get("layout-style-option")))}}}();App.isAngularJsApp()===!1&&jQuery(document).ready(function(){Demo.init()});
//metronic (4.5.7)
(function() {
	app.constant('appConfig', {
		ng_debounce_time: 800,
		mil_interval_refresh: 600000,
		midia_type: {
			imagem: 'img',
			imagem_destacada: 'img-destacada',
			anexo: 'file'
		},
		accept: 'image/*'
			+ ', application/pdf'
			+ ', application/msword'
			+ ', application/vnd.openxmlformats-officedocument.wordprocessingml.document'
			+ ', application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			+ ', application/vnd.ms-excel'
			+ ', application/vnd.ms-powerpoint'
   			+ ', application/vnd.openxmlformats-officedocument.presentationml.slideshow'
    		+ ', application/vnd.openxmlformats-officedocument.presentationml.presentation'
		,
		url: site_url,
		default_post_image : 'assets/img/bg-login.jpg',
		default_user_image: 'assets/img/logo.png',
		max_characters_notification: 500,
		post_types: {
			informacao: 'informacao',
			forum: 'forum',
			evento: 'evento',
      transparencia: 'transparencia',
      documento_nao_auditado: 'documento_nao_auditado',
			classificado: 'classificado'
		}
	});
})();

//metronic (4.5.7)
(function() {
	app.constant('Session', {
		user : null,
		token: null,
		empreendimento: null,
		is_suporte: function() {
			/*
				Se o usuário não está vinculado a nenhum empreendimento, isto
				implica que o mesmo é um usuário do tipo suporte.
			*/
			return localStorage.empreendimento == 'null';
		}
	});
})();
//metronic (4.5.7)
(function() {
    app.service('AjaxService', [
        '$http',
        '$state',
        'Session',
        '$rootScope',
        function($http, $state, Session, $rootScope){
            var request = function(http, failure, success) {
                $rootScope.$broadcast('ajaxStartLoad');
                if(Session.token)
                    http.headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Session.token};

                return $http(http)
                    .success((response) => {
                        $rootScope.$broadcast('ajaxFinishLoad');
                        if(success)
                            console.log('success');

                        return response;
                    })
                    .error((error) => {
                        $rootScope.$broadcast('ajaxFinishLoad');
                        // console.log(error);
                        if(error !== null && (error.error === "token_not_provided"
                            || error.error === "token_invalid" || error.error === "token_expired")) {

                            toastr.error('Houve algum problema na validação de seu Token. Por favor, realize login e tente novamente!');
                            $state.go('login');
                            return;
                        }

                        if(error !== null) {
                            if(error.error === "invalid_credentials")
                                toastr.error('Login ou senha inváidos');

                            if(error.error_message)
                                toastr.error(error.error_message);
                        }

                        
                    });
            }

            return {
                request: request
            };
        }
    ]);
})();

//metronic (4.5.7)
(function(angular) {
	app.service('AuthService', [
		'Session',
		'$state',
        '$rootScope',
        '$q',
        'StorageService',
		function(Session, $state, $rootScope, $q, StorageService){
            // Retorna o status da auntenticacao
            function waitForSignIn() {
                if($rootScope.isUserLogged && Session.user) {
                    return true;
                }

                Session.user = StorageService.getJson('usuario');
                Session.token = StorageService.getJson('token');
                Session.empreendimento = StorageService.getJson('empreendimento');
                
                if(Session.user.usuario_tipo.titulo === 'Portaria') {
                   $rootScope.isPortaria = true;
                } else if(Session.user.usuario_tipo.titulo === 'Mensageria') {
                   $rootScope.isMensageria = true;
                }else if(Session.user.usuario_tipo.titulo === 'Recepção') {
                   $rootScope.isRecepcao = true;
                }
                
                //$rootScope.isUserLogged = Session.user && Session.token && Session.empreendimento;

                return $rootScope.isUserLogged;
            }

            // Retorna o status da autenticacao e caso nao haja gera um erro de acesso
            function requireSignIn() {
                var hasAuth = waitForSignIn();
                if (!hasAuth) {
                    toastr.info('Para ter acesso à essa página, faça login');
                    var error = 'AUTH_REQUIRED';
                    return $q.reject(error);
                }
                return hasAuth;
            }

			return {
                waitForSignIn: waitForSignIn,
                requireSignIn: requireSignIn
			};
		}
	]);
})(window.angular);
//metronic (4.5.7)
(function() {
	app.service('AgendamentoStatusService', [
		'Session',
		'AjaxService',
		function(Session, AjaxService){

			var getAll = function() {
				return AjaxService.request({
					method: 'GET',
					url: api + 'agendamentostatus'
				});
			}

			var getStatus = function(id) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'agendamentostatus/' + id
				});
			}

			return {
				getAll: getAll,
				getStatus: getStatus,
			};
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.service('AgendamentoService', [
		'Session',
		'AjaxService',
		function(Session, AjaxService){
			
			var getPages = function(filters) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'agendamento-count' + (filters ? filters : '')
				});
			}
			
			var getAgendamentos = function(filters) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'agendamento' + (filters ? filters : '')
				});
			}

			var getAgendamento = function(id) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'agendamento/' + id
				});
			}

			var createAgendamento = function(data) {
				return AjaxService.request({
					method: 'POST',
					url: api + 'agendamento',
					data: data
				});
			}

			var updateAgendamento = function(data) {
				return AjaxService.request({
					method: 'PATCH',
					url: api + 'agendamento/' + data.id,
					data: data
				});
			}

			var deleteAgendamento = function(id) {
				return AjaxService.request({
					method: 'DELETE',
					url: api + 'agendamento/' + id
				});
			}

			var getDependenciaHorarios = function(id, data, isEditing, idAgendamento, clickOnCalendar) {
				
				return AjaxService.request({
					method: 'GET',
					url: api + 'dependencias/horarios/' + id + "/" +data + '/'+ isEditing + '/'+ idAgendamento + '/' +clickOnCalendar
				}, 'Não foi possível recuperar as dependências');
			};

			return {
				getPages: getPages,
				getAgendamentos: getAgendamentos,
				getAgendamento: getAgendamento,
				createAgendamento: createAgendamento,
				updateAgendamento: updateAgendamento,
				deleteAgendamento: deleteAgendamento,
				getDependenciaHorarios: getDependenciaHorarios
			};
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.service('ChamadoService', [
		'Session',
		'AjaxService',
		function(Session, AjaxService){

			var getTiposChamado = function(filters) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'chamadotipo' + (filters ? filters : '')
				});
			}

			var getTipoChamado = function(id) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'chamadotipo/' + id
				});
			}

			var createTipoChamado = function(data) {
				return AjaxService.request({
					method: 'POST',
					url: api + 'chamadotipo',
					data: data
				});
			}

			var updateTipoChamado = function(data) {
				return AjaxService.request({
					method: 'PATCH',
					url: api + 'chamadotipo/' + data.id,
					data: data
				});
			}

			var deleteTipoChamado = function(id) {
				return AjaxService.request({
					method: 'DELETE',
					url: api + 'chamadotipo/' + id
				});
			}

			var getAssuntosChamado = function(filter) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'chamadoassunto' + (filter ? filter : '')
				});
			}

			var getAssuntoChamado = function(id) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'chamadoassunto/' + id
				});
			}

			var createAssuntoChamado = function(data) {
				return AjaxService.request({
					method: 'POST',
					url: api + 'chamadoassunto',
					data: data
				});
			}

			var updateAssuntoChamado = function(data) {
				return AjaxService.request({
					method: 'PATCH',
					url: api + 'chamadoassunto/' + data.id,
					data: data
				});
			}

			var deleteAssuntoChamado = function(id) {
				return AjaxService.request({
					method: 'DELETE',
					url: api + 'chamadoassunto/' + id
				});
			}

			var getChamadosEmAberto = function(filter) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'chamado' + (filter ? filter : '')
				});
			}

			var getChamado = function(id) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'chamado/' + id
				});
			}

			var comentar = function(data) {
				return AjaxService.request({
					method: 'POST',
					url: api + 'chamadocomentario',
					data: data
				});
			}

			var alterarStatus = function(data) {
				return AjaxService.request({
					method: 'PUT',
					url: api + 'updateStatus/'+data.id,
					data: data
				});
			}

			var addResponsavel = function(data) {
				return AjaxService.request({
					method: 'POST',
					url: api + 'chamadoresponsavel',
					data: data
				});
			}

			var removeResponsavel = function(data) {
				return AjaxService.request({
					method: 'DELETE',
					url: api + 'chamadoresponsavel/0', //Hack
					data: data
				});
			}

			return {
				getTiposChamado: getTiposChamado,
				createTipoChamado: createTipoChamado,
				updateTipoChamado: updateTipoChamado,
				deleteTipoChamado: deleteTipoChamado,
				getTipoChamado: getTipoChamado,
				getAssuntosChamado: getAssuntosChamado,
				createAssuntoChamado: createAssuntoChamado,
				updateAssuntoChamado: updateAssuntoChamado,
				deleteAssuntoChamado: deleteAssuntoChamado,
				getAssuntoChamado: getAssuntoChamado,
				getChamadosEmAberto: getChamadosEmAberto,
				getChamado: getChamado,
				comentar: comentar,
				alterarStatus: alterarStatus,
				addResponsavel: addResponsavel,
				removeResponsavel: removeResponsavel
			};
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.service('ConfiguracaoService', [
		'Session',
		'AjaxService',
		function(Session, AjaxService){

			var getConfiguracao = function(filters) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'configuracao' + (filters ? filters : '')
				});
			}

			var createConfiguracao = function(data) {
				return AjaxService.request({
					method: 'POST',
					url: api + 'configuracao',
					data: data
				});
			}


			return {
				getConfiguracao: getConfiguracao,
				createConfiguracao: createConfiguracao,
			};
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.service('ConjuntoService', [
		'Session',
		'AjaxService',
		function(Session, AjaxService){

			var getTiposConjuntos = function() {
				return AjaxService.request({
					method: 'GET',
					url: api + 'conjuntotipo'
				});
			}

			var getTipoConjunto = function(id) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'conjuntotipo/' + id
				});
			}

			var createTipoConjunto = function(data) {
				return AjaxService.request({
					method: 'POST',
					url: api + 'conjuntotipo',
					data: data
				});
			}

			var updateTipoConjunto = function(data) {
				return AjaxService.request({
					method: 'PATCH',
					url: api + 'conjuntotipo/' + data.id,
					data: data
				});
			}

			var deleteTipoConjunto = function(id) {
				return AjaxService.request({
					method: 'DELETE',
					url: api + 'conjuntotipo/' + id
				});
			}

			var getConjuntos = function(filters) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'conjunto' + (filters ? filters : '')
				});
			}

			var getConjunto = function(id) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'conjunto/' + id
				});
			}

			var createConjunto = function(data) {
				return AjaxService.request({
					method: 'POST',
					url: api + 'conjunto',
					data: data
				});
			}

			var updateConjunto = function(data) {
				return AjaxService.request({
					method: 'PATCH',
					url: api + 'conjunto/' + data.id,
					data: data
				});
			}

			var deleteConjunto = function(id) {
				return AjaxService.request({
					method: 'DELETE',
					url: api + 'conjunto/' + id
				});
			}

			return {
				getTiposConjuntos: getTiposConjuntos,
				createTipoConjunto: createTipoConjunto,
				updateTipoConjunto: updateTipoConjunto,
				deleteTipoConjunto: deleteTipoConjunto,
				getTipoConjunto: getTipoConjunto,
				getConjuntos: getConjuntos,
				createConjunto: createConjunto,
				updateConjunto: updateConjunto,
				deleteConjunto: deleteConjunto,
				getConjunto: getConjunto
			};
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.service('DependenciaService', [
		'Session',
		'AjaxService',
		function(Session, AjaxService){

			var getDependencias = function(filters) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'dependencia' + (filters ? filters : '')
				});
			}

			var getDependencia = function(id) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'dependencia/' + id
				});
			}

			var createDependencia = function(data) {
				return AjaxService.request({
					method: 'POST',
					url: api + 'dependencia',
					data: data
				});
			}

			var updateDependencia = function(data) {
				return AjaxService.request({
					method: 'PATCH',
					url: api + 'dependencia/' + data.id,
					data: data
				});
			}

			var deleteDependencia = function(id) {
				return AjaxService.request({
					method: 'DELETE',
					url: api + 'dependencia/' + id
				});
			}

			return {
				getDependencias: getDependencias,
				getDependencia: getDependencia,
				createDependencia: createDependencia,
				updateDependencia: updateDependencia,
				deleteDependencia: deleteDependencia
			};
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.service('EmpreendimentoService', [
		'Session',
		'AjaxService',
		function(Session, AjaxService){

			var getEmpreendimentosList = function() {
				return AjaxService.request({
					method: 'GET',
					url: api + 'empreendimento/list'
				});
			}
			
			var getEmpreendimentos = function() {
				return AjaxService.request({
					method: 'GET',
					url: api + 'empreendimento'
				});
			}

			var getEmpreendimento = function(id) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'empreendimento/' + id
				});
			}

			var deleteEmpreendimento = function(id) {
				return AjaxService.request({
					method: 'DELETE',
					url: api + 'empreendimento/' + id
				});
			}

			var createEmpreendimento = function(data) {
				return AjaxService.request({
					method: 'POST',
					url: api + 'empreendimento',
					data: data
				});				
			}

			var updateEmpreendimento = function(data) {
				return AjaxService.request({
					method: 'PATCH',
					url: api + 'empreendimento/' + data.id,
					data: data
				});
			}

			return {
				getEmpreendimentosList: getEmpreendimentosList,
				getEmpreendimentos: getEmpreendimentos,
				getEmpreendimento: getEmpreendimento,
				deleteEmpreendimento: deleteEmpreendimento,
				createEmpreendimento: createEmpreendimento,
				updateEmpreendimento: updateEmpreendimento
			};
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.service('FraseService', [
		'Session',
		'AjaxService',
		function(Session, AjaxService){

			var getFrases = function(filter) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'frase' + (filter ? filter : '')
				});
			}

			var getFrase = function(id) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'frase/' + id
				});
			}

			var createFrase = function(data) {
				return AjaxService.request({
					method: 'POST',
					url: api + 'frase',
					data: data
				});
			}

			var updateFrase = function(data) {
				return AjaxService.request({
					method: 'PATCH',
					url: api + 'frase/' + data.id,
					data: data
				});
			}

			var deleteFrase = function(id) {
				return AjaxService.request({
					method: 'DELETE',
					url: api + 'frase/' + id
				});
			}

			return {
				getFrases: getFrases,
				getFrase: getFrase,
				createFrase: createFrase,
				updateFrase: updateFrase,
				deleteFrase: deleteFrase
			};
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.service('LoginService', [
		'Session',
		'AjaxService',
		function(Session, AjaxService){
			var doLogin = function(data) {
				return AjaxService.request({
					method: 'POST',
					url: api + 'login',
					data: data
				});
			};
			
			var logout = function(token) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'logout/' + token
				});
			};

			var recuperarSenha = function(data) {
				return AjaxService.request({
					method: 'PATCH',
					url: api + 'recuperarsenha',
					data: data
				});
			}

			return {
				doLogin : doLogin,
				logout : logout,
				recuperarSenha : recuperarSenha
			};
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.service('MidiaService', [
		'Session',
		'AjaxService',
		function(Session, AjaxService){
			var createMidia = function(data) {
				return AjaxService.request({
					method: 'post',
					url: api + 'midia',
					data: data
				});
			};

			var deleteMidia = function(id) {
				return AjaxService.request({
					method: 'delete',
					url: api + 'midia/'+id
				});
			};

			return {
				createMidia : createMidia,
				deleteMidia : deleteMidia
			};
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.service('MoradiaService', [
		'Session',
		'AjaxService',
		function(Session, AjaxService){
			var getPages = function(filters) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'moradia-count' + (filters ? filters : '')
				});
			}

			var getMoradias = function(filters) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'moradia' + (filters ? filters : '')
				});
			}

			var getMoradia = function(id) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'moradia/' + id
				});
			}

			var createMoradia = function(data) {
				return AjaxService.request({
					method: 'POST',
					url: api + 'moradia',
					data: data
				});
			}

			var updateMoradia = function(data) {
				return AjaxService.request({
					method: 'PATCH',
					url: api + 'moradia/' + data.id,
					data: data
				});
			}

			var deleteMoradia = function(id) {
				return AjaxService.request({
					method: 'DELETE',
					url: api + 'moradia/' + id
				});
			}

			return {
				getPages: getPages,
				getMoradias: getMoradias,
				getMoradia: getMoradia,
				createMoradia: createMoradia,
				updateMoradia: updateMoradia,
				deleteMoradia: deleteMoradia
			};
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.service('NotificacaoService', [
		'Session',
		'AjaxService',
		function(Session, AjaxService){
			var getNotificacoes = function(filters) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'notificacoes' + (filters ? filters : '')
				});
			}
			
			var getPages = function(filters) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'notificacao-count' + (filters ? filters : '')
				});
			}

			var createNotificacao = function(data) {
				return AjaxService.request({
					method: 'POST',
					url: api + 'notificacoes',
					data: data
				});
			}

			var deleteNotificacao = function(id) {
				return AjaxService.request({
					method: 'DELETE',
					url: api + 'notificacoes/'+id
				});
			}

			return {
				getNotificacoes: getNotificacoes,
				getPages: getPages,
				createNotificacao: createNotificacao,
				deleteNotificacao: deleteNotificacao
			};
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.service('PermissaoService', [
		'Session',
		'AjaxService',
		function(Session, AjaxService){

			var getPermissoes = function() {
				return AjaxService.request({
					method: 'GET',
					url: api + 'permissao'
				});
			}

			var getPermissao = function(id) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'permissao/' + id
				});
			}

			var createPermissao = function(data) {
				return AjaxService.request({
					method: 'POST',
					url: api + 'permissao',
					data: data
				});
			}

			var updatePermissao = function(data) {
				return AjaxService.request({
					method: 'PATCH',
					url: api + 'permissao/' + data.id,
					data: data
				});
			}

			var deletePermissao = function(id) {
				return AjaxService.request({
					method: 'DELETE',
					url: api + 'permissao/' + id
				});
			}

			return {
				getPermissoes: getPermissoes,
				getPermissao: getPermissao,
				createPermissao: createPermissao,
				updatePermissao: updatePermissao,
				deletePermissao: deletePermissao
			};
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.service('PostService', [
		'Session',
		'AjaxService',
		function(Session, AjaxService){
			var getDestaques = function(filters) {
				return AjaxService.request({
					method: 'GET',
					url: api + (filters ? filters : '')
				});
			}

			var getPages = function(filters) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'post-count' + (filters ? filters : '')
				});
			}

			var getTiposPost = function(filters) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'posttipo' + (filters ? filters : '')
				});
			}

			var getPostTipo = function(id) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'posttipo/' + id
				});
			}

			var createPostTipo = function(data) {
				return AjaxService.request({
					method: 'POST',
					url: api + 'posttipo',
					data: data
				});
			}

			var updatePostTipo = function(data) {
				return AjaxService.request({
					method: 'PATCH',
					url: api + 'posttipo/' + data.id,
					data: data
				});
			}

			var deletePostTipo = function(id) {
				return AjaxService.request({
					method: 'DELETE',
					url: api + 'posttipo/' + id
				});
			}

			var getPosts = function(filters) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'post' + (filters ? filters : '')
				});
			}

			var getPost = function(id) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'post/' + id
				});
			}

			var createPost = function(data) {
				return AjaxService.request({
					method: 'POST',
					url: api + 'post',
					data: data
				});
			}

			var updatePost = function(data) {
				return AjaxService.request({
					method: 'PATCH',
					url: api + 'post/' + data.id,
					data: data
				});
			}

			var deletePost = function(id) {
				return AjaxService.request({
					method: 'DELETE',
					url: api + 'post/' + id 
				});
			}


			var getPostMetas = function(filters) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'postmeta' + (filters ? filters : '')
				});
			}

			var getPostMeta = function(id) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'postmeta/' + id
				});
			}

			var createPostMeta = function(data) {
				return AjaxService.request({
					method: 'POST',
					url: api + 'postmeta',
					data: data
				});
			}

			var updatePostMeta = function(data) {
				return AjaxService.request({
					method: 'PATCH',
					url: api + 'postmeta/' + data.id,
					data: data
				});
			}

			var deletePostMeta = function(id) {
				return AjaxService.request({
					method: 'DELETE',
					url: api + 'postmeta/' + id
				});
			}

			var getCategories = function() {
				var categorias = [
					{
						label: 'Classificado',
						post_type: 'classificado'
					},
					{
						label: 'Evento',
						post_type: 'evento'
					},
					{
						label: 'Fórum',
						post_type: 'forum'
					},
					{
						label: 'Informação',
						post_type: 'informacao'
					},
					{
						label: 'Transparência',
						post_type: 'transparencia'
					}
				]

				return categorias;
			}

			return {
				getDestaques: getDestaques,
				getPages: getPages,
				getPosts: getPosts,
				getPost: getPost,
				createPost: createPost,
				updatePost: updatePost,
				deletePost: deletePost,
				getPostMetas: getPostMetas,
				getPostMeta: getPostMeta,
				createPostMeta: createPostMeta,
				updatePostMeta: updatePostMeta,
				deletePostMeta: deletePostMeta,
				getTiposPost: getTiposPost,
				getPostTipo: getPostTipo,
				createPostTipo: createPostTipo,
				updatePostTipo: updatePostTipo,
				deletePostTipo: deletePostTipo,
				getCategories: getCategories
			};
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.service('PrestadorService', [
		'Session',
		'AjaxService',
		function(Session, AjaxService){
			
			var getPages = function(id, filter) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'prestador-count?empreendimento='+id + (filter ? filter : '')
				});
			}
			
			var getPrestadores = function(id, filter) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'prestador?empreendimento='+id + (filter ? filter : '')
				});
			}

			var getPrestador = function(id) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'prestador/' + id
				});
			}

			var deletePrestador = function(id) {
				return AjaxService.request({
					method: 'DELETE',
					url: api + 'prestador/' + id
				});
			}

			var createPrestador = function(data) {
				return AjaxService.request({
					method: 'POST',
					url: api + 'prestador',
					data: data
				});				
			}

			var updatePrestador = function(data) {
				return AjaxService.request({
					method: 'PATCH',
					url: api + 'prestador/' + data.id,
					data: data
				});
			}

			return {
				getPages: getPages,
				getPrestadores: getPrestadores,
				getPrestador: getPrestador,
				deletePrestador: deletePrestador,
				createPrestador: createPrestador,
				updatePrestador: updatePrestador
			};
		}
	]);
})();
//metronic (4.5.7)
(function() {
  app.service('RelatorioAcessoService',[
    'Session',
    'AjaxService',
    function(Session,AjaxService) {
      var getRelatorioAll = function(filter){
        // var filter = '?empreendimento='+data.empreendimento;
        // filter += data.post_type ? '&post_type='+data.post_type : '';
        return AjaxService.request({
          method : 'GET',
          url : api +'relatorio-acesso'+filter
        });
      }
      var getRelatorioDados = function(filter){
        return AjaxService.request({
          method : 'GET',
          url : api +'relatorio-dados'+filter
        });
      }

      var getRelatorioMonth = function(filter){
        return AjaxService.request({
          method : 'GET',
          url : api+'relatorio-geral'+filter
        });
      }
      return {
        getRelatorioAll: getRelatorioAll,
        getRelatorioMonth : getRelatorioMonth,
        getRelatorioDados : getRelatorioDados
      }
    }
  ])
})();

//metronic (4.5.7)
(function() {
	app.service('SistemaService', [
		'Session',
		'AjaxService',
		function(Session, AjaxService){
			var createSistema = function(data) {
				return AjaxService.request({
					method: 'POST',
					url: api + 'sistema',
					data: data
				});
			}

			var getSistema = function() {
				return AjaxService.request({
					method: 'GET',
					url: api + 'sistema',
				});
			}

			var updateSistema = function(data) {
				return AjaxService.request({
					method: 'PATCH',
					url: api + 'sistema/' + data.id,
					data: data
				});
			}

			return {
				createSistema: createSistema,
				getSistema: getSistema,
				updateSistema: updateSistema
			};
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.service('TelefonesUteisService', [
		'Session',
		'AjaxService',
		function(Session, AjaxService){

			var getTelefones = function(filters) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'telefone' + (filters ? filters : '')
				});
			}

			var getTelefone = function(id) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'telefone/' + id
				});
			}

			var updateTelefone = function(data) {
				return AjaxService.request({
					method: 'PATCH',
					url: api + 'telefone/' + data.id,
					data: data
				});
			}

			var createTelefone = function(data) {
				return AjaxService.request({
					method: 'POST',
					url: api + 'telefone',
					data: data
				});
			}

			var deleteTelefone = function(id) {
				return AjaxService.request({
					method: 'DELETE',
					url: api + 'telefone/' + id
				});
			}

			return {
				getTelefones: getTelefones,
				getTelefone: getTelefone,
				updateTelefone: updateTelefone,
				createTelefone: createTelefone,
				deleteTelefone: deleteTelefone
			};
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.service('UsuarioService', [
		'AjaxService','$q',
		function(AjaxService,$q){
			var getPages = function(filters) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'usuario-count' + (filters ? filters : '')
				});
			}

			var getTiposUsuario = function(filters) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'usuariotipo' + (filters ? filters : '')
				});
			}

			var getTipoUsuario = function(id) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'usuariotipo/' + id
				});
			}

			var createTipoUsuario = function(data) {
				return AjaxService.request({
					method: 'POST',
					url: api + 'usuariotipo',
					data: data
				});
			}

			var updateTipoUsuario = function(data) {
				return AjaxService.request({
					method: 'PATCH',
					url: api + 'usuariotipo/' + data.id,
					data: data
				});
			}

			var deleteTipoUsuario = function(id) {
				return AjaxService.request({
					method: 'DELETE',
					url: api + 'usuariotipo/' + id
				});
			}
			
			var promise = [];
			
			var getUsuarios = function(filters) {
				
				promise.forEach(function(item,index){
					item.resolve();
					promise.splice(index, 1);
				});
				
				var canceler = $q.defer();
				promise.push(canceler);
				
				return AjaxService.request({
					method: 'GET',
					url: api + 'usuario' + (filters ? filters : ''),
					timeout: canceler.promise
				});
			}

			var getUsuario = function(id) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'usuario/' + id
				});
			}

			var createUsuario = function(data) {
				return AjaxService.request({
					method: 'POST',
					url: api + 'usuario',
					data: data
				});
			}

			var updateUsuario = function(data) {
				return AjaxService.request({
					method: 'PATCH',
					url: api + 'usuario/' + data.id,
					data: data
				});
			}

			var deleteUsuario = function(id) {
				return AjaxService.request({
					method: 'DELETE',
					url: api + 'usuario/' + id
				});
			}

			return {
				getPages: getPages,
				getUsuarios: getUsuarios,
				getUsuario: getUsuario,
				createUsuario: createUsuario,
				updateUsuario: updateUsuario,
				deleteUsuario: deleteUsuario,
				getTiposUsuario: getTiposUsuario,
				getTipoUsuario: getTipoUsuario,
				createTipoUsuario: createTipoUsuario,
				updateTipoUsuario: updateTipoUsuario,
				deleteTipoUsuario: deleteTipoUsuario
			};
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.service('VisitanteService', [
		'Session',
		'AjaxService',
		function(Session, AjaxService){

			var getListas = function(filters) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'lista-visitantes' + (filters ? filters : '')
				});
			}

			var getLista = function(id) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'lista-visitantes/' + id
				});
			}

			var deleteLista = function(id) {
				return AjaxService.request({
					method: 'DELETE',
					url: api + 'lista-visitantes/' + id
				});
			}

			var updateLista = function(data) {
				return AjaxService.request({
					method: 'PATCH',
					url: api + 'lista-visitantes/' + data.id,
					data: data
				});
			}

			//##################################

			var getSearch = function(id,filters) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'visitantes?search=true&empreendimento='+id + (filters ? filters : '')
				});
			}

			var getVisitantes = function(id, confirmado) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'visitantes?empreendimento='+id + (confirmado ? '&confirmado='+confirmado : '')
				});
      }

      var getVisitanteLiberados = function(id,filter){
        return AjaxService.request({
					method: 'GET',
					url: api + 'visitantes-liberado?empreendimento='+id + (filter ? '&confirmado='+filter : '')
				});
      }
      var getVisitanteEstatistica= function(id){
        return AjaxService.request({
					method: 'GET',
					url: api + 'visitantes-relatorio?empreendimento='+id
				});
      }

      var downloadVisitanteLiberadosPdf = function(filters) {
        return AjaxService.request({
          method: 'GET',
          url: api + 'visitantes-liberado?' + filters + '&export=pdf',
          responseType: 'arraybuffer'
        });
      }
			var getVisitante = function(id) {
				return AjaxService.request({
					method: 'GET',
					url: api + 'visitantes/' + id
				});
			}

			var deleteVisitante = function(id) {
				return AjaxService.request({
					method: 'DELETE',
					url: api + 'visitantes/' + id
				});
			}

			var deleteVisitantes = function(id,code) {
				return AjaxService.request({
					method: 'DELETE',
					url: api + 'visitantes/apagarcadeia/' + id + '/' + code
				});
			}

			var updateVisitante = function(data) {
				return AjaxService.request({
					method: 'PATCH',
					url: api + 'visitantes/' + data.id,
					data: data
				});
			}

			var createVisitante = function(data) {
				return AjaxService.request({
					method: 'POST',
					url: api + 'visitantes',
					data: data
				});
			}
			return {
				getListas: getListas,
				getLista: getLista,
				updateLista: updateLista,
				deleteLista: deleteLista,
				getSearch: getSearch,
				getVisitante: getVisitante,
				getVisitantes: getVisitantes,
				deleteVisitante: deleteVisitante,
				createVisitante: createVisitante,
				updateVisitante: updateVisitante,
        deleteVisitantes: deleteVisitantes,
        getVisitanteLiberados : getVisitanteLiberados,
         getVisitanteEstatistica : getVisitanteEstatistica
         ,downloadVisitanteLiberadosPdf: downloadVisitanteLiberadosPdf
			};
		}
	]);
})();

//metronic (4.5.7)
(function() {
    app.service('DialogService', [
        function(){
            var deleteDialog = function(title, callback) {
                swal({
                        title: "Você realmente deseja deletar "+ title +"?",
                        text: "Uma vez deletado, não será possível recuperá-lo",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Sim",
                        cancelButtonText: "Cancelar",
                        closeOnConfirm: false,
                        allowOutsideClick: true,
                        allowEscapeKey: true
                    },  
                    function() {
                        if(callback)
                            callback();
                    }
                );
            }

            var confirmDialog = function(message, callback) {
                swal({
                        title: message,
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Sim",
                        cancelButtonText: "Cancelar",
                        closeOnConfirm: false,
                        allowOutsideClick: true,
                        allowEscapeKey: true
                    },  
                    function() {
                        if(callback)
                            callback();
                    }
                );
            }

            var dialog = function(message, type) {
                swal({
                    title: message,
                    type: type || "success",
                    timer: 2000,
                    allowOutsideClick: true,
                    allowEscapeKey: true
                });
            }

            var close = function() {
                swal.close();
            }

            return {
                deleteDialog: deleteDialog,
                confirmDialog: confirmDialog,
                dialog: dialog,
                close: close
            }
        }
    ]);
})();
//metronic (4.5.7)
(function() {
    app.service('StorageService', [
        function(){
            var setJson = function(key, object) {
                localStorage.setItem(key, JSON.stringify(object));
            }

            var getJson = function(key) {
                return JSON.parse(localStorage.getItem(key))
            }

            var set = function(key, value) {
                localStorage.setItem(key, value);
            }

            var get = function(key) {
                return localStorage.getItem(key);
            }

            var reset = function() {
                localStorage.clear();
            }

            return {
                reset: reset,
                setJson: setJson,
                getJson: getJson,
                get: get,
                set: set
            }
        }
    ]);
})();
//metronic (4.5.7)
(function() {
	app.controller('AgendamentoCadastroController', [ 
		'$scope',
		'AgendamentoService',
		'AgendamentoStatusService',
		'UsuarioService',
		'DependenciaService',
		'$stateParams',
		'$state',
		'Session',
		function ($scope, AgendamentoService, AgendamentoStatusService, UsuarioService, DependenciaService, $stateParams, $state, Session) { 
			'use strict'; 
			var vm = this;
			
			vm.isEditing = false;
			vm.agendamento = { usuario_responsavel : { nome: '' }}
			vm.usuarios = [];
			vm.horariosDisponiveis = [];
			
			angular.element(document).ready(() => {
				var select2 = $(".select").select2();

				$('.select').on('classChange', function() {
					$select2.data('select2').$container.addClass("wrap")
				});
			});
			
			vm.doFilter = function() {
				var filter = '?empreendimento='
					+ Session.empreendimento.id
					+ '&enabled=true'
					+ '&filter='+vm.agendamento.usuario_responsavel.nome;

				UsuarioService.getUsuarios(filter).then((response) => {
					vm.usuarios.length = 0;
					
					response.data.usuarios.forEach(usuario => {
						usuario.label = '<b>' + usuario.nome + '</b><br />' + usuario.moradias.map(
							moradia => moradia.identificador 
								+ ' (' + moradia.conjunto.titulo + ')').join('<br/>');

						vm.usuarios.push(usuario);
					});
				});
			}
			
			vm.select = function(element) {
				vm.agendamento.usuario_responsavel = element;

				if(vm.agendamento.usuario_responsavel.moradias.length === 1) {
					vm.agendamento.moradia = vm.agendamento.usuario_responsavel.moradias[0];
					vm.selectMoradia();
				}
				vm.show_box = false;
			}
			
			vm.selectMoradia = function(){
				var filter = '?empreendimento='+Session.empreendimento.id+"&status=1";
					//+'&conjunto='+vm.agendamento.moradia.conjunto.id;
				
				DependenciaService.getDependencias(filter).then((response) => {
					vm.agendamento.dependencias = response.data.dependencias;
				});
			}
			
			AgendamentoStatusService.getAll().then((response) => {
				vm.agendamento.agendamento_statuss = response.data.status;
			});
			
			if($stateParams.id) {
				vm.isEditing = true;

				AgendamentoService.getAgendamento($stateParams.id).then((response) => {
					vm.agendamento.id = response.data.agendamento.id;
					vm.agendamento.usuario_responsavel = response.data.agendamento.usuario;
					vm.agendamento.moradias = response.data.agendamento.usuario.moradias;
					vm.agendamento.moradia = response.data.agendamento.moradia;
					vm.agendamento.dependencia = response.data.agendamento.dependencia;
					vm.agendamento.dependencias = response.data.agendamento.moradia.conjunto.dependencias;
					vm.agendamento.data_inicio = new Date(response.data.agendamento.data_inicio.timestamp);
					vm.agendamento.data_fim = new Date(response.data.agendamento.data_fim.timestamp);
					vm.agendamento.agendamento_status = response.data.agendamento.agendamento_status;
					vm.agendamento.descricao = response.data.agendamento.descricao;

					vm.getHorariosDisponiveis(response.data.agendamento.data_inicio.amd,vm.isEditing,response.data.agendamento.id);



				});
			}


			vm.resetHorarios = function() {

				vm.horariosDisponiveis = [];
				
			}
			$scope.setDate = function(date,date2) {
						
				vm.getHorariosDisponiveis(date, vm.isEditing, vm.agendamento.id, true);
			
			}

			vm.getHorariosDisponiveis = function(data,isEditing, idAgendamento, clickOnCalendar) {
				AgendamentoService.getDependenciaHorarios(vm.agendamento.dependencia.id, now(data,false), isEditing, idAgendamento, clickOnCalendar)
        		.then( response => {
        			if(isEditing){
						vm.agendamento.datas  = response.data.data.findIndex( obj => obj.pertenceAoUsuario == true);

        				
        			}
        			vm.horariosDisponiveis = response.data.data;
        		
        			
				});
					
			};

			vm.salvar = function() {

				var dataAgendamento = vm.horariosDisponiveis[vm.agendamento.datas];
			
				var data = {
					dependencia_id : vm.agendamento.dependencia.id,
					usuario_id : vm.agendamento.usuario_responsavel.id,
					moradia_id : vm.agendamento.moradia.id,
					descricao : vm.agendamento.descricao,
					agendamento_status_id : vm.agendamento.agendamento_status.id,
					data_inicio: dataAgendamento.dataInicio,
					data_fim: dataAgendamento.dataFim
				};
				
				if(vm.isEditing){
					
					data['id'] = vm.agendamento.id;
					
					AgendamentoService.updateAgendamento(data).then((response) => {
						if(response.data.success) {
							toastr.success('Agendamento alterado com sucesso!');
							$state.go('agendamento');
						} else {
							toastr.error('Não foi possível alterar os dados do Agendamento!');
						}
					});
				}else{
					
					data['periodicidade_ao_criar'] = vm.agendamento.dependencia.periodicidade;
					AgendamentoService.createAgendamento(data).then((response) => {
						if(response.data.success) {
							toastr.success('Agendamento cadastrado com sucesso!');
							$state.go('agendamento');
						} else {
							if(response.data.message){
                                toastr.error(response.data.message);
							}else {
                                toastr.error('Não foi possível cadastrar o Agendamento!');
							}

						}
					});
				}
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('AgendamentoCalendarioController', [ 
		'AgendamentoService',
		'DependenciaService',
		'DialogService',
		'$state',
		'Session',
		'$scope',
		function (AgendamentoService, DependenciaService, DialogService, $state, Session, $scope) { 
			'use strict'; 
			var vm = this;
            var mounthId = {
                "Janeiro" : "01",
                "Fevereiro" : "02",
                "Março" : "03",
                "Abril" : "04",
                "Maio" : "05",
                "Junho" : "06",
                "Julho" : "07",
                "Agosto" : "08",
                "Setembro" : "09",
                "Outubro" : "10",
                "Novembro" : "11",
                "Dezembro" : "12"
            };
            var mes = new Date().getMonth() + 1;
            var ano = new Date().getFullYear();  
            var list = [];
            var list_dependecias = [];
            vm.search = "";
            vm.init = function(){
                vm.getAgendamento();
                vm.getDependencia();
            }

            $('#evoCalendar').evoCalendar({
                language:'pt',

            })
            .on('selectYear',function(activeYear,yearIndex) {
                ano = yearIndex;
                vm.getAgendamento();
             })
            .on("selectMonth",function(activeMonth, monthIndex){
                mes = mounthId[monthIndex];
                vm.getAgendamento();
            })
            .on("selectEvent",function(activeEvent){
                let id = null;
                if(activeEvent.currentTarget.evoCalendar.$active && activeEvent.currentTarget.evoCalendar.$active.events[0].id){
                    id = activeEvent.currentTarget.evoCalendar.$active.events[0].id;
                    id = id.split("-")[1];
                    window.location = `/#/agendamento-cadastro/${id}`;
                }
            })
            

            vm.callEvo = function(arr){
                list.map(el => {
                    $("#evoCalendar").evoCalendar('removeCalendarEvent', el.id);
                })
                list = arr;
                $('#evoCalendar').evoCalendar('addCalendarEvent',arr);
            }

            vm.formatCalendar = function(arr){
                let newArr = [];
                arr.map(el => {
                    newArr.push({
                        id : "date-"+el.id,
                        name: el.usuario.nome,
                        description: `<b>Morador:</b>${el.usuario.nome}<br/><b>Unidade:</b>${el.moradia.identificador} - ${el.moradia.tipo_moradia}<br/><b>Dependência:</b>${el.dependencia.titulo}<br/><b>Status:</b>${el.agendamento_status.titulo}<br/><b>Horário:</b>${el.data_inicio.horaPadrao}`,
                        date : new Date(el.data_inicio.timestamp),
                        everyYear:false,
                        color: "#36c6d3",
                        type:"event",
                    })
                })
                return newArr;
            }

            vm.getAgendamento = function(){
                let empreendimento_id = Session.empreendimento.id;
                let filter = `?mes=${mes}&ano=${ano}&empreendimento=${empreendimento_id}&filter=${vm.search}`;
                AgendamentoService.getAgendamentos(filter).then((resp) => {
                    let newArr = vm.formatCalendar(resp.data.agendamentos);
                    vm.callEvo(newArr);
                });
            }

            vm.getDependencia = function(){
                let empreendimento_id = Session.empreendimento.id;
                let filter = `?empreendimento=${empreendimento_id}&status=1`;
                DependenciaService.getDependencias(filter).then((resp) => {
                    list_dependecias = resp.data.dependencias;
                });
            }

            vm.reload = function(){
                vm.getAgendamento();
            }

            vm.init();
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('AgendamentoController', [ 
		'AgendamentoService',
		'AgendamentoStatusService',
		'DialogService',
		'$state',
		'Session',
		'$scope',
		function (AgendamentoService, AgendamentoStatusService, DialogService, $state, Session, $scope) { 
			'use strict'; 
			var vm = this;

			vm.loadFromPage = function(page) {
				var filters = '?empreendimento='
					+ Session.empreendimento.id
					+ '&offset=' + page
					+ (vm.status ? '&status=' + vm.status.id : '')
					+ (vm.search ? '&filter=' + vm.search : '');
				AgendamentoService.getAgendamentos(filters).then((response) => {
					vm.agendamentos = response.data.agendamentos;
				});
			}

			vm.reload = function() {
				var filters = '?empreendimento='
					+ Session.empreendimento.id
					+ (vm.status ? '&status=' + vm.status.id : '')
					+ (vm.search ? '&filter=' + vm.search : '');
				
				vm.paginator = 0;
				
				AgendamentoService.getPages(filters).then((response) => {
					vm.pages = response.data.pages;
					vm.maxElements = response.data.count;
					vm.itemsPerPage = response.data.itemsPerPage;
				});
				
				vm.loadFromPage(vm.paginator);
			}
			
			AgendamentoStatusService.getAll().then((response) => {
				vm.agendamento_status = response.data.status;
			});
			
			$scope.$on('empreendimento_has_changed', () => {
				vm.reload();
		    });
			vm.reload();

			vm.doFilter = function() {
				vm.reload('&filter='+$scope.search+'&status='+vm.agendamento.agendamento_status);
			}

			vm.delete = function(element) {
				DialogService.deleteDialog('', function() {
					AgendamentoService.deleteAgendamento(element.id).then((response) => {
						if(response.data.success) {
							DialogService.dialog("Deletado com sucesso!");
							$state.reload();
						}else{
							DialogService.dialog("Não foi possível deletar", "error");
						}
					});
				});
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('ChamadoAssuntoCadastroController', [ 
		'ChamadoService',
		'$stateParams',
		'$state',
		'Session',
		function (ChamadoService, $stateParams, $state, Session) { 
			'use strict'; 
			var vm = this;
			
			vm.isEditing = false;

			if($stateParams.id) {
				vm.isEditing = true;
				ChamadoService.getAssuntoChamado($stateParams.id).then((response) => {
					vm.assunto = response.data.assunto_chamada;
					vm.empreendimento = Session.empreendimento.id;
				});
			}

			vm.salvar = function() {
				var data = {
					titulo: vm.assunto.titulo,
					empreendimento_id: Session.empreendimento.id
				};

				if(vm.assunto.id)
					data['id'] = vm.assunto.id;

				if(vm.isEditing) {
					ChamadoService.updateAssuntoChamado(data).then((response) => {
						if(response.data.success) {
							toastr.success('Assunto de Chamado alterado com sucesso!');
							$state.go('chamado-assunto');
						} else {
							toastr.error('Não foi possível alterar os dados do Assunto de Chamado!');
						}
					});
				} else {
					ChamadoService.createAssuntoChamado(data).then((response) => {
						if(response.data.success) {
							toastr.success('Assunto de Chamado cadastrado com sucesso!');
							$state.go('chamado-assunto');
						} else {
							toastr.error('Não foi possível cadastrar o Assunto de Chamado!');
						}
					});
				}
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('ChamadoAssuntoController', [ 
		'ChamadoService',
		'$state',
		'DialogService',
		'Session',
		'$scope',
		function (ChamadoService, $state, DialogService, Session, $scope) { 
			'use strict'; 
			var vm = this;
			
			vm.reloadAssuntos = function() {
				var filter = '?empreendimento='+ Session.empreendimento.id;

				ChamadoService.getAssuntosChamado(filter).then((response) => {
					vm.assuntos = response.data.assuntos_chamadas;
				});				
			}		

			$scope.$on('empreendimento_has_changed', () => {
				vm.reloadAssuntos();
		    });
			vm.reloadAssuntos();

			vm.delete = function(element) {
				DialogService.deleteDialog(element.titulo, function() {
					DialogService.dialog("Deletado com sucesso!");
				});
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('ChamadoTipoCadastroController', [ 
		'ChamadoService',
		'Session',
		'$stateParams',
		'$state',
		function (ChamadoService, Session, $stateParams, $state) { 
			'use strict'; 
			var vm = this;
			
			vm.isEditing = false;

			if($stateParams.id) {
				vm.isEditing = true;
				ChamadoService.getTipoChamado($stateParams.id).then((response) => {
					vm.chamado = response.data.tipo_chamada;
				});
			}

			vm.salvar = function() {
				var data = {
					titulo: vm.chamado.titulo,
					empreendimento_id: Session.empreendimento.id
				};

				if(vm.chamado.id)
					data['id'] = vm.chamado.id;

				if(vm.isEditing) {
					ChamadoService.updateTipoChamado(data).then((response) => {
						if(response.data.success) {
							toastr.success('Chamado alterado com sucesso!');
							$state.go('chamado-tipo');
						} else {
							toastr.error('Não foi possível alterar os dados do Chamado!');
						}
					});
				} else {
					ChamadoService.createTipoChamado(data).then((response) => {
						if(response.data.success) {
							toastr.success('Chamado cadastrado com sucesso!');
							$state.go('chamado-tipo');
						} else {
							toastr.error('Não foi possível cadastrar o Chamado!');
						}
					});
				}
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('ChamadoTipoController', [ 
		'ChamadoService',
		'DialogService',
		'Session',
		'$state',
		'$scope',
		function (ChamadoService, DialogService, Session, $state, $scope) { 
			'use strict'; 
			var vm = this;

			vm.reloadTipos = function() {
				var filter = '?empreendimento=' + Session.empreendimento.id;

				ChamadoService.getTiposChamado(filter).then((response) => {
					vm.tipos_chamadas = response.data.tipos_chamadas;
				});		
			}

			$scope.$on('empreendimento_has_changed', () => {
				vm.reloadTipos();
		    });
			vm.reloadTipos();

			vm.delete = function(element) {
				DialogService.deleteDialog(element.titulo, function() {
					ChamadoService.deleteTipoChamado(element.id).then((response) => {
						if(response.data.success) {
							DialogService.dialog("Deletado com sucesso!");
							$state.reload();
						} else
							DialogService.dialog("Não foi possível deletar "+element.titulo, "error");
					})
				});
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('ChamadosEmAbertoController', [ 
		'ChamadoService',
		'DialogService',
		'Session',
		'$scope',
		function (ChamadoService, DialogService, Session, $scope) { 
			'use strict'; 
			var vm = this;
			vm.filter_select = null;
			
			vm.reloadChamados = function() {
				var filter = '?empreendimento=' + Session.empreendimento.id;

				ChamadoService.getChamadosEmAberto(filter).then((response) => {
					vm.chamados = response.data.chamados;
				});
			}

			vm.selectFilterChanged = function(){
				let status = "";
				if(vm.filter_select != "todos"){
					status = vm.filter_select;
				}
				var filter = '?empreendimento=' + Session.empreendimento.id+'&status='+status;

				ChamadoService.getChamadosEmAberto(filter).then((response) => {
					vm.chamados = response.data.chamados;
				});
			}

			$scope.$on('empreendimento_has_changed', () => {
				vm.reloadChamados();
		    });
			vm.reloadChamados();
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('ChamadoController', [ 
		'ChamadoService',
		'DialogService',
		'UsuarioService',
		'Session',
		'$stateParams',
		'$state',
		function (ChamadoService, DialogService, UsuarioService, Session, $stateParams, $state) { 
			'use strict'; 
			var vm = this;
			vm.status = null;
			ChamadoService.getChamado($stateParams.id).then((response) => {
				vm.chamado = response.data.chamado;
				vm.status = response.data.chamado.status;
				var filter = '?empreendimento='
					+ Session.empreendimento.id
					+ '&enabled=true'
					+'&tipo_usuario=["Administrador","Concierge","Água","Comunicação","Concierge","Conservação","Eventos","Financeiro","Gerente","Manutenção","Mensageria","Pedestre 2","Portaria","Projetos","Proprietário Locador","Recepção","Segurança","Síndico","Sup. Portaria","Suporte"]';
				UsuarioService.getUsuarios(filter).then((response) => {
					vm.usuarios = response.data.usuarios;

					vm.chamado.responsaveis.forEach((element) => {
						vm.usuarios.forEach((innerElement, index) => {
							if(innerElement.id = element.id)
								vm.usuarios.splice(index, 1);
						});
					});
				});
			});

			vm.pick = function(element, index) {
				vm.chamado.responsaveis.push(element);
				vm.usuarios.splice(index, 1);

				ChamadoService.addResponsavel({chamado_id: vm.chamado.id, usuario_id: element.id}).then((response) => {
					if(response.data.success)
						toastr.success(element.nome + ' agora é responsável por este chamado');
					else
						toastr.error('Não foi possível colocar '+element.nome+' como responsável por este chamado');
				});
			}

			vm.unpick = function(element, index) {
				vm.usuarios.push(element);
				vm.chamado.responsaveis.splice(index, 1);

				ChamadoService.removeResponsavel({chamado_id: vm.chamado.id, usuario_id: element.id}).then((response) => {
					if(response.data.success)
						toastr.success(element.nome + ' não é mais responsável por este chamado');
					else
						toastr.error('Não foi possível remover '+element.nome+' como responsável por este chamado');
				});
			}

			vm.comentar = function() {
				var data = {
					chamado_id: vm.chamado.id,
					conteudo: vm.comentario,
					usuario_id: Session.user.id,
					data_postagem: now()
				}

				ChamadoService.comentar(data).then((response) => {
					if(response.data.success) {
						DialogService.dialog("Comentário criado com sucesso!");
						$state.reload();
					} else {
						DialogService.dialog("Erro na criação do comentário!", "error");
					}

				});
			}

			vm.changeStatus = function() {
				let data = {};
				let message = "";
				switch(vm.status){
					case "Aberto" : {
						message = 'Deseja abrir essa ocorrência?';
						data = {
							'usuario_finalizou_id': null,
							'data_fechado': null,
							'data_em_andamento' : null,
							'data_aberto' : now(),
							'status' : vm.status,
							'id': vm.chamado.id
						}
						break;
					}
					case "Em andamento" :{
						message = 'Deseja coloca essa ocorrência em andamento?';
						data = {
							'usuario_finalizou_id': null,
							'data_fechado': null,
							'data_em_andamento' : now(),
							'status' : vm.status,
							'id': vm.chamado.id
						}
						break;
					}
					case "Finalizado": {
						message = 'Deseja finalizar essa ocorrência?';
						data =  {
							'usuario_finalizou_id': Session.user.id,
							'data_fechado': now(),
							'status' : vm.status,
							'id': vm.chamado.id
						}						
						break;
					}
				}	
				DialogService.confirmDialog(message, function() {			
					ChamadoService.alterarStatus(data).then((response) => {
						vm.chamado = response.data.chamado;
						DialogService.close();
					});
				});		
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('ConfiguracaoController', [ 
		'ConfiguracaoService',
		'$stateParams',
		'$state',
		'Session',
		function (ConfiguracaoService, $stateParams, $state, Session) { 
			'use strict'; 
			var vm = this;
			vm.configuracao = {
                empreendimento_id : Session.empreendimento.id
            };
			
			var filter = '?empreendimento='
					+ Session.empreendimento.id;

			ConfiguracaoService.getConfiguracao(filter).then((response) => {
				vm.configuracao = response.data.configuracoes;
			});		
			
			vm.salvar = function() {
                ConfiguracaoService.createConfiguracao(vm.configuracao).then((response) => {
                    if(response.data.success) {
                        toastr.success('Configuração salva com sucesso!');
                    } else {
                        toastr.error('Não foi possível salvar a Configuração!');
                    }
                });
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('ConjuntoCadastroController', [ 
		'ConjuntoService',
		'UsuarioService',
		'$stateParams',
		'$state',
		'Session',
		function (ConjuntoService, UsuarioService, $stateParams, $state, Session) { 
			'use strict'; 
			var vm = this;
			
			vm.isEditing = false;
			vm.usuarios = [];
			vm.conjunto = {
				responsaveis: []
			};
			
			var filter = '?empreendimento='
					+ Session.empreendimento.id
					+ '&enabled=true'
					+ '&is_concierge=Sim';

				UsuarioService.getUsuarios(filter).then((response) => {
					vm.usuarios = response.data.usuarios;		
					if($stateParams.id) {				
							vm.isEditing = true;
							ConjuntoService.getConjunto($stateParams.id).then((response) => {
								   vm.conjunto = response.data.conjunto;
								  
									vm.conjunto.responsaveis.forEach((element) => {
												
											vm.usuarios.forEach((innerElement, index) => {
												if(innerElement.id == element.id){
													 vm.usuarios.splice(index, 1);
												}else {
													// console.log('Não entrou');
												}
											});
										});
							});
					}		
					
				});
			ConjuntoService.getTiposConjuntos().then((response) => {
				vm.tipos_conjunto = response.data.tipos_conjunto;
			});		
			
			angular.element(document).ready(() => {
				$(".select").select2();
			});

			$(document).ready(function() {
				
			});



			vm.pick = function(element, index) {
					vm.conjunto.responsaveis.push(element);
					vm.usuarios.splice(index, 1);
			}

			vm.unpick = function(element, index) {
				vm.usuarios.push(element);
				vm.conjunto.responsaveis.splice(index, 1);
			}


			vm.salvar = function() {
						
				var data = {
					titulo	: vm.conjunto.titulo,
					conjunto_tipo_id : vm.conjunto.conjunto_tipo.id,
					empreendimento_id: Session.empreendimento.id,
					responsaveis: vm.conjunto.responsaveis

				};

				if(vm.conjunto.id)
					data['id'] = vm.conjunto.id;

				if(vm.isEditing) {
					ConjuntoService.updateConjunto(data).then((response) => {
						if(response.data.success) {
							toastr.success('Conjunto alterado com sucesso!');
							$state.go('conjunto');
						} else {
							toastr.error('Não foi possível alterar os dados do Conjunto!');
						}
					});
				} else {
					ConjuntoService.createConjunto(data).then((response) => {
						if(response.data.success) {
							toastr.success('Conjunto cadastrado com sucesso!');
							$state.go('conjunto');
						} else {
							toastr.error('Não foi possível cadastrar o Conjunto!');
						}
					});
				}
			}

		
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('ConjuntoController', [ 
		'$scope',
		'ConjuntoService',
		'Session',
		'DialogService',
		'$state',
		function ($scope, ConjuntoService, Session, DialogService, $state) { 
			'use strict'; 
			var vm = this;
			
			vm.reload = function() {
				var filters = '?empreendimento='+Session.empreendimento.id;
				
				ConjuntoService.getConjuntos(filters).then((response) => {
					vm.conjuntos = response.data.conjuntos;
				});
			}
			
			$scope.$on('empreendimento_has_changed', () => {
				vm.reload();
		    });
			vm.reload();

			vm.delete = function(element) {
				DialogService.deleteDialog(element.titulo, function() {
					ConjuntoService.deleteConjunto(element.id).then((response) => {
						if(response.data.success) {
							DialogService.dialog("Deletado com sucesso!");
							$state.reload();
						} else
							DialogService.dialog("Não foi possível deletar "+element.titulo, "error");
					});
				});
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('ConjuntoTipoCadastroController', [ 
		'ConjuntoService',
		'$stateParams',
		'$state',
		function (ConjuntoService, $stateParams, $state) { 
			'use strict'; 
			var vm = this;
			
			vm.isEditing = false;

			if($stateParams.id) {
				vm.isEditing = true;
				ConjuntoService.getTipoConjunto($stateParams.id).then((response) => {
					vm.conjunto_tipo = response.data.conjunto;
				});
			}

			vm.salvar = function() {
				var data = {
					titulo: vm.conjunto_tipo.titulo
				};

				if(vm.conjunto_tipo.id)
					data['id'] = vm.conjunto_tipo.id;

				if(vm.isEditing) {
					ConjuntoService.updateTipoConjunto(data).then((response) => {
						if(response.data.success) {
							toastr.success('Tipo de Conjunto alterado com sucesso!');
							$state.go('conjunto-tipo');
						} else {
							toastr.error('Não foi possível alterar os dados do Tipo de Conjunto!');
						}
					});
				} else {
					ConjuntoService.createTipoConjunto(data).then((response) => {
						if(response.data.success) {
							toastr.success('Tipo de Conjunto cadastrado com sucesso!');
							$state.go('conjunto-tipo');
						} else {
							toastr.error('Não foi possível cadastrar o Tipo de Conjunto!');
						}
					});
				}
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('ConjuntoTipoController', [ 
		'ConjuntoService',
		'DialogService',
		'$state',
		function (ConjuntoService, DialogService, $state) { 
			'use strict'; 
			var vm = this;
			
			ConjuntoService.getTiposConjuntos().then((response) => {
				vm.tipos_conjunto = response.data.tipos_conjunto;
			});		

			vm.delete = function(element) {
				DialogService.deleteDialog(element.titulo, function() {
					ConjuntoService.deleteTipoConjunto(element.id).then((response) => {
						if(response.data.success) {
							DialogService.dialog("Deletado com sucesso!");
							$state.reload();
						} else
							DialogService.dialog("Não foi possível deletar "+element.titulo, "error");
					})
				});
			}
		}
	]);
})();
//metronic (4.5.7)
(() => {
	app.controller('DashboardController', [
		'$rootScope',
		'$scope',
		'$http',
		'$timeout',
		'PostService',
		'Session',
		function($rootScope, $scope, $http, $timeout, PostService, Session) {
		    var vm = this;
            //$rootScope.isUserLogged = true;
			
		    $scope.$on('$viewContentLoaded', function() {   
		        App.initAjax();
		    });
			
		    vm.loadContent = function() {
				var filters ='post?empreendimento=' 
		    		+ Session.empreendimento.id
		    		+ '&except=classificado&is_destaque=1';
			    PostService.getDestaques(filters).then((response) => {
			    	vm.posts = response.data.post;
			    });
			}
			
			$scope.$on('empreendimento_has_changed', () => {
			    vm.loadContent();
		    });
			vm.loadContent();
			
		    // set sidebar closed and body solid layout mode
		    $rootScope.settings.layout.pageContentWhite = true;
		    $rootScope.settings.layout.pageBodySolid = false;
		    $rootScope.settings.layout.pageSidebarClosed = false;
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('DependenciaCadastroController', [ 
		'$scope',
		'DependenciaService',
		'ConjuntoService',
		'UsuarioService',
		'$stateParams',
		'$state',
		'Session',
		function ($scope, DependenciaService, ConjuntoService,UsuarioService, $stateParams, $state, Session) { 
			'use strict'; 
			var vm = this;
			
			vm.isEditing = false;
			vm.conjuntos = [];
			vm.usuarios = [];
			vm.dependencia = {
				conjuntos: [],
				responsaveis: []
			};

			angular.element(document).ready(() => {
				$(".select").select2();
			});

			vm.reload = function() {
				var filters = '?empreendimento='+Session.empreendimento.id;
				
				vm.dependencia.conjuntos = [];
				vm.dependencia.responsaveis = [];

				//Pega a lista de conjuntos
				ConjuntoService.getConjuntos(filters).then((response) => {
					vm.conjuntos = response.data.conjuntos;
					 var filter = '?empreendimento='
					+ Session.empreendimento.id
					+ '&enabled=true'
					+ '&is_concierge=Sim';

					UsuarioService.getUsuarios(filter).then((response) => {
						vm.usuarios = response.data.usuarios;	
						console.log(vm.usuarios);	
						//Verifica se é uma edição
							if($stateParams.id) {
								vm.isEditing = true;

								//Pega o conjunto da Edição
								DependenciaService.getDependencia($stateParams.id).then((response) => {
									vm.dependencia = response.data.dependencia;

									//Remove todos conjuntos que já existam
									vm.dependencia.conjuntos.forEach((element) => {
										vm.conjuntos.forEach((innerElement, index) => {
											if(innerElement.id === element.id)
												vm.conjuntos.splice(index, 1);
										});
									});
									vm.dependencia.responsaveis.forEach((element) => {
														
											vm.usuarios.forEach((innerElement, index) => {
												if(innerElement.id == element.id){												
													vm.usuarios.splice(index, 1);
												}
										});
									});
								});
							}
						
					});
					
				});
			}
			
			$scope.$on('empreendimento_has_changed', () => {
				vm.reload();
		    });
			vm.reload();

			vm.pick = function(element, index) {
				vm.dependencia.conjuntos.push(element);
				vm.conjuntos.splice(index, 1);
			}

			vm.unpick = function(element, index) {
				vm.conjuntos.push(element);
				vm.dependencia.conjuntos.splice(index, 1);
			}

			vm.pickResponsaveis = function(element, index) {
					vm.dependencia.responsaveis.push(element);
					vm.usuarios.splice(index, 1);
			}

			vm.unpickResponsaveis = function(element, index) {
				console.log(element);
				vm.usuarios.push(element);
				vm.dependencia.responsaveis.splice(index, 1);
			}

			vm.salvar = function() {
				var data = {
					titulo: vm.dependencia.titulo,
					regras_de_uso: vm.dependencia.regras_de_uso,
					qtd_max_reservas_semanais: vm.dependencia.qtd_max_reservas_semanais,
					qtd_max_hora_reserva: vm.dependencia.qtd_max_hora_reserva,
					hora_inicio_funcionamento: vm.dependencia.hora_inicio_funcionamento,
					hora_fim_funcionamento: vm.dependencia.hora_fim_funcionamento,
					periodicidade: vm.dependencia.periodicidade,
					conjuntos: extractConjuntos(),
					responsaveis:vm.dependencia.responsaveis,
					empreendimento_id: Session.empreendimento.id,
					status : vm.dependencia.status
				};
				
				if(vm.dependencia.id) {
					data['id'] = vm.dependencia.id;
				}

				if(vm.isEditing) {
					DependenciaService.updateDependencia(data).then((response) => {
						if(response.data.success) {
							toastr.success('Dependência alterada com sucesso!');
							$state.go('dependencia');
						} else {
							toastr.error('Não foi possível alterar os dados da Dependência!');
						}
					});
				} else {
					DependenciaService.createDependencia(data).then((response) => {
						if(response.data.success) {
							toastr.success('Dependência cadastrada com sucesso!');
							$state.go('dependencia');
						} else {
							toastr.error('Não foi possível cadastrar a Dependência!');
						}
					});
				}
			}

			function extractConjuntos() {
				var ids = [];
				
				vm.dependencia.conjuntos.forEach((element, index) => {
					ids.push(element.id);
				});

				return ids;
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('DependenciaController', [ 
		'$scope',
		'DependenciaService',
		'DialogService',
		'$state',
		'Session',
		function ($scope, DependenciaService, DialogService, $state, Session) { 
			'use strict'; 
			var vm = this;
			vm.dependencias = [];

			vm.carregarDependencias = function() {
				DependenciaService.getDependencias('?empreendimento=' + Session.empreendimento.id+"&status=all").then((response) => {
					vm.dependencias = response.data.dependencias;
				});
			};
			
			$scope.$on('empreendimento_has_changed', () => {
				vm.carregarDependencias();
		    });
			vm.carregarDependencias();

			vm.delete = function(element) { 
				DialogService.deleteDialog(element.titulo, function() {
					DependenciaService.deleteDependencia(element.id).then((response) => {
						if(response.data.success) {
							DialogService.dialog("Deletado com sucesso!");
							$state.reload();
						} else {
							DialogService.dialog("Não foi possível deletar "+element.titulo, "error");
						}
					})
				});
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('EmpreendimentoCadastroController', [ 
		'EmpreendimentoService',
		'$stateParams',
		'$state',
		'MidiaService',
		'$rootScope',
		'DialogService',
		function (EmpreendimentoService, $stateParams, $state, MidiaService, $rootScope, DialogService) { 
			'use strict'; 
			var vm = this;
			
			vm.isEditing = false;
			$rootScope.timestamp = new Date().getTime();

			if($stateParams.id) {
				vm.isEditing = true;
				EmpreendimentoService.getEmpreendimento($stateParams.id).then((response) => {
					vm.empreendimento = response.data.empreendimento;
					
					if(vm.empreendimento.imagem_background) {
						vm.empreendimento.imageBackgroundPreview = {
							arquivo: vm.empreendimento.imagem_background
						};
					}
					
					if(vm.empreendimento.imagem_logo) {
						vm.empreendimento.imageLogoPreview = {
							arquivo: vm.empreendimento.imagem_logo
						};
					}
				});
			}

			vm.salvar = function() {
				var data = {
					nome_fantasia: vm.empreendimento.nome_fantasia,
			        razao_social: vm.empreendimento.razao_social,
			    	cnpj: vm.empreendimento.cnpj,
			    	nome_responsavel: vm.empreendimento.nome_responsavel,
			    	email: vm.empreendimento.email,
			    	telefone: vm.empreendimento.telefone,
			    	observacao: vm.empreendimento.observacao,
			    	informacoes: vm.empreendimento.informacoes,
			    	slug: vm.empreendimento.slug,
                    app_android: vm.empreendimento.app_android,
                    app_ios: vm.empreendimento.app_ios,
					regras_forum: vm.empreendimento.regras_forum,
					texto_chamado: vm.empreendimento.texto_chamado,
					timestamp: $rootScope.timestamp
				};
				
				if(vm.empreendimento.imageBackgroundPreview) {				
					data['imagem_background'] = vm.empreendimento.imageBackgroundPreview.arquivo;
				}
				if(vm.empreendimento.imageLogoPreview) {				
					data['imagem_logo'] = vm.empreendimento.imageLogoPreview.arquivo;
				}
				
				if(vm.empreendimento.id)
					data['id'] = vm.empreendimento.id;

				if(vm.isEditing) {
					EmpreendimentoService.updateEmpreendimento(data).then((response) => {
						if(response.data.success) {
							toastr.success('Empreendimento alterado com sucesso!');
							$state.go('empreendimento');
						} else {
							toastr.error('Não foi possível alterar os dados do empreendimento!');
						}
					});
				} else {
					EmpreendimentoService.createEmpreendimento(data).then((response) => {
						if(response.data.success) {
							toastr.success('Empreendimento cadastrado com sucesso!');
							$state.go('empreendimento');
						} else {
							toastr.error('Não foi possível cadastrar o Empreeendimento!');
						}
					});
				}
			}
			
			vm.deleteImagemBackground = function() {
				DialogService.deleteDialog('imagem background', function() {
					if(vm.empreendimento.imagem_background) {
						EmpreendimentoService.updateEmpreendimento({id: vm.empreendimento.id, clear_imagem_background: true}).then((response) => {
							DialogService.close();
							delete vm.empreendimento.imageBackgroundPreview;
						});
					} else {
						if(vm.empreendimento.imageBackgroundPreview.id) {
							MidiaService.deleteMidia(vm.empreendimento.imageBackgroundPreview.id).then(response => {
								DialogService.close();
								if(response.data.success)
									delete vm.empreendimento.imageBackgroundPreview;
								else 
									toastr.error('Não foi possível deletar imagem background');
							});
						} else {
							DialogService.close();
							delete vm.empreendimento.imageBackgroundPreview;
							$scope.$apply();
						}
					}
				});
			}
			
			vm.deleteImagemLogo = function() {
				DialogService.deleteDialog('imagem logo', function() {
					if(vm.empreendimento.imagem_logo) {
						EmpreendimentoService.updateEmpreendimento({id: vm.empreendimento.id, clear_imagem_logo: true}).then((response) => {
							DialogService.close();
							delete vm.empreendimento.imageLogoPreview;
						});
					} else {
						if(vm.empreendimento.imageLogoPreview.id) {
							MidiaService.deleteMidia(vm.empreendimento.imageLogoPreview.id).then(response => {
								DialogService.close();
								if(response.data.success)
									delete vm.empreendimento.imageLogoPreview;
								else 
									toastr.error('Não foi possível deletar imagem logo');
							});
						} else {
							DialogService.close();
							delete vm.empreendimento.imageLogoPreview;
							$scope.$apply();
						}
					}
				});
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('EmpreendimentoController', [ 
		'EmpreendimentoService',
		'DialogService',
		'$state',
		function (EmpreendimentoService, DialogService, $state) { 
			'use strict'; 
			var vm = this;
			
			EmpreendimentoService.getEmpreendimentos().then((response) => {
				vm.empreendimentos = response.data.empreendimentos;
			});		

			vm.delete = function(element) {
				DialogService.deleteDialog(element.nome_fantasia, function() {
					EmpreendimentoService.deleteEmpreendimento(element.id).then((response) => {
						if(response.data.success) {
							DialogService.dialog("Deletado com sucesso!");
							$state.reload();
						} else
							DialogService.dialog("Não foi possível deletar "+element.nome_fantasia, "error");
					})
				});
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('FraseCadastroController', [ 
		'FraseService',
		'Session',
		'$stateParams',
		'$state',
		function (FraseService, Session, $stateParams, $state) { 
			'use strict'; 
			var vm = this;
			
			vm.isEditing = false;

			if($stateParams.id) {
				vm.isEditing = true;
				FraseService.getFrase($stateParams.id).then((response) => {
					vm.frase = response.data.frase;
				});
			}

			vm.salvar = function() {
				var data = {
					titulo : vm.frase.titulo,
					empreendimento_id: Session.empreendimento.id
				};

				if(vm.frase.id)
					data['id'] = vm.frase.id;

				if(vm.isEditing) {
					FraseService.updateFrase(data).then((response) => {
						if(response.data.success) {
							toastr.success('Frase alterada com sucesso!');
							$state.go('frase');
						} else {
							toastr.error('Não foi possível alterar os dados da Frase!');
						}
					});
				} else {
					FraseService.createFrase(data).then((response) => {
						if(response.data.success) {
							toastr.success('Frase cadastrada com sucesso!');
							$state.go('frase');
						} else {
							toastr.error('Não foi possível cadastrar a Frase!');
						}
					});
				}
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('FraseController', [ 
		'FraseService',
		'DialogService',
		'Session',
		'$state',
		'$scope',
		function (FraseService, DialogService, Session, $state, $scope) { 
			'use strict'; 
			var vm = this;

			vm.reload = function() {
				FraseService.getFrases('?empreendimento='+Session.empreendimento.id).then((response) => {
					vm.frases = response.data.frases;
				});		
			}

			$scope.$on('empreendimento_has_changed', () => {
				vm.reload();
		    });
			vm.reload();

			vm.delete = function(element) {
				DialogService.deleteDialog(element.titulo, function() {
					FraseService.deleteFrase(element.id).then((response) => {
						if(response.data.success) {
							DialogService.dialog("Deletado com sucesso!");
							$state.reload();
						} else
							DialogService.dialog("Não foi possível deletar "+element.titulo, "error");
					});
				});
			}
		}
	]);
})();
//metronic (4.5.7)
/* Setup general page controller */
app.controller('GeneralPageController', ['$rootScope', '$scope', 'settings', function($rootScope, $scope, settings) {
    $scope.$on('$viewContentLoaded', function() {   
    	// initialize core components
    	App.initAjax();

    	// set default layout mode
    	$rootScope.settings.layout.pageContentWhite = true;
        $rootScope.settings.layout.pageBodySolid = false;
        $rootScope.settings.layout.pageSidebarClosed = false;
    });
}]);

//metronic (4.5.7)
(function() {
	app.controller('MoradiaCadastroController', [ 
		'MoradiaService',
		'Session',
		'ConjuntoService',
		'$stateParams',
		'$state',
		'$scope',
		function (MoradiaService, Session, ConjuntoService, $stateParams, $state, $scope) { 
			'use strict'; 
			var vm = this;
			vm.isEditing = false;

			vm.reload = function() {
				var filters = '?empreendimento=' + Session.empreendimento.id;
				ConjuntoService.getConjuntos(filters).then((response) => {
					vm.conjuntos = response.data.conjuntos;
				});
			}
			
			$scope.$on('empreendimento_has_changed', () => {
				vm.reload();
		    });
			vm.reload();

			angular.element(document).ready(() => {
				$(".select").select2();
			});
			
			if($stateParams.id) {
				vm.isEditing = true;
				MoradiaService.getMoradia($stateParams.id).then((response) => {
					vm.moradia = response.data.moradia;
				});
			}

			vm.salvar = function() {
				var data = {
					identificador: vm.moradia.identificador,
					conjunto_id: vm.moradia.conjunto.id,
					tipo_moradia: vm.moradia.tipo_moradia,
					empreendimento_id: Session.empreendimento.id
				};

				if(vm.moradia.id)
					data['id'] = vm.moradia.id;

				if(vm.isEditing) {
					MoradiaService.updateMoradia(data).then((response) => {
						if(response.data.success) {
							toastr.success('Unidade alterada com sucesso!');
							$state.go('moradia');
						} else {
							toastr.error('Não foi possível alterar os dados da Unidade!');
						}
					});
				} else {
					MoradiaService.createMoradia(data).then((response) => {
						if(response.data.success) {
							toastr.success('Unidade cadastrada com sucesso!');
							$state.go('moradia');
						} else {
							toastr.error('Não foi possível cadastrar a Unidade!');
						}
					});
				}
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('MoradiaController', [ 
		'MoradiaService',
		'DialogService',
		'$state',
		'Session',
		'$scope',
		function (MoradiaService, DialogService, $state, Session, $scope) { 
			'use strict'; 
			var vm = this;

			vm.loadFromPage = function(page) {
				var filters = '?empreendimento='
					+ Session.empreendimento.id
					+ '&offset=' + page
					+ (vm.search ? '&filter=' + vm.search : '');

				MoradiaService.getMoradias(filters).then((response) => {
					vm.moradias = response.data.moradias;
				});
			}

			vm.reload = function() {
				var filter = '?empreendimento='
					+ Session.empreendimento.id
					+ (vm.search ? '&filter=' + vm.search : '');

				vm.paginator = 0;

				MoradiaService.getPages(filter).then((response) => {
					vm.pages = response.data.pages;
					vm.maxElements = response.data.count;
					vm.itemsPerPage = response.data.itemsPerPage;
				});

				vm.loadFromPage(vm.paginator);
			}
			
			$scope.$on('empreendimento_has_changed', () => {
				vm.reload();
		    });
			vm.reload();

			vm.doFilter = function() {
				vm.reload('&filter='+$scope.search);
			}

			vm.delete = function(element) {
				DialogService.deleteDialog(element.identificador, function() {
					MoradiaService.deleteMoradia(element.id).then((response) => {
						if(response.data.success) {
							DialogService.dialog("Deletado com sucesso!");
							$state.reload();
						} else
							DialogService.dialog("Não foi possível deletar "+element.titulo, "error");
					});
				});
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('NotificacaoCadastroConjuntoController', [ 
		'NotificacaoService',
		'ConjuntoService',
		'Session',
		'FraseService',
		'DialogService',
		'$state',
		'$scope',
		function (NotificacaoService, ConjuntoService, Session, FraseService, DialogService, $state, $scope) { 
			'use strict'; 
			var vm = this;
			
			vm.conjuntos = vm.conjuntosSelecionados = [];

			angular.element(document).ready(() => {
				$(".select").select2();
			});

			vm.reload = function() {
				var filters = '?empreendimento='+Session.empreendimento.id;

				FraseService.getFrases(filters).then((response) => {
					vm.frases = response.data.frases;

					angular.element(document).ready(() => {
						$(".select").select2();
					});
				});

				ConjuntoService.getConjuntos(filters).then((response) => {
					vm.conjuntos = response.data.conjuntos;
				});
			}
			
			$scope.$on('empreendimento_has_changed', () => {
				vm.reload();
		    });
			vm.reload();

			vm.pickConjunto = function(element, index) {
				vm.conjuntosSelecionados.push(element);
				vm.conjuntos.splice(index, 1);
			}

			vm.unpickConjunto = function(element, index) {
				vm.conjuntos.push(element);
				vm.conjuntosSelecionados.splice(index, 1);
			}

			vm.enviar = function() {
				var data = {
					conjuntos: getIds(),
					titulo: vm.notificacao.titulo,
					conteudo: vm.notificacao.conteudo,
					autor_id: Session.user.id,
					data_envio: now(),
					empreendimento_id: Session.empreendimento.id
				};

				NotificacaoService.createNotificacao(data).then((response) => {
					if(response.data.success) {
						toastr.success('Notificação cadastrada com sucesso!');
						$state.go('notificacoes');
					} else {
						toastr.error('Não foi possível cadastrar Notificação!');
					}
				});
			}

			function getIds() {
				var ids = [];

				vm.conjuntosSelecionados.forEach((element) => {
					ids.push(element.id);
				});

				return ids;
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('NotificacaoCadastroMensageriaController', [ 
		'NotificacaoService',
		'FraseService',
		'UsuarioService',
		'DialogService',
		'$state',
		'Session',
		'$scope',
		'$rootScope',
		function (NotificacaoService, FraseService, UsuarioService, DialogService, $state, Session, $scope, $rootScope) { 
			'use strict'; 
			
			var vm = this;
            //$rootScope.isUserLogged = true;
			vm.usuarios = [];
			vm.usuariosSelecionados = [];
			vm.notificacao = { conteudo: '', usuario_responsavel: { nome: '' } };

			angular.element(document).ready(() => {
				$(".select").select2();
			});
					
			vm.doFilter = function() {
				var filter = '?empreendimento='
					+ Session.empreendimento.id
					+ '&enabled=true'
					+ '&filter='+vm.notificacao.usuario_responsavel.nome + '&with_player_id=true';

				if( ! vm.isEditing) {
					UsuarioService.getUsuarios(filter).then((response) => {
						vm.usuarios.length = 0;
						
						response.data.usuarios.forEach(usuario => {
							usuario.label = '<b>' + usuario.nome + '</b><br />' + usuario.moradias.map(
								moradia => moradia.identificador 
									+ ' (' + moradia.conjunto.titulo + ')').join('<br/>');

							vm.usuarios.push(usuario);
						});
					});	
				}
			}

			vm.reload = function() {
				var filters = '?empreendimento=' + Session.empreendimento.id + '&with_player_id=true'; 
				
				FraseService.getFrases(filters).then((response) => {
					vm.frases = response.data.frases;

					angular.element(document).ready(() => {
						$(".select").select2();
					});
				});

				vm.doFilter();
			}
			
			$scope.$on('empreendimento_has_changed', () => {
				vm.reload();
		    });
			vm.reload();

			vm.pickUsuario = function(element, index) {
				if(vm.usuariosSelecionados.length === 0) {
					vm.usuariosSelecionados.push(element);
					vm.notificacao.conteudo = $scope.acao_select;
					vm.show_box = false;
				} else {
					vm.notificacao.conteudo = $scope.acao_select;
					toastr.error('Mensageria só pode enviar notificações para um usuário por vez');
				}
			}

			vm.unpickUsuario = function(element, index) {
				vm.notificacao.conteudo = $scope.acao_select;
				vm.usuariosSelecionados.splice(index, 1);
			}

			vm.enviar = function() {
				vm.notificacao.titulo = "Notificação da Mensageria";
				vm.notificacao.conteudo = vm.notificacao.conteudo.replace("XXXXXXXXXX", vm.usuariosSelecionados[0].nome);

				var data = {
					usuarios: getIds(),
					titulo: vm.notificacao.titulo,
					conteudo: vm.notificacao.conteudo,
					autor_id: Session.user.id,
					data_envio: now(),
					empreendimento_id: Session.empreendimento.id
				}

				NotificacaoService.createNotificacao(data).then((response) => {
					if(response.data.success) {
						toastr.success('Notificação cadastrada com sucesso!');
						$state.go('notificacoes');
					} else {
						toastr.error('Não foi possível cadastrar Notificação!');
					}
				});
			}

			function getIds() {
				var ids = [];

				vm.usuariosSelecionados.forEach((element) => {
					ids.push(element.id);
				});

				return ids;
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('NotificacaoCadastroUsuarioController', [ 
		'NotificacaoService',
		'FraseService',
		'UsuarioService',
		'DialogService',
		'$state',
		'Session',
		'$scope',
		function (NotificacaoService, FraseService, UsuarioService, DialogService, $state, Session, $scope) { 
			'use strict'; 
			var vm = this;
			vm.usuarios = [];
			vm.usuariosSelecionados = [];
			vm.notificacao = { conteudo: '', usuario_responsavel: { nome: '' } };

			angular.element(document).ready(() => {
				$(".select").select2();
			});
					
			vm.doFilter = function() {
				var filter = '?empreendimento='
					+ Session.empreendimento.id
					+ '&enabled=true'
					+ '&filter='+vm.notificacao.usuario_responsavel.nome + '&with_player_id=true';

				if( ! vm.isEditing) {
					UsuarioService.getUsuarios(filter).then((response) => {
						vm.usuarios.length = 0;
						
						response.data.usuarios.forEach(usuario => {
							usuario.label = '<b>' + usuario.nome + '</b><br />' + usuario.moradias.map(
								moradia => moradia.identificador 
									+ ' (' + moradia.conjunto.titulo + ')').join('<br/>');

							vm.usuarios.push(usuario);
						});
					});	
				}
			}

			$scope.$on('empreendimento_has_changed', () => {
				vm.doFilter();
		    });
			vm.doFilter();

			vm.pickUsuario = function(element, index) {
				vm.show_box = false;
				vm.usuariosSelecionados.push(element);
			}

			vm.unpickUsuario = function(element, index) {
				vm.usuariosSelecionados.splice(index, 1);
			}

			vm.enviar = function() {
				var data = {
					usuarios: getIds(),
					titulo: vm.notificacao.titulo,
					conteudo: vm.notificacao.conteudo,
					autor_id: Session.user.id,
					data_envio: now(),
					empreendimento_id: Session.empreendimento.id
				}

				NotificacaoService.createNotificacao(data).then((response) => {
					if(response.data.success) {
						toastr.success('Notificação cadastrada com sucesso!');
						$state.go('notificacoes');
					} else {
						toastr.error('Não foi possível cadastrar Notificação!');
					}
				});
			}

			function getIds() {
				var ids = [];

				vm.usuariosSelecionados.forEach((element) => {
					ids.push(element.id);
				});

				return ids;
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('NotificacoesController', [ 
		'NotificacaoService',
		'Session',
		'DialogService',
		'$state',
		function (NotificacaoService, Session, DialogService, $state) { 
			'use strict'; 
			var vm = this;
			
			vm.loadMore = function() {
				var filters = '?empreendimento=' 
					+ Session.empreendimento.id
					+ '&offset=' + vm.paginator;

				NotificacaoService.getNotificacoes(filters).then((response) => {
					vm.notificacoes = response.data.notificacoes;
				});
			}

			vm.reload = function(reload_filter) {
				var filters = '?empreendimento=' + Session.empreendimento.id;

				NotificacaoService.getPages(filters).then((response) => {
					vm.pages = response.data.pages;
					vm.maxElements = response.data.count;
					vm.itemsPerPage = response.data.itemsPerPage;

					vm.loadMore(filters + reload_filter);
				});				
			}

			vm.reload();

			vm.delete = function(element) {
				DialogService.deleteDialog(element.titulo, function() {
					NotificacaoService.deleteNotificacao(element.id).then((response) => {
						if(response.data.success) {
							DialogService.dialog("Deletado com sucesso!");
							$state.reload();
						} else
							DialogService.dialog("Não foi possível deletar "+element.titulo, "error");
					});
				});
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('PermissaoCadastroController', [ 
		'PermissaoService',
		'$stateParams',
		'$state',
		function (PermissaoService, $stateParams, $state) { 
			'use strict'; 
			var vm = this;
			
			vm.isEditing = false;

			if($stateParams.id) {
				vm.isEditing = true;
				PermissaoService.getPermissao($stateParams.id).then((response) => {
					vm.permissao = response.data.permissao;
				});
			}

			vm.salvar = function() {
				var data = {
					titulo : vm.permissao.titulo,
					label : vm.permissao.label
				};

				if(vm.permissao.id)
					data['id'] = vm.permissao.id;

				if(vm.isEditing) {
					PermissaoService.updatePermissao(data).then((response) => {
						if(response.data.success) {
							toastr.success('Permissão alterada com sucesso!');
							$state.go('permissao');
						} else {
							toastr.error('Não foi possível alterar os dados da Permissão!');
						}
					});
				} else {
					PermissaoService.createPermissao(data).then((response) => {
						if(response.data.success) {
							toastr.success('Permissão cadastrada com sucesso!');
							$state.go('permissao');
						} else {
							toastr.error('Não foi possível cadastrar a Permissão!');
						}
					});
				}
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('PermissaoController', [ 
		'PermissaoService',
		'DialogService',
		'$state',
		function (PermissaoService, DialogService, $state) { 
			'use strict'; 
			var vm = this;
			
			PermissaoService.getPermissoes().then((response) => {
				vm.permissoes = response.data.permissoes;
			});		

			vm.delete = function(element) {
				DialogService.deleteDialog(element.titulo, function() {
					PermissaoService.deletePermissao(element.id).then((response) => {
						if(response.data.success) {
							DialogService.dialog("Deletado com sucesso!");
							$state.reload();
						} else
							DialogService.dialog("Não foi possível deletar "+element.titulo, "error");
					});
				});
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('ClassificadoCadastroController', [ 
		'$stateParams',
		'PostService',
		'Session',
		'$state',
		'UsuarioService',
		'MidiaService',
		'appConfig',
		'$scope',
		'DialogService',
		'$rootScope',
		function ($stateParams, PostService, Session, $state, UsuarioService, MidiaService, appConfig, $scope, DialogService, $rootScope) { 
			'use strict'; 
			var vm = this;
			
			vm.submitBlocked = false;
			vm.isEditing = false;
			vm.categories = PostService.getCategories();
			vm.tipo_post_selecionado = {};
			vm.post = {
				imagens: [], 
				data_postagem: new Date(),
				conteudo: ' '
			};
			vm.imagens = [];
			vm.autor = {nome: ""};
			$rootScope.timestamp = new Date().getTime();
			
			vm.doFilter = function() {
				var filters = '?empreendimento=' 
					+ Session.empreendimento.id
					+ '&enabled=true'
					+ '&filter=' + vm.autor.nome;	
				
				UsuarioService.getUsuarios(filters).then((response) => {
					vm.usuarios = response.data.usuarios;
				});		
			}

			vm.pickAutor = function(autor) {
				vm.autor = autor;
				vm.show_box = false;
			}

			vm.reloadPosts = function() {			
				var filter = '?empreendimento=' + 
					Session.empreendimento.id + 
					'&post_type=' + appConfig.post_types.classificado;

				// PostService.getPosts(filter).then((response) => {
				// 	vm.posts = response.data.post;
				// });		

				PostService.getTiposPost(filter).then((response) => {
					vm.tipos_post = response.data.tipos_post;
				});		
			}

			vm.deleteImagemDestacada = function() {
				DialogService.deleteDialog('imagem destacada', function() {
					if(vm.post.imagem_destacada) {
						PostService.updatePost({id: vm.post.id, clear_imagem_destacada: true}).then((response) => {
							DialogService.close();
							delete vm.post.preview;
						});
					} else {
						if(vm.post.preview.id) {
							MidiaService.deleteMidia(vm.post.preview.id).then(response => {
								DialogService.close();
								if(response.data.success)
									delete vm.post.preview;
								else 
									toastr.error('Não foi possível deletar imagem destacada');
							});
						} else {
							DialogService.close();
							delete vm.post.preview;
							$scope.$apply();
						}
					}
				});
			}

			$scope.$on('empreendimento_has_changed', () => {
			    vm.reloadPosts();
		    });
			vm.reloadPosts();

			angular.element(document).ready(() => {
				$(".select").select2();
			});

			if($stateParams.id) {
				vm.isEditing = true;

				PostService.getPost($stateParams.id).then((response) => {
					vm.post = response.data.post;
					vm.post.data_postagem = new Date(vm.post.data_postagem.timestamp);

					vm.reloadPosts();
					
					if(vm.post.usado !== 'Novo') {
						vm.post.estado_usado = vm.post.usado;
						vm.post.usado = true;
					} else {
						vm.post.usado = false;
					}
					
					vm.autor = vm.post.autor;
					
					if(vm.post.imagem_destacada) {
						vm.post.preview = {
							arquivo: vm.post.imagem_destacada
						};	
					}

					vm.post.imagens = [];

					vm.post.midias.forEach((element) => {
						if(element.type === appConfig.midia_type.imagem)
							vm.post.imagens.push(element);
					});
				});		
			}

			vm.apagarMidia = function(element, index) {
				DialogService.deleteDialog(element.descricao, function() {
					if(element.id) {
						MidiaService.deleteMidia(element.id).then((response) => {
							if(response.data.success) {
								DialogService.close();
								vm.post.imagens.splice(index, 1);
							} else 
								toastr.error('Não foi possível remover '+element.descricao);
						});
					} else {
						vm.post.imagens.splice(index, 1);
						DialogService.close();
						$scope.$apply();
					}
				});
			}

			vm.salvar = function() {
				vm.submitBlocked = true;

				var data = {
					conteudo: vm.post.conteudo,
					post_type: appConfig.post_types.classificado,
					titulo: vm.post.titulo,
					usuario_id: vm.autor.id ? vm.autor.id : Session.user.id,
					empreendimento_id: Session.empreendimento.id,
					preco: vm.post.preco,
					data_postagem: now(vm.post.data_postagem),
					timestamp: $rootScope.timestamp,
					usado: vm.post.usado ? 'Usado por ' + vm.post.estado_usado : 'Novo',
					imagens: vm.post.imagens
				};
				
				if(vm.post.tipo_post) {
					data['post_tipo_id'] = vm.post.tipo_post.id;
				}

				if(vm.post.preview) {
					data['imagem_destacada'] = vm.post.preview.arquivo;
				}
				
				if(vm.post.id){
					data['data_ultima_edicao'] = now();
					data['id'] = vm.post.id;
				}

				if(vm.isEditing) {
					PostService.updatePost(data).then((response) => {
						if(response.data.success) {
							toastr.success('Classificado alterado com sucesso!');
							$state.go('classificado');
						} else {
							toastr.error('Não foi possível alterar os dados do Classificado!');
						}
					});
				} else {
					PostService.createPost(data).then((response) => {
						if(response.data.success) {
							toastr.success('Classificado cadastrado com sucesso!');
							$state.go('classificado');
						} else {
							toastr.error('Não foi possível cadastrar o Classificado!');
						}
					});
				}
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('ClassificadoController', [
		'PostService',
		'DialogService',
		'$state',
		'Session',
		'appConfig',
		'$scope',
		function (PostService, DialogService, $state, Session, appConfig, $scope) {
			'use strict';
			var vm = this;
      vm.search = null;

			vm.loadMore = function(filter) {
				var filters = '?empreendimento='
					+ Session.empreendimento.id
					+ '&post_type=' + appConfig.post_types.classificado
					+ '&offset=' + vm.paginator
					+ (vm.search !== null && vm.search !== undefined && vm.search !== '' ? vm.search : '');

				PostService.getPosts(filters).then((response) => {
					vm.posts = response.data.post;
				});
			}

			vm.reloadPosts = function(filter_view) {
				vm.paginator = 0;

				var filter = '?empreendimento=' +
					Session.empreendimento.id +
					'&post_type=' + appConfig.post_types.classificado + (vm.search !== null && vm.search !== undefined && vm.search !== '' ? vm.search : '');

				PostService.getPages(filter).then((response) => {
					vm.pages = response.data.pages;
					vm.maxElements = response.data.count;
					vm.itemsPerPage = response.data.itemsPerPage;

					vm.loadMore(filter_view);
				});
			}

			$scope.$on('empreendimento_has_changed', () => {
			    vm.reloadPosts();
		    });
			vm.reloadPosts();

			vm.doFilter = function() {
        vm.search = '&filter='+$scope.search;
				vm.reloadPosts('&filter='+$scope.search);
			}

			vm.delete = function(element) {
				DialogService.deleteDialog(element.titulo, function() {
					PostService.deletePost(element.id).then((response) => {
						if(response.data.success) {
							DialogService.dialog("Deletado com sucesso!");
							$state.reload();
						} else
							DialogService.dialog("Não foi possível deletar "+element.titulo, "error");
					});
				});
			}
		}
	]);
})();

//metronic (4.5.7)
(function() {
	app.controller('DestaquesController', [ 
		'PostService',
		'Session',
		'appConfig',
		'$scope',
		function (PostService, Session, appConfig, $scope) { 
			'use strict'; 
			var vm = this;
			
			vm.posts = vm.posts_selecionados = [];
			vm.post = {nome: ''};
			
			vm.updateOrdem = function() {
				var data = {
					id: 0,
					update_ordem: true,
					items : vm.posts_selecionados.map(element => {
						return {
							id: element.id,
							ordem_destaque: element.ordem_destaque
						}
					})
				};

				PostService.updatePost(data).then(response => {
					if(response.data.success) {
						toastr.success('Posts ordenados com sucesso!');
					} else {
						toastr.error('Não foi possível atualizar a ordem dos posts');
					}
				});
			}

			vm.reloadPosts = function() {			
				var filter = '?empreendimento=' + 
					Session.empreendimento.id + 
					'&except=' + appConfig.post_types.classificado;

				PostService.getPosts(filter+'&is_destaque=1').then((response) => {
					vm.posts_selecionados = response.data.post;
				});		
			}
			$scope.$on('empreendimento_has_changed', () => {
			    vm.reloadPosts();
		    });
			vm.reloadPosts();

			vm.doFilter = function() {
				var filter = '?empreendimento=' + 
					Session.empreendimento.id + 
					'&except=' + appConfig.post_types.classificado
					+ '&is_destaque=0&filter='+vm.post.nome;

				PostService.getPosts(filter).then((response) => {
					vm.posts = response.data.post;
				});		
			}

			vm.pickDestaque = function(element, index) {
				if( ! Session.user.permissoes_usuario.add_destaque) {
					toastr.error('Você não tem permissão para adicionar novos destaques');
					return;
				}

				vm.post = {nome:''};
				vm.show_box = false;
				vm.posts = [];
				vm.posts_selecionados.push(element);
				marcar(element, 1);
			}

			vm.unpickDestaque = function(element, index) {
				if( ! Session.user.permissoes_usuario.delete_destaque) {
					toastr.error('Você não tem permissão para remover destaques');
					return;
				}

				marcar(element, 0);
				vm.posts_selecionados.splice(index, 1);
			}

			function marcar(element, status) {
				var data = {
					id: element.id,
					is_destaque: status
				}

				PostService.updatePost(data).then((response) => {
					if(response.data.success) 
						toastr.success('O post \" ' + element.titulo + '\" foi '+ (status == 1 ? 'marcado' : 'desmarcado') +' como destaque com sucesso');
					else
						toastr.error('Não foi possível '+ (status == 1 ? 'marcar' : 'desmarcar') +' o post \"'+ element.titulo +'\" como destaque');
				});
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('DocumentoNaoAuditadoCadastroController', [
		'$stateParams',
		'PostService',
		'Session',
		'$state',
		'MidiaService',
		'appConfig',
		'$scope',
		'DialogService',
		'$rootScope',
		function ($stateParams, PostService, Session, $state, MidiaService, appConfig, $scope, DialogService, $rootScope) {
			'use strict';
			var vm = this;

			vm.submitBlocked = false;
			vm.isEditing = false;
			vm.categories = PostService.getCategories();
			vm.tipo_post_selecionado = {};
			vm.anexos = [];
			vm.imagens = [];
			vm.post = {
				anexos: [],
				imagens: [],
				conteudo: ' '
			};
			$rootScope.timestamp = new Date().getTime();

			vm.reloadPosts = function() {
				var filter = '?empreendimento=' +
					Session.empreendimento.id +
					'&post_type=' + appConfig.post_types.documento_nao_auditado;

				PostService.getTiposPost(filter).then((response) => {
					vm.tipos_post = response.data.tipos_post;
				});
			}

			vm.deleteImagemDestacada = function() {
				DialogService.deleteDialog('imagem destacada', function() {
					if(vm.post.imagem_destacada) {
						PostService.updatePost({id: vm.post.id, clear_imagem_destacada: true}).then((response) => {
							DialogService.close();
							delete vm.post.preview;
						});
					} else {
						if(vm.post.preview.id) {
							MidiaService.deleteMidia(vm.post.preview.id).then(response => {
								DialogService.close();
								if(response.data.success)
									delete vm.post.preview;
								else
									toastr.error('Não foi possível deletar imagem destacada');
							});
						} else {
							DialogService.close();
							delete vm.post.preview;
							$scope.$apply();
						}
					}
				});
			}

			$scope.$on('empreendimento_has_changed', () => {
				vm.reloadPosts();
		    });
			vm.reloadPosts();

			angular.element(document).ready(() => {
				$(".select").select2();
			});

			if($stateParams.id) {
				vm.isEditing = true;

				PostService.getPost($stateParams.id).then((response) => {
					vm.post = response.data.post;
					vm.post.data_postagem = new Date(vm.post.data_postagem.timestamp);
					// vm.post.data_postagem = vm.post.data_postagem.toLocaleString();
					// vm.post.data_postagem = vm.post.data_postagem.substring(0, vm.post.data_postagem.length - 3);

					if(vm.post.imagem_destacada) {
						vm.post.preview = {
							arquivo: vm.post.imagem_destacada
						};
					}

					vm.reloadPosts();

					vm.categories.forEach((element) => {
						if(element.post_type === vm.post.post_type) {
							vm.post.post_type = element;
							return;
						}
					});

					vm.post.anexos = [];
					vm.post.imagens = [];

					vm.post.midias.forEach((element) => {
						if(element.type === appConfig.midia_type.imagem)
							vm.post.imagens.push(element);
						else if(element.type == appConfig.midia_type.anexo)
							vm.post.anexos.push(element);
					});
				});
			}

			vm.apagarMidia = function(element, index, from) {
				DialogService.deleteDialog(element.descricao, function() {
					if(element.id) {
						MidiaService.deleteMidia(element.id).then((response) => {
							if(response.data.success) {
								DialogService.close();
								vm.post[from === 'galeria' ? 'imagens' : 'anexos' ].splice(index, 1);
							} else
								toastr.error('Não foi possível remover '+element.descricao);
						});
					} else {
						vm.post[from === 'galeria' ? 'imagens' : 'anexos' ].splice(index, 1);
						DialogService.close();
						$scope.$apply();
					}
				});
			}

			vm.salvar = function() {
				vm.submitBlocked = true;

				var data = {
					conteudo: vm.post.conteudo,
					post_type: appConfig.post_types.documento_nao_auditado,
					titulo: vm.post.titulo,
					usuario_id: Session.user.id,
					empreendimento_id: Session.empreendimento.id,
					timestamp: $rootScope.timestamp,
					anexos: vm.post.anexos,
					caminho_anexo: vm.post.caminho_anexo,
					imagens: vm.post.imagens,
					data_postagem: now(vm.post.data_postagem)
				};

				if(vm.post.tipo_post) {
					data['post_tipo_id'] = vm.post.tipo_post.id;
				}

				if(vm.post.preview) {
					data['imagem_destacada'] = vm.post.preview.arquivo;
				}

				if(vm.post.id) {
					data['data_ultima_edicao'] = now();
					data['id'] = vm.post.id;
				}

				if(vm.isEditing) {
					PostService.updatePost(data).then((response) => {
						if(response.data.success) {
							toastr.success('Documento alterado com sucesso!');
							$state.go('documento-nao-auditado');
						} else {
							toastr.error('Não foi possível alterar os dados do documento auditado!');
						}
					});
				} else {
					PostService.createPost(data).then((response) => {
						if(response.data.success) {
							toastr.success('Documento cadastrado com sucesso!');
							$state.go('documento-nao-auditado');
						} else {
							toastr.error('Não foi possível cadastrar a documento!');
						}
					});
				}
			}
		}
	]);
})();

//metronic (4.5.7)
(function() {
	app.controller('DocumentoNaoAuditadoController', [
		'PostService',
		'DialogService',
		'$state',
		'Session',
		'appConfig',
		'$scope',
		function (PostService, DialogService, $state, Session, appConfig, $scope) {
			'use strict';
			var vm = this;
      vm.search = null;
			vm.loadMore = function(filter) {
				var filters = '?empreendimento='
					+ Session.empreendimento.id +
					'&post_type=' + appConfig.post_types.documento_nao_auditado + '&offset=' + vm.paginator
					+ (vm.search !== null && vm.search !== undefined && vm.search !== '' ? vm.search : '');

				PostService.getPosts(filters).then((response) => {
					vm.posts = response.data.post;
				});
			}

			vm.reloadPosts = function(filter_view) {
				vm.paginator = 0;

				var filter = '?empreendimento=' +
					Session.empreendimento.id +
					'&post_type=' + appConfig.post_types.documento_nao_auditado + (vm.search !== null && vm.search !== undefined && vm.search !== '' ? vm.search : '');

				PostService.getPages(filter).then((response) => {
					vm.pages = response.data.pages;
					vm.maxElements = response.data.count;
					vm.itemsPerPage = response.data.itemsPerPage;

					vm.loadMore(filter_view);
				});
			}

			$scope.$on('empreendimento_has_changed', () => {
				vm.reloadPosts();
		    });
			vm.reloadPosts();

			vm.doFilter = function() {
        vm.search = '&filter='+$scope.search;
				vm.reloadPosts('&filter='+$scope.search);
			}

			vm.delete = function(element) {
				DialogService.deleteDialog(element.titulo, function() {
					PostService.deletePost(element.id).then((response) => {
						if(response.data.success) {
							$state.reload();
							DialogService.dialog("Deletado com sucesso!");
						} else
							DialogService.dialog("Não foi possível deletar "+element.titulo, "error");
					});
				});
			}
		}
	]);
})();

//metronic (4.5.7)
(function() {
	app.controller('EventoCadastroController', [
		'$stateParams',
		'PostService',
		'Session',
		'$state',
		'MidiaService',
		'appConfig',
		'$scope',
		'DialogService',
		'$rootScope',
		function ($stateParams, PostService, Session, $state, MidiaService, appConfig, $scope, DialogService, $rootScope) {
			'use strict';
			var vm = this;

			var date = new Date();

			vm.submitBlocked = false;
			vm.isEditing = false;
			vm.categories = PostService.getCategories();
			vm.tipo_post_selecionado = {};
			vm.anexos = [];
			vm.imagens = [];
			vm.post = {
				imagens: [],
				anexos: [],
				data_postagem: date,
				post_meta: [
					{
						meta_key: 'Data de Início',
						meta_value: date,
						meta_type: 'date'
					},
					{
						meta_key: 'Data de Término',
						meta_value: date,
						meta_type: 'date'
					},
					{
						meta_key: 'Local do Evento',
						meta_value: '',
						meta_type: 'text'
					}
				],
				conteudo: ' '
			};
			$rootScope.timestamp = new Date().getTime();

			vm.deleteImagemDestacada = function() {
				DialogService.deleteDialog('imagem destacada', function() {
					if(vm.post.imagem_destacada) {
						PostService.updatePost({id: vm.post.id, clear_imagem_destacada: true}).then((response) => {
							DialogService.close();
							delete vm.post.preview;
						});
					} else {
						if(vm.post.preview.id) {
							MidiaService.deleteMidia(vm.post.preview.id).then(response => {
								DialogService.close();
								if(response.data.success)
									delete vm.post.preview;
								else
									toastr.error('Não foi possível deletar imagem destacada');
							});
						} else {
							DialogService.close();
							delete vm.post.preview;
							$scope.$apply();
						}
					}
				});
			}

			vm.reloadPosts = function() {
				var filter = '?empreendimento=' +
					Session.empreendimento.id +
					'&post_type=' + appConfig.post_types.evento;

				PostService.getPosts(filter).then((response) => {
					vm.posts = response.data.post;
				});

				PostService.getTiposPost(filter).then((response) => {
					vm.tipos_post = response.data.tipos_post;
				});
			}

			$scope.$on('empreendimento_has_changed', () => {
			    vm.reloadPosts();
		    });
			vm.reloadPosts();

			angular.element(document).ready(() => {
				$(".select").select2();
			});

			if($stateParams.id) {
				vm.isEditing = true;

				PostService.getPost($stateParams.id).then((response) => {
					vm.post = response.data.post;
					vm.post.data_postagem = new Date(vm.post.data_postagem.timestamp);

					vm.post.post_meta.forEach(element => {
						if(element['meta_key'].startsWith('Data'))
							element['meta_value'] = new Date(element.meta_value.timestamp);
					});

					vm.reloadPosts();

					if(vm.post.imagem_destacada !== null && vm.post.imagem_destacada.length > 0) {
						vm.post.preview = {
							arquivo: vm.post.imagem_destacada
						};
					}

					vm.post.anexos = [];
					vm.post.imagens = [];

					vm.post.midias.forEach((element) => {
						if(element.type === appConfig.midia_type.anexo)
							vm.post.anexos.push(element);
						else if(element.type === appConfig.midia_type.imagem)
							vm.post.imagens.push(element);
					});
				});
			}

			vm.apagarMidia = function(element, index, from) {
				DialogService.deleteDialog(element.descricao, function() {
					if(element.id) {
						MidiaService.deleteMidia(element.id).then((response) => {
							if(response.data.success) {
								DialogService.close();
								vm.post[from === 'galeria' ? 'imagens' : 'anexos' ].splice(index, 1);
							} else
								toastr.error('Não foi possível remover '+element.descricao);
						});
					} else {
						vm.post[from === 'galeria' ? 'imagens' : 'anexos' ].splice(index, 1);
						DialogService.close();
						$scope.$apply();
					}
				});
			}

			vm.salvar = function() {
				vm.submitBlocked = true;

				var data = {
					conteudo: vm.post.conteudo,
					post_type: appConfig.post_types.evento,
					titulo: vm.post.titulo,
					usuario_id: Session.user.id,
					empreendimento_id: Session.empreendimento.id,
          anexos: vm.post.anexos,
          caminho_anexo: vm.post.caminho_anexo,
					timestamp: $rootScope.timestamp,
					imagens: vm.post.imagens,
					data_postagem: now(vm.post.data_postagem),
					post_meta: vm.post.post_meta.map(element => {
						if(element.meta_type === 'date') {
							element.meta_value = element.meta_value.getTime() / 1000;
							element.meta_type = 'date';
						} else {
							element.meta_type = 'text';
						}

						return element;
					}),
				};

				if(vm.post.tipo_post) {
					data['post_tipo_id'] = vm.post.tipo_post.id;
				}

				if(vm.post.preview) {
					data['imagem_destacada'] = vm.post.preview.arquivo;
				}

				if(vm.post.id){
					data['data_ultima_edicao'] = now();
					data['id'] = vm.post.id;
				}

				if(vm.isEditing) {
					PostService.updatePost(data).then((response) => {
						if(response.data.success) {
							toastr.success('Evento alterado com sucesso!');
							$state.go('evento');
						} else {
							toastr.error('Não foi possível alterar os dados do Evento!');
						}
					});
				} else {
					PostService.createPost(data).then((response) => {
						if(response.data.success) {
							toastr.success('Evento cadastrado com sucesso!');
							$state.go('evento');
						} else {
							toastr.error('Não foi possível cadastrar o Evento!');
						}
					});
				}
			}
		}
	]);
})();

//metronic (4.5.7)
(function() {
	app.controller('EventoController', [
		'PostService',
		'DialogService',
		'$state',
		'Session',
		'appConfig',
		'$scope',
		function (PostService, DialogService, $state, Session, appConfig, $scope) {
			'use strict';
			var vm = this;
      vm.search = null;

			angular.element(document).ready(() => {
				$(".select").select2();
			});

			vm.reloadPosts = function(filter_view) {
				vm.paginator = 0;

				var filter = '?empreendimento=' +
					Session.empreendimento.id +
					'&post_type=' + appConfig.post_types.evento
					+ (vm.filter_date ? vm.filter_date : '')
					+ (vm.search !== null && vm.search !== undefined && vm.search !== '' ? vm.search : '');

				PostService.getPages(filter).then((response) => {
					vm.pages = response.data.pages;
					vm.maxElements = response.data.count;
					vm.itemsPerPage = response.data.itemsPerPage;

					vm.loadMore(filter_view);
				});
			}

			vm.selectFilterChanged = function() {
				vm.filter_date = vm.filter_select !== 'todos' ? '&filter_date='+vm.filter_select+'&date=' + Date.now() : '';
				vm.reloadPosts();
			}

			vm.loadMore = function(filter) {
				var filters = '?empreendimento='
					+ Session.empreendimento.id
					+ '&post_type=' + appConfig.post_types.evento
					+ '&offset=' + vm.paginator
					+ (vm.filter_date ? vm.filter_date : '')
					+ (vm.search !== null && vm.search !== undefined && vm.search !== '' ? vm.search : '');

				PostService.getPosts(filters).then((response) => {
					vm.posts = response.data.post;
				});
			}

			$scope.$on('empreendimento_has_changed', () => {
			    vm.reloadPosts();
		    });
			vm.reloadPosts();

			vm.doFilter = function() {
        vm.search = '&filter='+$scope.search;
				vm.reloadPosts('&filter='+$scope.search);
			}

			vm.delete = function(element) {
				DialogService.deleteDialog(element.titulo, function() {
					PostService.deletePost(element.id).then((response) => {
						if(response.data.success) {
							DialogService.dialog("Deletado com sucesso!");
							$state.reload();
						} else
							DialogService.dialog("Não foi possível deletar "+element.titulo, "error");
					});
				});
			}
		}
	]);
})();

//metronic (4.5.7)
(function() {
	app.controller('ForumCadastroController', [ 
		'$stateParams',
		'PostService',
		'Session',
		'$state',
		'appConfig',
		'$scope',
		function ($stateParams, PostService, Session, $state, appConfig, $scope) { 
			'use strict'; 
			var vm = this;
			
			vm.submitBlocked = false;
			vm.isEditing = false;
			vm.categories = PostService.getCategories();
			vm.tipo_post_selecionado = {};
			vm.post = {
				data_postagem: new Date(),
				conteudo: ' '
			}

			vm.reloadPosts = function() {			
				var filter = '?empreendimento=' + 
					Session.empreendimento.id + 
					'&post_type=' + appConfig.post_types.forum;

				PostService.getTiposPost(filter).then((response) => {
					vm.tipos_post = response.data.tipos_post;
				});		
			}
			
			$scope.$on('empreendimento_has_changed', () => {
			    vm.reloadPosts();
		    });
			vm.reloadPosts();

			angular.element(document).ready(() => {
				$(".select").select2();
			});

			if($stateParams.id) {
				vm.isEditing = true;

				PostService.getPost($stateParams.id).then((response) => {
					vm.post = response.data.post;
					vm.post.data_postagem = new Date(vm.post.data_postagem.timestamp);
				});		
			}

			vm.salvar = function() {
				vm.submitBlocked = true;

				var data = {
					conteudo: vm.post.conteudo,
					post_type: appConfig.post_types.forum,
					titulo: vm.post.titulo,
					usuario_id: Session.user.id,
					empreendimento_id: Session.empreendimento.id,
					data_postagem: now(vm.post.data_postagem)
				};
				
				if(vm.post.tipo_post) {
					data['post_tipo_id'] = vm.post.tipo_post.id
				}

				if(vm.post.id){
					data['data_ultima_edicao'] = now();
					data['id'] = vm.post.id;
				}

				if(vm.isEditing) {
					PostService.updatePost(data).then((response) => {
						if(response.data.success) {
							toastr.success('Postagem Fórum alterada com sucesso!');
							$state.go('forum');
						} else {
							toastr.error('Não foi possível alterar os dados da Postagem Fórum!');
						}
					});
				} else {
					PostService.createPost(data).then((response) => {
						if(response.data.success) {
							toastr.success('Postagem Fórum cadastrada com sucesso!');
							$state.go('forum');
						} else {
							toastr.error('Não foi possível cadastrar a Postagem Fórum!');
						}
					});
				}
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('ForumController', [
		'PostService',
		'DialogService',
		'$state',
		'Session',
		'appConfig',
		'$scope',
		function (PostService, DialogService, $state, Session, appConfig, $scope) {
			'use strict';
			var vm = this;
      vm.search = null;

			vm.loadMore = function(filter) {
				var filters = '?empreendimento='
					+ Session.empreendimento.id
					+ '&post_type=' + appConfig.post_types.forum + '&offset=' + vm.paginator
					+ (vm.search !== null && vm.search !== undefined && vm.search !== '' ? vm.search : '');

				PostService.getPosts(filters).then((response) => {
					vm.posts = response.data.post;
				});
			}

			vm.reloadPosts = function(filter_view) {
				vm.paginator = 0;

				var filter = '?empreendimento=' +
					Session.empreendimento.id +
					'&post_type=' + appConfig.post_types.forum + (vm.search !== null && vm.search !== undefined && vm.search !== '' ? vm.search : '');

				PostService.getPages(filter).then((response) => {
					vm.pages = response.data.pages;
					vm.maxElements = response.data.count;
					vm.itemsPerPage = response.data.itemsPerPage;

					vm.loadMore(filter_view);
				});
			}

			$scope.$on('empreendimento_has_changed', () => {
			    vm.reloadPosts();
		    });
			vm.reloadPosts();

			vm.doFilter = function() {
        vm.search = '&filter='+$scope.search;
				vm.reloadPosts('&filter='+$scope.search);
      }

      //backupt 22/08/2019 icaro
			// vm.doFilter = function() {
			// 	vm.reloadPosts('&filter='+$scope.search);
			// }

			vm.delete = function(element) {
				DialogService.deleteDialog(element.titulo, function() {
					PostService.deletePost(element.id).then((response) => {
						if(response.data.success) {
							DialogService.dialog("Deletado com sucesso!");
							$state.reload();
						} else
							DialogService.dialog("Não foi possível deletar "+element.titulo, "error");
					});
				});
			}
		}
	]);
})();

//metronic (4.5.7)
(function() {
	app.controller('InformacaoCadastroController', [
		'$stateParams',
		'PostService',
		'Session',
		'$state',
		'MidiaService',
		'appConfig',
		'$scope',
		'DialogService',
		'$rootScope',
		function ($stateParams, PostService, Session, $state, MidiaService, appConfig, $scope, DialogService, $rootScope) {
			'use strict';
			var vm = this;

			vm.submitBlocked = false;
			vm.isEditing = false;
			vm.categories = PostService.getCategories();
			vm.tipo_post_selecionado = {};
			vm.anexos = [];
			vm.imagens = [];
			vm.post = {
				anexos: [],
				imagens: [],
				data_postagem: new Date(),
				conteudo: ' '
			};
			$rootScope.timestamp = new Date().getTime();

			vm.reloadPosts = function() {
				var filter = '?empreendimento=' +
					Session.empreendimento.id +
					'&post_type=' + appConfig.post_types.informacao;

				PostService.getTiposPost(filter).then((response) => {
					vm.tipos_post = response.data.tipos_post;
				});
			}

			vm.deleteImagemDestacada = function() {
				DialogService.deleteDialog('imagem destacada', function() {
					if(vm.post.imagem_destacada) {
						PostService.updatePost({id: vm.post.id, clear_imagem_destacada: true}).then((response) => {
							DialogService.close();
							delete vm.post.preview;
						});
					} else {
						if(vm.post.preview.id) {
							MidiaService.deleteMidia(vm.post.preview.id).then(response => {
								DialogService.close();
								if(response.data.success)
									delete vm.post.preview;
								else
									toastr.error('Não foi possível deletar imagem destacada');
							});
						} else {
							DialogService.close();
							delete vm.post.preview;
							$scope.$apply();
						}
					}
				});
			}

			$scope.$on('empreendimento_has_changed', () => {
			    vm.reloadPosts();
		    });
			vm.reloadPosts();

			angular.element(document).ready(() => {
				$(".select").select2();
			});

			if($stateParams.id) {
				vm.isEditing = true;

				PostService.getPost($stateParams.id).then((response) => {
					vm.post = response.data.post;
					vm.post.data_postagem = new Date(vm.post.data_postagem.timestamp);

					if(vm.post.imagem_destacada) {
						vm.post.preview = {
							arquivo: vm.post.imagem_destacada
						};
					}

					vm.reloadPosts();

					vm.categories.forEach((element) => {
						if(element.post_type === vm.post.post_type) {
							vm.post.post_type = element;
							return;
						}
					});

					vm.post.anexos = [];
					vm.post.imagens = [];

					vm.post.midias.forEach((element) => {
						if(element.type === appConfig.midia_type.imagem)
							vm.post.imagens.push(element);
						else if(element.type == appConfig.midia_type.anexo)
							vm.post.anexos.push(element);
					});
				});
			}

			vm.apagarMidia = function(element, index, from) {
				DialogService.deleteDialog(element.descricao, function() {
					if(element.id) {
						MidiaService.deleteMidia(element.id).then((response) => {
							if(response.data.success) {
								DialogService.close();
								vm.post[from === 'galeria' ? 'imagens' : 'anexos' ].splice(index, 1);
							} else
								toastr.error('Não foi possível remover '+element.descricao);
						});
					} else {
						vm.post[from === 'galeria' ? 'imagens' : 'anexos' ].splice(index, 1);
						DialogService.close();
						$scope.$apply();
					}
				});
			}

			vm.salvar = function() {
				vm.submitBlocked = true;

				var data = {
					conteudo: vm.post.conteudo,
					post_type: appConfig.post_types.informacao,
					titulo: vm.post.titulo,
					usuario_id: Session.user.id,
					empreendimento_id: Session.empreendimento.id,
          anexos: vm.post.anexos,
          caminho_anexo: vm.post.caminho_anexo,
					timestamp: $rootScope.timestamp,
					imagens: vm.post.imagens,
					data_postagem: now(vm.post.data_postagem)
				};

				if(vm.post.tipo_post) {
					data['post_tipo_id'] = vm.post.tipo_post.id;
				}

				if(vm.post.preview) {
					data['imagem_destacada'] = vm.post.preview.arquivo;
				}

				if(vm.post.id) {
					data['data_ultima_edicao'] = now();
					data['id'] = vm.post.id;
				}

				if(vm.isEditing) {
					PostService.updatePost(data).then((response) => {
						if(response.data.success) {
							toastr.success('Informação alterada com sucesso!');
							$state.go('informacao');
						} else {
							toastr.error('Não foi possível alterar os dados do Informação!');
						}
					});
				} else {
					PostService.createPost(data).then((response) => {
						if(response.data.success) {
							toastr.success('Informação cadastrada com sucesso!');
							$state.go('informacao');
						} else {
							toastr.error('Não foi possível cadastrar a Informação!');
						}
					});
				}
			}
		}
	]);
})();

//metronic (4.5.7)
(function() {
	app.controller('InformacaoController', [
		'PostService',
		'DialogService',
		'$state',
		'Session',
		'appConfig',
		'$scope',
		function (PostService, DialogService, $state, Session, appConfig, $scope) {
			'use strict';
			var vm = this;
      vm.search = null;

			vm.loadMore = function() {
				var filters = '?empreendimento='
					+ Session.empreendimento.id +
					'&post_type=' + appConfig.post_types.informacao + '&offset=' + vm.paginator
					+ (vm.search !== null && vm.search !== undefined && vm.search !== '' ? vm.search : '');

				PostService.getPosts(filters).then((response) => {
					vm.posts = response.data.post;
				});
			}

			vm.reloadPosts = function() {
				vm.paginator = 0;

				var filter = '?empreendimento=' +
					Session.empreendimento.id +
					'&post_type=' + appConfig.post_types.informacao + (vm.search !== null && vm.search !== undefined && vm.search !== '' ? vm.search : '');

				PostService.getPages(filter).then((response) => {
					vm.pages = response.data.pages;
					vm.maxElements = response.data.count;
					vm.itemsPerPage = response.data.itemsPerPage;

					vm.loadMore();
				});
			}

			$scope.$on('empreendimento_has_changed', () => {
			    vm.reloadPosts();
		    });
			vm.reloadPosts();

        vm.doFilter = () => {
          vm.search = '&filter='+$scope.search;
          vm.reloadPosts();
        }
      //Backup icaro - 21/08/2019
			// vm.doFilter = function() {
			// 	vm.reloadPosts('&filter='+$scope.search);
			// }

			vm.delete = function(element) {
				DialogService.deleteDialog(element.titulo, function() {
					PostService.deletePost(element.id).then((response) => {
						if(response.data.success) {
							$state.reload();
							DialogService.dialog("Deletado com sucesso!");
						} else
							DialogService.dialog("Não foi possível deletar "+element.titulo, "error");
					});
				});
			}
		}
	]);
})();

//metronic (4.5.7)
(function() {
	app.controller('PostTipoCadastroController', [ 
		'PostService',
		'Session',
		'$stateParams',
		'$state',
		function (PostService, Session, $stateParams, $state) { 
			'use strict'; 
			var vm = this;
			
			vm.isEditing = false;
			vm.categories = PostService.getCategories();
			vm.post_tipo = {};

			if($stateParams.id) {
				vm.isEditing = true;
				PostService.getPostTipo($stateParams.id).then((response) => {
					vm.post_tipo = response.data.postTipo;

					vm.categories.forEach((element) => {
						if(vm.post_tipo.post_type === element.post_type) {
							vm.post_tipo.post_type = element;
							return;
						}
					});
				});
			}

			angular.element(document).ready(() => {
				$(".select").select2();
			});

			vm.salvar = function() {
				var data = {
					titulo: vm.post_tipo.titulo,
					post_type: vm.post_tipo.post_type.post_type,
					empreendimento_id: Session.empreendimento.id
				};

				if(vm.post_tipo.id)
					data['id'] = vm.post_tipo.id;

				if(vm.isEditing) {
					PostService.updatePostTipo(data).then((response) => {
						if(response.data.success) {
							toastr.success('Categoria alterada com sucesso!');
							$state.go('post-tipo');
						} else {
							toastr.error('Não foi possível alterar os dados da Categoria!');
						}
					});
				} else {
					PostService.createPostTipo(data).then((response) => {
						if(response.data.success) {
							toastr.success('Categoria cadastrada com sucesso!');
							$state.go('post-tipo');
						} else {
							toastr.error('Não foi possível cadastrar Categoria!');
						}
					});
				}
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('PostTipoController', [ 
		'PostService',
		'Session',
		'DialogService',
		'$state',
		'$scope',
		function (PostService, Session, DialogService, $state, $scope) { 
			'use strict'; 
			var vm = this;

			vm.reload = function() {
				var filters = '?empreendimento=' + Session.empreendimento.id;

				PostService.getTiposPost(filters).then((response) => {
					vm.tipos = response.data.tipos_post;
				});		
			}
			
			$scope.$on('empreendimento_has_changed', () => {
			    vm.reload();
		    });
			vm.reload();

			vm.getCategory = function(element) {
				switch(element) {
					case 'informacao' : return 'Informação';
					case 'forum' : return 'Fórum';
					default : return element.charAt(0).toUpperCase() + element.slice(1);
				}
			}

			vm.delete = function(element) {
				DialogService.deleteDialog(element.titulo, function() {
					PostService.deletePostTipo(element.id).then((response) => {
						if(response.data.success) {
							DialogService.dialog("Deletado com sucesso!");
							$state.reload();
						} else
							DialogService.dialog("Não foi possível deletar "+element.titulo, "error");
					});
				});
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('PostViewController', [ 
		'PostService',
		'DialogService',
		'$state',
		'$stateParams',
		'appConfig',
		function (PostService, DialogService, $state, $stateParams, appConfig) { 
			'use strict'; 
			var vm = this;

			vm.imagens = [];
			vm.anexos = [];
			
			vm.initOwl = function() {
				$(document).ready(function(){
				  $('.owl-carousel').owlCarousel({
				  	loop:true,
				  	items: 1,
				  	autoplay: true,
				  	autoplayTimeout: 2000,
				  	autoplayHoverPause: true,
				  	dots: true,
				  	dotsEach: true
				  });
				});
			}

			PostService.getPost($stateParams.id).then((response) => {
				vm.post = response.data.post;

				if(vm.post.imagem_destacada)
					vm.post.imagem_destacada = site_url + '/' + vm.post.imagem_destacada;

				vm.isForum = vm.post.post_type === appConfig.post_types.forum;

				vm.post.midias.forEach((element) => {
					if(element.type === appConfig.midia_type.imagem) {
						vm.imagens.push(site_url + '/' + element.arquivo);
					} else if(element.type === appConfig.midia_type.anexo) {
						element.arquivo = site_url + '/' + element.arquivo;
						vm.anexos.push(element);
					}
				});
			});
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('TransparenciaCadastroController', [
		'$stateParams',
		'PostService',
		'Session',
		'$state',
		'MidiaService',
		'appConfig',
		'$scope',
		'DialogService',
		'$rootScope',
		function ($stateParams, PostService, Session, $state, MidiaService, appConfig, $scope, DialogService, $rootScope) {
			'use strict';
			var vm = this;

			vm.submitBlocked = false;
			vm.isEditing = false;
			vm.categories = PostService.getCategories();
			vm.tipo_post_selecionado = {};
			vm.anexos = [];
			vm.imagens = [];
			vm.post = {
				anexos: [],
				imagens: [],
				conteudo: ' '
      };
			$rootScope.timestamp = new Date().getTime();

			vm.reloadPosts = function() {
				var filter = '?empreendimento=' +
					Session.empreendimento.id +
					'&post_type=' + appConfig.post_types.transparencia;

				PostService.getTiposPost(filter).then((response) => {
					vm.tipos_post = response.data.tipos_post;
				});
			}

			vm.deleteImagemDestacada = function() {
				DialogService.deleteDialog('imagem destacada', function() {
					if(vm.post.imagem_destacada) {
						PostService.updatePost({id: vm.post.id, clear_imagem_destacada: true}).then((response) => {
							DialogService.close();
							delete vm.post.preview;
						});
					} else {
						if(vm.post.preview.id) {
							MidiaService.deleteMidia(vm.post.preview.id).then(response => {
								DialogService.close();
								if(response.data.success)
									delete vm.post.preview;
								else
									toastr.error('Não foi possível deletar imagem destacada');
							});
						} else {
							DialogService.close();
							delete vm.post.preview;
							$scope.$apply();
						}
					}
				});
			}

			$scope.$on('empreendimento_has_changed', () => {
				vm.reloadPosts();
		    });
			vm.reloadPosts();

			angular.element(document).ready(() => {
				$(".select").select2();
			});

			if($stateParams.id) {
				vm.isEditing = true;

				PostService.getPost($stateParams.id).then((response) => {
					vm.post = response.data.post;
					vm.post.data_postagem = new Date(vm.post.data_postagem.timestamp);
					// vm.post.data_postagem = vm.post.data_postagem.toLocaleString();
					// vm.post.data_postagem = vm.post.data_postagem.substring(0, vm.post.data_postagem.length - 3);

					if(vm.post.imagem_destacada) {
						vm.post.preview = {
							arquivo: vm.post.imagem_destacada
						};
					}

					vm.reloadPosts();

					vm.categories.forEach((element) => {
						if(element.post_type === vm.post.post_type) {
							vm.post.post_type = element;
							return;
						}
					});

					vm.post.anexos = [];
					vm.post.imagens = [];

					vm.post.midias.forEach((element) => {
						if(element.type === appConfig.midia_type.imagem)
							vm.post.imagens.push(element);
						else if(element.type == appConfig.midia_type.anexo)
							vm.post.anexos.push(element);
					});
				});
			}

			vm.apagarMidia = function(element, index, from) {
				DialogService.deleteDialog(element.descricao, function() {
					if(element.id) {
						MidiaService.deleteMidia(element.id).then((response) => {
							if(response.data.success) {
								DialogService.close();
								vm.post[from === 'galeria' ? 'imagens' : 'anexos' ].splice(index, 1);
							} else
								toastr.error('Não foi possível remover '+element.descricao);
						});
					} else {
						vm.post[from === 'galeria' ? 'imagens' : 'anexos' ].splice(index, 1);
						DialogService.close();
						$scope.$apply();
					}
				});
			}

			vm.salvar = function() {
				vm.submitBlocked = true;

				var data = {
					conteudo: vm.post.conteudo,
					post_type: appConfig.post_types.transparencia,
					titulo: vm.post.titulo,
					usuario_id: Session.user.id,
					empreendimento_id: Session.empreendimento.id,
					timestamp: $rootScope.timestamp,
          anexos: vm.post.anexos,
          caminho_anexo: vm.post.caminho_anexo,
					imagens: vm.post.imagens,
					data_postagem: now(vm.post.data_postagem)
				};

				if(vm.post.tipo_post) {
					data['post_tipo_id'] = vm.post.tipo_post.id;
				}

				if(vm.post.preview) {
					data['imagem_destacada'] = vm.post.preview.arquivo;
				}

				if(vm.post.id) {
					data['data_ultima_edicao'] = now();
					data['id'] = vm.post.id;
				}
				if(vm.isEditing) {
					PostService.updatePost(data).then((response) => {
						if(response.data.success) {
							toastr.success('Transparência alterada com sucesso!');
							$state.go('transparencia');
						} else {
							toastr.error('Não foi possível alterar os dados do Transparência!');
						}
					});
				} else {
					PostService.createPost(data).then((response) => {
						if(response.data.success) {
							toastr.success('Transparência cadastrada com sucesso!');
							$state.go('transparencia');
						} else {
							toastr.error('Não foi possível cadastrar a Transparência!');
						}
					});
				}
			}
		}
	]);
})();

//metronic (4.5.7)
(function() {
	app.controller('TransparenciaController', [
		'PostService',
		'DialogService',
		'$state',
		'Session',
		'appConfig',
		'$scope',
		function (PostService, DialogService, $state, Session, appConfig, $scope) {
			'use strict';
			var vm = this;
      vm.search = null;

			vm.loadMore = function(filter) {
				var filters = '?empreendimento='
					+ Session.empreendimento.id +
					'&post_type=' + appConfig.post_types.transparencia + '&offset=' + vm.paginator
					+ (vm.search !== null && vm.search !== undefined && vm.search !== '' ? vm.search : '');
				PostService.getPosts(filters).then((response) => {
					vm.posts = response.data.post;
				});
			}

			vm.reloadPosts = function(filter_view) {
				vm.paginator = 0;

				var filter = '?empreendimento=' +
					Session.empreendimento.id +
					'&post_type=' + appConfig.post_types.transparencia + (vm.search !== null && vm.search !== undefined && vm.search !== '' ? vm.search : '');

				PostService.getPages(filter).then((response) => {
					vm.pages = response.data.pages;
					vm.maxElements = response.data.count;
					vm.itemsPerPage = response.data.itemsPerPage;

					vm.loadMore(filter_view);
				});
			}

			$scope.$on('empreendimento_has_changed', () => {
				vm.reloadPosts();
		    });
			vm.reloadPosts();

			vm.doFilter = function() {
        vm.search = '&filter='+$scope.search;
				vm.reloadPosts('&filter='+$scope.search);
      }
      //Backup 22/08/2019- icaro
			// vm.doFilter = function() {
			// 	vm.reloadPosts('&filter='+$scope.search);
			// }

			vm.delete = function(element) {
				DialogService.deleteDialog(element.titulo, function() {
					PostService.deletePost(element.id).then((response) => {
						if(response.data.success) {
							$state.reload();
							DialogService.dialog("Deletado com sucesso!");
						} else
							DialogService.dialog("Não foi possível deletar "+element.titulo, "error");
					});
				});
			}
		}
	]);
})();

//metronic (4.5.7)
(function() {
	app.controller('PrestadorCadastroController', [
		'PrestadorService',
		'UsuarioService',
		'$stateParams',
		'$state',
		'Session',
		'$scope',
		function (PrestadorService, UsuarioService, $stateParams, $state, Session, $scope) {
			'use strict';
			var vm = this;

			vm.isEditing = false;
			vm.prestador = { responsavel : { nome: '' }, moradia: {}}
			vm.usuarios = [];

			angular.element(document).ready(() => {
				var select2 = $(".select").select2();

				$('.select').on('classChange', function() {
					$select2.data('select2').$container.addClass("wrap");
				});
			});

			vm.doFilter = function() {
				var filter = '?empreendimento='
					+ Session.empreendimento.id
					+ '&enabled=true'
					+ '&filter='+vm.prestador.responsavel.nome;

				if( ! vm.isEditing) {
					UsuarioService.getUsuarios(filter).then((response) => {
						vm.usuarios.length = 0;

						response.data.usuarios.forEach(usuario => {
							usuario.label = '<b>' + usuario.nome + '</b><br />' + usuario.moradias.map(
								moradia => moradia.identificador 
									+ ' (' + moradia.conjunto.titulo + ')').join('<br/>');

							vm.usuarios.push(usuario);
						});
					});	
				}
			}

			vm.select = function(element) {
				vm.prestador.responsavel = element;

				if(vm.prestador.responsavel.moradias.length === 1) {
					vm.prestador.moradia = vm.prestador.responsavel.moradias[0];
				}

				vm.show_box = false;
			}

			if($stateParams.id) {
				vm.isEditing = true;

				PrestadorService.getPrestador($stateParams.id).then((response) => {
					vm.prestador = response.data.prestador;
					vm.data_inicio = new Date(vm.prestador.data_inicio.timestamp);
					vm.data_termino = new Date(vm.prestador.data_termino.timestamp);
					vm.doFilter();
				});
			}

			vm.salvar = function() {
				var data = {
					data_inicio: now(vm.data_inicio),
					data_termino: vm.data_termino ? now(vm.data_termino) : null,
					nome: vm.prestador.nome,
					tipo_servico: vm.prestador.tipo_servico,
					responsavel_id: vm.prestador.responsavel.id,
					moradia_id: vm.prestador.moradia.id,
					observacoes: vm.prestador.observacoes
				};

				if(vm.prestador.id)
					data['id'] = vm.prestador.id;

				if(vm.isEditing) {
					PrestadorService.updatePrestador(data).then((response) => {
						if(response.data.success) {
							toastr.success('Prestador alterado com sucesso!');
							$state.go('prestador');
						} else {
							toastr.error('Não foi possível alterar os dados do Prestador!');
						}
					});
				} else {
					PrestadorService.createPrestador(data).then((response) => {
						if(response.data.success) {
							toastr.success('Prestador cadastrado com sucesso!');
							$state.go('prestador');
						} else {
							toastr.error('Não foi possível cadastrar o Prestador!');
						}
					});
				}
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('PrestadorController', [ 
		'PrestadorService',
		'DialogService',
		'$state',
		'$scope',
		'Session',
		'$rootScope',
		function (PrestadorService, DialogService, $state, $scope, Session, $rootScope) { 
			'use strict'; 
			var vm = this;
			
            //$rootScope.isUserLogged = true;

			vm.loadPrestadores = function() {
				PrestadorService.getPrestadores(Session.empreendimento.id+'&list=true').then((response) => {
					vm.prestadores = response.data.prestadores;

					if(vm.prestadores.length === 0)
						toastr.info('Não há prestadores de serviço cadastrados para o empreendimento '+Session.empreendimento.nome_fantasia);
				});	
			}

			$scope.$on('empreendimento_has_changed', () => {
				vm.loadPrestadores();
		    });
			vm.loadPrestadores();

			angular.element(document).ready(() => {
				$(".select").select2();
			});

			vm.delete = function(element) {
				DialogService.deleteDialog('prestação de serviço de ' + element.nome, function() {
					PrestadorService.deletePrestador(element.id).then((response) => {
						if(response.data.success) {
							DialogService.dialog("Deletado com sucesso!");
							$state.reload();
						} else
							DialogService.dialog("Não foi possível deletar visita de "+element.nome, "error");
					});
				});
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('PrestadorTodosController', [ 
		'PrestadorService',
		'DialogService',
		'$state',
		'$scope',
		'Session',
		'$rootScope',
		function (PrestadorService, DialogService, $state, $scope, Session, $rootScope) { 
			'use strict'; 
			var vm = this;
			vm.search = '';
			vm.is_filter = false;
            //$rootScope.isUserLogged = true;
	
			vm.loadPrestadores = function(page) {
				PrestadorService.getPrestadores(Session.empreendimento.id+'&list=true&all=true&offset='+page+'&filter='+vm.search).then((response) => {
					vm.prestadores = response.data.prestadores;

					if(vm.prestadores.length === 0)
						toastr.info('Não há prestadores de serviço cadastrados para o empreendimento '+Session.empreendimento.nome_fantasia);
				});	
			}
			
			vm.reload = function() {
				vm.paginator = 0;
				if(!vm.is_filter){
					vm.is_filter = true;
					PrestadorService.getPages(Session.empreendimento.id+'&list=true&all=true&filter=' + vm.search).then((response) => {
						vm.pages = response.data.pages;
						vm.maxElements = response.data.count;
						vm.itemsPerPage = response.data.itemsPerPage;
						vm.is_filter = false;
					});
				}

				vm.loadPrestadores(vm.paginator);
			}
			
			//Controles de filtro
			vm.doFilter = function() {
				vm.reload();
			}
			$scope.$on('empreendimento_has_changed', () => {
				vm.reload();
		    });
			vm.reload();
			
			angular.element(document).ready(() => {
				$(".select").select2();
			});

			vm.delete = function(element) {
				DialogService.deleteDialog('prestação de serviço de ' + element.nome, function() {
					PrestadorService.deletePrestador(element.id).then((response) => {
						if(response.data.success) {
							DialogService.dialog("Deletado com sucesso!");
							$state.reload();
						} else
							DialogService.dialog("Não foi possível deletar visita de "+element.nome, "error");
					});
				});
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('LoginController', [ 
		'$state',
		'$rootScope',
		'LoginService',
		'Session',
		'StorageService',
		'EmpreendimentoService',
		function ($state, $rootScope, LoginService, Session, StorageService, EmpreendimentoService) { 
			'use strict'; 
			var vm = this;
			vm.user = new Object();
            //$rootScope.isUserLogged = false;
			EmpreendimentoService.getEmpreendimentosList().then((response) => {
				vm.empreendimentos = response.data.empreendimentos;
				
				var domain = document.domain.split('.');
				var subdomain = domain[0];
				if(subdomain != 'sistema'){
					vm.empreendimentos.forEach((innerElement, index) => {
						if(innerElement.slug == subdomain){
							vm.user.empreendimento = innerElement;
							angular.element(document).ready(() => {
								$('#empreendimento').next(".select2-container").hide();
								if(innerElement.imagem_logo != null){
									$(".logo").attr('src',innerElement.imagem_logo);
								}
								if(innerElement.imagem_background != null){
									$(".login").css('background','url('+innerElement.imagem_background+')');
									$(".login").css('background-size','cover');
								}
							});
							return false;
						}
					});
				}
			});
			angular.element(document).ready(() => {
				$(".select").select2();
			});
			
			vm.doLogin = function() {
				LoginService.doLogin(vm.user).then((response) => {
					// if(response.statusText == "OK") {
					if(response.status == 200 && response.data && response.data.usuario) {
						
						StorageService.setJson('usuario', response.data.usuario);
						StorageService.setJson('token', response.data.token);
						StorageService.setJson('empreendimento', response.data.usuario.empreendimento);
						
						Session.user = response.data.usuario;
						Session.token = response.data.token;
						
						if(StorageService.get('empreendimento') == 'null'){
							EmpreendimentoService.getEmpreendimentos().then((response) => {
								Session.empreendimento = response.data.empreendimentos[0];
								StorageService.setJson('empreendimentoSel', Session.empreendimento);
								vm.redirect();
								return false;
							});
						}else{
							Session.empreendimento = StorageService.getJson('empreendimento');
							StorageService.setJson('empreendimentoSel', Session.empreendimento);
							vm.redirect();
						}
					}
				});	
			}
			
			vm.redirect = function(){
				$rootScope.isUserLogged = true;
				
				if(StorageService.get('empreendimento') == 'null'){
					$rootScope.client_hide_title = false;
				}else{
					$rootScope.client_visible = true;
					$rootScope.client_hide_title = true;
				}
				
				if(Session.user.usuario_tipo.titulo === 'Portaria') {
					$rootScope.isMensageria = false;
					$rootScope.isPortaria = true;
					$rootScope.isRecepcao = false;
					$state.go('visitante');
				} else if(Session.user.usuario_tipo.titulo === 'Mensageria') {
					$rootScope.isRecepcao = false;
					$rootScope.isMensageria = true;
					$rootScope.isPortaria = false;
					$state.go('notificacoes-mensageria-cadastro');
				} else if(Session.user.usuario_tipo.titulo === 'Recepção') {
					$rootScope.isRecepcao = true;
					$rootScope.isMensageria = false;
					$rootScope.isPortaria = false;
					$state.go('visitante');
				} else if(Session.user.usuario_tipo.titulo === 'Morador') {
					Session = {};
					toastr.error('Somente usuários da administração tem acesso a este portal');
				} else {
					$rootScope.isRecepcao = false;
					$rootScope.isMensageria = false;
					$rootScope.isPortaria = false;
					$state.go('dashboard');
				}
			}
			
			vm.mudou = function() {
				$state.go('recuperar-senha');
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('RecuperarSenhaController', [ 
		'$state',
		'$rootScope',
		'LoginService',
		function ($state, $rootScope, LoginService) { 
			'use strict'; 
			var vm = this;
			$rootScope.isUserLogged = false;

			vm.recuperarSenha = function() {
				var data = {
					email: vm.email
				};

				LoginService.recuperarSenha(data).then((response) => {
					if(response.data.success) {
						$state.go('login');
						toastr.success('Verifique seu e-mail para consultar sua senha.');
						//$rootScope.isUserLogged = true;
					} else {
						toastr.error('Não foi possível recuperar sua senha. Por favor, tente novamente mais tarde.');
					}
				});				
			}
		}
	]);
})();
//metronic (4.5.7)
(function (){
  app.controller('RelatorioAcessoController',[
    'RelatorioAcessoService',
    '$scope',
		'$rootScope',
    'Session',
    function(RelatorioAcessoService,$scope,$rootScope,Session){
      'use strict';
      var vm = this;
      var anoAtual = new Date();
      vm.ano = [];
      vm.meses = [];
      vm.anoEscolhido = '';
      vm.mesEscolhido = '';
      $scope.labels = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"];
      $scope.series = ['Visitantes', 'Prestadores'];
      $scope.data = [
        [0,0,0,0,0,0,0,0,0,0,0,0],
        [0,0,0,0,0,0,0,0,0,0,0,0]
      ];

      vm.init  = function(){
        var i = 1;
        vm.anoEscolhido = String(anoAtual.getFullYear());
        console.log(vm.anoEscolhido);
        vm.mesEscolhido = '0';
        $scope.labels.map(element =>{
          vm.meses.push({
            mes : element,
            index : i
          })
          i++;
        });
        vm.reload();
      }

      vm.reload = function(){
        var filter = '?empreendimento='+Session.empreendimento.id+'&ano='+vm.anoEscolhido;
        if(vm.mesEscolhido !== '0'){
          filter += '&mes='+vm.mesEscolhido
        }

        RelatorioAcessoService.getRelatorioMonth(filter).then((response)=>{
          console.log(response.data)
          if(vm.ano.length < 1)
            vm.getDados(anoAtual.getFullYear());
        })
      }
      vm.getDados = function(ano){
        var filters = '?empreendimento=' + Session.empreendimento.id;
          RelatorioAcessoService.getRelatorioDados(filters).then((response)=>{
            for(var i = response.data.dados.ano; i <= ano; i++){
              vm.ano.push(i);
            }
          })
      }

      vm.init();
    }
  ])
})();

//metronic (4.5.7)
(function() {
	app.controller('SistemaController', [ 
		'SistemaService',
		function (SistemaService) { 
			'use strict'; 
			var vm = this;
			
			SistemaService.getInfo().then((response) => {
				vm.sistema = response.data.sistema;
			})

			vm.salvar = function() {
				var data = {
				};

				if(vm.sistema.id) {
					SistemaService.updateSistema(data).then((response) => {
						if(response.data.success) {
							toastr.success('Sistema alterado com sucesso!');
						} else {
							toastr.error('Não foi possível alterar os dados do Sistema!');
						}
					});
				} else {
					SistemaService.createSistema(data).then((response) => {
						if(response.data.success) {
							toastr.success('Sistema cadastrado com sucesso!');
						} else {
							toastr.error('Não foi possível cadastrar os dados do Sistema!');
						}
					});
				}
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('TelefoneUtilCadastroController', [ 
		'TelefonesUteisService',
		'ConjuntoService',
		'$stateParams',
		'PermissaoService',
		'$state',
		'Session',
		'$scope',
		function (TelefonesUteisService, ConjuntoService, $stateParams, PermissaoService, $state, Session, $scope) { 
			'use strict'; 
			var vm = this;
			
			vm.isEditing = false;
			vm.conjuntos = [];
			vm.telefone = {
				numero: [],
				conjuntos: []
			}
			
			if($stateParams.id) {
				vm.isEditing = true;
				TelefonesUteisService.getTelefone($stateParams.id).then((response) => {
					vm.telefone = response.data.telefone;

					if( ! angular.isArray(vm.telefone.conjuntos))
						vm.telefone.conjuntos = [];
					
					vm.reload();
				});
			} 

			vm.reload = function() {
				var filter = '?empreendimento='+Session.empreendimento.id;

				ConjuntoService.getConjuntos(filter).then((response) => {
					vm.conjuntos = response.data.conjuntos;

					if(vm.telefone.conjuntos) {
						vm.telefone.conjuntos.forEach((element, index) => {
							vm.conjuntos.forEach((innerElement, innerIndex) => {
								if(element.id === innerElement.id) {
									vm.conjuntos.splice(innerIndex, 1);
									return true;
								}
							});
						});
					}
				});
			}
			
			$scope.$on('empreendimento_has_changed', () => {
				vm.reload();
		    });
			vm.reload();
			
			vm.adicionarTelefone = function() {
				vm.telefone.numero.push('');
			}

			vm.removeTelefone = function(index) {
				vm.telefone.numero.splice(index, 1);
			}

			vm.pickConjunto = function(id) {
				vm.conjuntos.forEach((element, index) => {
					if(element.id === id) {
						vm.telefone.conjuntos.push(element);
						vm.conjuntos.splice(index, 1);
						return;
					}
				})
			}

			vm.unpickConjunto = function(id) {
				vm.telefone.conjuntos.forEach((element, index) => {
					if(element.id === id) {
						vm.conjuntos.push(element);
						vm.telefone.conjuntos.splice(index, 1);
						return;
					}
				});
			}

			vm.salvar = function() {
				var data = {
					titulo: vm.telefone.titulo,
					numero: vm.telefone.numero.join(),
					empreendimento_id: Session.empreendimento.id,
					ramal: vm.telefone.ramal ? vm.telefone.ramal : '',
					email: vm.telefone.email ? vm.telefone.email : '',
					conjuntos: vm.telefone.conjuntos.length > 0 ? getIdsConjuntos() : []
				};

				if(vm.telefone.id)
					data['id'] = vm.telefone.id;

				if(vm.isEditing) {
					TelefonesUteisService.updateTelefone(data).then((response) => {
						if(response.data.success) {
							toastr.success('Telefone alterado com sucesso!');
							$state.go('telefones-uteis');
						} else {
							toastr.error('Não foi possível alterar os dados do Telefone!');
						}
					});
				} else {
					TelefonesUteisService.createTelefone(data).then((response) => {
						if(response.data.success) {
							toastr.success('Telefone cadastrado com sucesso!');
							$state.go('telefones-uteis');
						} else {
							toastr.error('Não foi possível cadastrar o Telefone!');
						}
					});
				}
			}

			function getIdsConjuntos() {
				var ids = [];

				vm.telefone.conjuntos.forEach((element) => {
					ids.push(element.id);
				});

				return ids;
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('TelefoneUtilController', [ 
		'TelefonesUteisService',
		'Session',
		'DialogService',
		'$state',
		'$scope',
		function (TelefonesUteisService, Session, DialogService, $state, $scope) { 
			'use strict'; 
			var vm = this;
			
			vm.reloadTelephones = function() {
				var filter = '?empreendimento=' + 
					Session.empreendimento.id;

				TelefonesUteisService.getTelefones(filter).then((response) => {
					vm.telefones = response.data.telefones_uteis;
				});		
			}
			
			$scope.$on('empreendimento_has_changed', () => {
				vm.reloadTelephones();
		    });
			vm.reloadTelephones();

			vm.delete = function(element) {
				DialogService.deleteDialog(element.titulo, function() {
					TelefonesUteisService.deleteTelefone(element.id).then((response) => {
						if(response.data.success) {
							DialogService.dialog("Deletado com sucesso!");
							$state.reload();
						} else
							DialogService.dialog("Não foi possível deletar "+element.titulo, "error");
					});
				});
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('AppController', [
        '$scope', 
        '$rootScope', 
        'Session',
        '$state',
        'appConfig',
        'StorageService',
		'EmpreendimentoService',
		'LoginService',
        function($scope, $rootScope, Session, $state, appConfig, StorageService, EmpreendimentoService, LoginService) {

        var vm = this;

        vm.Session = Session;
        vm.appConfig = appConfig;
        vm.url = site_url + '/';
        var currentYear = new Date().getFullYear();
        vm.dateOptions = {
            changeYear: true,
            changeMonth: true,
            yearRange: (currentYear - 15) + ':' + (currentYear + 15)
        };
		
		function removeAccents(value) {
			return value
			 .replace(/á/g, 'a') 
			 .replace(/â/g, 'a')            
			 .replace(/é/g, 'e')
			 .replace(/è/g, 'e') 
			 .replace(/ê/g, 'e')
			 .replace(/í/g, 'i')
			 .replace(/ï/g, 'i')
			 .replace(/ì/g, 'i')
			 .replace(/ó/g, 'o')
			 .replace(/ô/g, 'o')
			 .replace(/ú/g, 'u')
			 .replace(/ü/g, 'u')
			 .replace(/ç/g, 'c')
			 .replace(/ß/g, 's');
		}
		$rootScope.ignoreAccents = function (actual, expected) {
			if(expected.length >= 3){
				if(angular.isObject(actual)) return false;
				actual = removeAccents(angular.lowercase('' + actual));
				expected = removeAccents(angular.lowercase('' + expected));
				return actual.indexOf(expected) !== -1;
			}else{
				return true;
			}
		};
		
        vm.logout = function() {
            LoginService.logout(StorageService.get('token')).then((response) => {
				
				Session.user = null;
				Session.empreendimento = null;
				Session.token = null;
				StorageService.reset();
				$rootScope.isUserLogged = false;
				
				$state.go('login');
			});
        }

	    $scope.$on('$viewContentLoaded', function() {
	        //App.initComponents(); // init core components
	        //Layout.init(); //  Init entire layout(header, footer, sidebar, etc) on page load if the partials included in server side instead of loading with ng-include directive 
	    });

	    $rootScope.htmlEditorMenu = [
            ['bold', 'italic', 'underline', 'strikethrough', 'subscript', 'superscript'],
            ['format-block'],
            ['font-size'],
            ['font-color', 'hilite-color'],
            ['remove-format'],
            ['ordered-list', 'unordered-list', 'outdent', 'indent'],
            ['left-justify', 'center-justify', 'right-justify'],
            ['code', 'quote', 'paragraph'],
            ['link', 'image']
        ];

        $rootScope.sendTop = function() {
            $("html, body").animate({ scrollTop: 0 }, "slow");
        }
		
		EmpreendimentoService.getEmpreendimentosList().then((response) => {
			vm.empreendimentos = response.data.empreendimentos;
			//Session.empreendimento = vm.empreendimentos[0];
			//vm.empreendimento_changed();
		});
		vm.empreendimento_changed = function() {
			StorageService.setJson('empreendimentoSel', Session.empreendimento);
			$scope.$broadcast("empreendimento_has_changed");
		}
	}]);
})();
//metronic (4.5.7)
(function() {
	app.controller('FooterController', ['$scope', function($scope) {
	    $scope.$on('$includeContentLoaded', function() {
	        Layout.initFooter(); // init footer
			angular.element(document).ready(() => {
				$(".select").select2();
			});
	    });
	}]);
})();
//metronic (4.5.7)
(function() {
	app.controller('HeaderController', ['$scope', function($scope) {
	    $scope.$on('$includeContentLoaded', function() {
	        Layout.initHeader(); // init header
	    });
	}]);
})();
//metronic (4.5.7)
(function() {
	app.controller('QuickSidebarController', ['$scope', function($scope) {    
	    $scope.$on('$includeContentLoaded', function() {
	       setTimeout(function(){
	            QuickSidebar.init(); // init quick sidebar        
	        }, 2000)
	    });
	}]);
})();
//metronic (4.5.7)
(function() {
	app.controller('SidebarController', ['$state', '$scope','Session', function($state, $scope, Session) {
		vm = this;
		
		$scope.$on('$includeContentLoaded', function() {
	        Layout.initSidebar($state); // init sidebar
			
			if(!Session.is_suporte()){
				document.getElementById('sidebar-title-adm').remove();
				document.getElementById('page-sidebar-menu-adm').remove();
			}
	    });
	}]);
})();
//metronic (4.5.7)
(function() {
	app.controller('ThemePanelController', ['$scope', function($scope) {    
	    $scope.$on('$includeContentLoaded', function() {
	        Demo.init(); // init theme panel
	    });
	}]);
})();
//metronic (4.5.7)
(function() {
	app.controller('ProfileController', [ 
		'UsuarioService',
		'$state',
		'Session',
		function (UsuarioService, $state, Session) { 
			'use strict'; 
			var vm = this;

			vm.user = Session.user;

			vm.atualizar = function() {
				var data = {
					id: Session.user.id,
					email: vm.user.email,
					telefone: vm.user.telefone
				};

				UsuarioService.updateUsuario(data).then((response) => {
					if(response.data.success)
						toastr.success('Dados atualizados com sucesso');
					else
						toastr.error('Não foi possível Atualizar os dados');
				});
			}

			vm.alterarSenha = function() {
				var data = {
					id: Session.user.id,
					password: vm.user.password
				};

				UsuarioService.updateUsuario(data).then((response) => {
					if(response.data.success)
						toastr.success('Senha alterada com sucesso');
					else
						toastr.error('Não foi possível alterar senha');
				});
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('UsuarioCadastroController', [ 
		'UsuarioService',
		'$stateParams',
		'PermissaoService',
		'MoradiaService',
		'$state',
		'Session',
		'$scope',
		function (UsuarioService, $stateParams, PermissaoService, MoradiaService, $state, Session, $scope) { 
			'use strict'; 
			var vm = this;
			
			vm.isEditing = false;
			vm.usuario = {
				permissoes: [],
				moradias: [],
				usuario_tipo: {
					permissoes: []
				}
			};
			
			vm.reload = function() {
				var filter = '?empreendimento=' 
					+ Session.empreendimento.id;

				UsuarioService.getTiposUsuario(filter).then((response) => {
					vm.tipos_usuario = response.data.tipos;
				});	

				MoradiaService.getMoradias(filter + '&all=true').then((response) => {
					vm.moradias = response.data.moradias;

					vm.usuario.moradias.forEach((element) => {
						vm.moradias.forEach((innerElement, index) => {
							if(innerElement.id === element.id) {
								vm.moradias.splice(index, 1);
								return;
							}
						});
					});
				});
			}

			angular.element(document).ready(() => {
				$(".select").select2();
			});

			vm.onSelectChange = function() {
				PermissaoService.getPermissoes().then((response) => {
					vm.permissoes = response.data.permissoes;

					vm.usuario.usuario_tipo.permissoes.forEach((element) => {
						vm.permissoes.forEach((innerElement, index) => {
							if(innerElement.id === element.id) {
								vm.permissoes.splice(index, 1);
								return;
							}
						});
					});
				});
			};
			
			$scope.$on('empreendimento_has_changed', () => {
			    vm.reload();
		    });
			vm.reload();

			if($stateParams.id) {
				vm.isEditing = true;

				UsuarioService.getUsuario($stateParams.id).then((response) => {
					vm.usuario = response.data.usuario;
					vm.onSelectChange();
				});		
			}

			vm.pickPermissao = function(id) {
				vm.permissoes.forEach((element, index) => {
					if(element.id === id) {
						vm.usuario.permissoes.push(element);
						vm.permissoes.splice(index, 1);
						return;
					}
				})
			}

			vm.unpickPermissao = function(id) {
				vm.usuario.permissoes.forEach((element, index) => {
					if(element.id === id) {
						vm.permissoes.push(element);
						vm.usuario.permissoes.splice(index, 1);
					}
				});
			}

			vm.pickMoradia = function(id) {
				vm.moradias.forEach((element, index) => {
					if(element.id === id) {
						vm.usuario.moradias.push(element);
						vm.moradias.splice(index, 1);
					}
				});
			}

			vm.unpickMoradia = function(id) {
				vm.usuario.moradias.forEach((element, index) => {
					if(element.id === id) {
						vm.moradias.push(element);
						vm.usuario.moradias.splice(index, 1);
					}
				});
			}

			vm.salvar = function() {
				var data = {
					status: vm.usuario.status,
					email: vm.usuario.email,
					moradias: vm.usuario.moradias.length > 0 ? getIds(vm.usuario.moradias) : undefined,
					nome: vm.usuario.nome,
					permissoes: vm.usuario.permissoes.length > 0 ? getIds(vm.usuario.permissoes) : undefined,
					telefone: vm.usuario.telefone,
					username: vm.usuario.username,
					usuario_tipo_id: vm.usuario.usuario_tipo.id,
					empreendimento_id: Session.empreendimento.id
				};

				if(vm.usuario.password) {
					data['password'] = vm.usuario.password;
				}

				if(vm.usuario.id) {
					data['id'] = vm.usuario.id;
				}

				if(vm.isEditing) {
					UsuarioService.updateUsuario(data).then((response) => {
						if(response.data.success) {
							toastr.success('Usuário alterado com sucesso!');
							$state.go('usuario');
						} else {
							toastr.error('Não foi possível alterar os dados do Usuário!');
							if(response.data.error_message)
								toastr.error(response.data.error_message);
						}
					});
				} else {
					UsuarioService.createUsuario(data).then((response) => {
						if(response.data.success) {
							toastr.success('Usuário cadastrado com sucesso!');
							$state.go('usuario');
						} else {
							toastr.error('Não foi possível cadastrar o Usuário!');
							if(response.data.error_message)
								toastr.error(response.data.error_message);
						}
					});
				}
			}

			function getIds(array) {
				var arrayReturn = [];

				array.forEach((element) => {
					arrayReturn.push(element.id);
				});

				return arrayReturn;
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('UsuarioController', [ 
		'UsuarioService',
		'DialogService',
		'Session',
		'$state',
		'$scope',
		function (UsuarioService, DialogService, Session, $state, $scope) { 
			'use strict'; 
			var vm = this;
			vm.search = '';

			vm.loadUsersFromPage = function(page) {		
				var filters = '?empreendimento=' 
					+ Session.empreendimento.id
					+ (Session.is_suporte() ? '&is_suporte=true' : '')
					+ '&offset=' + page
					+ '&filter=' + vm.search;	
				
				UsuarioService.getUsuarios(filters).then((response) => {
					vm.usuarios = response.data.usuarios;
				});		
			}

			vm.reload = function() {
				var filter = '?empreendimento=' 
					+ Session.empreendimento.id
					+ (Session.is_suporte() ? '&is_suporte=true' : '')
					+ '&filter=' + vm.search;
				
				vm.paginator = 0;

				UsuarioService.getPages(filter).then((response) => {
					vm.pages = response.data.pages;
					vm.maxElements = response.data.count;
					vm.itemsPerPage = response.data.itemsPerPage;
				});

				vm.loadUsersFromPage(vm.paginator);
			}
			
			$scope.$on('empreendimento_has_changed', () => {
			    vm.reload();
		    });
			vm.reload();

			//Controles de filtro
			vm.doFilter = function() {
				vm.reload('&filter='+$scope.search);
			}

			vm.delete = function(element) {
				DialogService.deleteDialog(element.nome, function() {
					UsuarioService.deleteUsuario(element.id).then((response) => {
						if(response.data.success) {
							DialogService.dialog("Deletado com sucesso!");
							$state.reload();
						} else
							DialogService.dialog("Não foi possível deletar "+element.nome, "error");
					});
				});
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('UsuarioTipoCadastroController', [ 
		'UsuarioService',
		'$stateParams',
		'PermissaoService',
		'$state',
		'Session',
		'$scope',
		function (UsuarioService, $stateParams, PermissaoService, $state, Session, $scope) { 
			'use strict'; 
			var vm = this;
			
			vm.isEditing = false;
			vm.permissoes = [];
			vm.tipo_usuario = {
				permissoes: []
			};

			PermissaoService.getPermissoes().then((response) => {
				vm.permissoes = response.data.permissoes;
			});

			angular.element(document).ready(() => {
				$(".select").select2();
			});

			if($stateParams.id) {
				vm.isEditing = true;
				UsuarioService.getTipoUsuario($stateParams.id).then((response) => {
					vm.tipo_usuario = response.data.tipo_usuario;
					cleanSelectedPermissions();
				});
			}

			function cleanSelectedPermissions() {
				vm.tipo_usuario.permissoes.forEach((element) => {
					vm.permissoes.forEach((innerElement, index) => {
						if(innerElement.id === element.id) {
							vm.permissoes.splice(index, 1);
							return;
						}
					});
				});
			}

			vm.pick = function(element, index) {
				vm.permissoes.forEach((innerElement, innerIndex) => {
					if(innerElement.id === element.id) {
						vm.permissoes.splice(innerIndex, 1);
						vm.tipo_usuario.permissoes.push(element);
					}
				});
			}

			vm.unpick = function(element, index) {
				vm.tipo_usuario.permissoes.forEach((innerElement, innerIndex) => {
					if(element.id === innerElement.id) {
						vm.permissoes.push(element);
						vm.tipo_usuario.permissoes.splice(innerIndex, 1);
					}
				});
			}

			vm.salvar = function() {
				var data = {
					titulo: vm.tipo_usuario.titulo,
					permissoes: extractIdsPermissoes(),
					empreendimento_id: Session.empreendimento.id
				};

				if(vm.tipo_usuario.id)
					data['id'] = vm.tipo_usuario.id;

				if(vm.isEditing) {
					UsuarioService.updateTipoUsuario(data).then((response) => {
						if(response.data.success) {
							toastr.success('Tipo de usuário alterado com sucesso!');
							$state.go('usuario-tipo');
						} else {
							toastr.error('Não foi possível alterar os dados do Tipo de usuário!');
						}
					});
				} else {
					UsuarioService.createTipoUsuario(data).then((response) => {
						if(response.data.success) {
							toastr.success('Tipo de usuário cadastrado com sucesso!');
							$state.go('usuario-tipo');
						} else {
							toastr.error('Não foi possível cadastrar o Tipo de usuário!');
						}
					});
				}
			}

			function extractIdsPermissoes() {
				var permissoes = [];

				vm.tipo_usuario.permissoes.forEach((element) => {
					permissoes.push(element.id);
				});

				return permissoes;
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('UsuarioTipoController', [ 
		'UsuarioService',
		'DialogService',
		'$state',
		'Session',
		'$scope',
		function (UsuarioService, DialogService, $state, Session, $scope) { 
			'use strict'; 
			var vm = this;
			
			vm.reloadTipos = function() { 
				var filter = "?empreendimento=" + Session.empreendimento.id + (Session.is_suporte() ? '&is_suporte=true' : '');
				UsuarioService.getTiposUsuario(filter).then((response) => {
					vm.tipos_usuario = response.data.tipos;
				});		
			}
			
			$scope.$on('empreendimento_has_changed', () => {
			    vm.reloadTipos();
		    });
			vm.reloadTipos();

			vm.delete = function(element) {
				DialogService.deleteDialog(element.titulo, function() {
					UsuarioService.deleteTipoUsuario(element.id).then((response) => {
						if(response.data.success) {
							DialogService.dialog("Deletado com sucesso!");
							$state.reload();
						} else
							DialogService.dialog("Não foi possível deletar "+element.titulo, "error");
					});
				});
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('UsuarioViewController', [ 
		'UsuarioService',
		'$stateParams',
		'Session',
		function (UsuarioService, $stateParams, Session) { 
			'use strict'; 
			var vm = this;
			
			UsuarioService.getUsuario($stateParams.id).then((response) => {
				vm.usuario = response.data.usuario;
			});		
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('MeusVisitantesController', [ 
		'VisitanteService',
		'DialogService',
		'$state',
		'$scope',
		'$rootScope',
		'Session',
		'$interval',
		'appConfig',
		function (VisitanteService, DialogService, $state, $scope, $rootScope, Session, $interval, appConfig) { 
			'use strict'; 
			var vm = this;
            //$rootScope.isUserLogged = true;
			vm.data_filter = new Date();
			vm.is_filter = false;
			vm.search = '';
			vm.paginator = 1;
			vm.loadFromPage = function(filter,page) {
				if(!filter)
					filter = Session.empreendimento.id;
				var filters = filter+ '&page=' + page + '&date_filter=' + now(vm.data_filter)+'&usuario_id='+Session.user.id;
				VisitanteService.getVisitantes(filters).then((response) => {
					vm.visitantes = response.data.visitantes;
					if(response.data.pagination) {
						vm.itemsPerPage = response.data.pagination.per_page;
						vm.maxElements = response.data.pagination.total;
						vm.paginator = response.data.pagination.current_page;
					}
				});

			}

			vm.reload = function(filter) {
				if(!filter)
					filter = Session.empreendimento.id + '&date_filter=' + now(vm.data_filter)+'&usuario_id='+Session.user.id;
				if(vm.search != ''){
					filter += '&q=' + vm.search;
				}
				if(!vm.is_filter){
					vm.is_filter = true;
					VisitanteService.getVisitantes(filter).then((response) => {
						vm.maxElements = response.data.total; 
						vm.visitantes = response.data.visitantes;
						vm.is_filter = false;
						if(response.data.pagination) {
							vm.itemsPerPage = response.data.pagination.per_page;
							vm.maxElements = response.data.pagination.total;
							vm.paginator = response.data.pagination.current_page;
						}
						if(vm.visitantes.length === 0)
							toastr.info('Não há visitantes agendados para o empreendimento '+Session.empreendimento.nome_fantasia);
					});	
				}
			};

			$scope.$on('empreendimento_has_changed', () => {
				vm.reload();
		    });
			$interval(() => vm.reload(), appConfig.mil_interval_refresh);

			vm.delete = function(element) {
				DialogService.deleteDialog('visita de ' + element.nome, function() {
					VisitanteService.deleteVisitante(element.id).then((response) => {
						if(response.data.success) {
							DialogService.dialog("Deletado com sucesso!");
							$state.reload();
						} else
							DialogService.dialog("Não foi possível deletar visita de "+element.nome, "error");
					});
				});
			}

			vm.confirm = function(element) {
				DialogService.confirmDialog('Confirmar chegada de ' + element.nome, function() {
					var data = {
						id: element.id,
						confirmado: true,
						responsavel_confirmacao_id: Session.user.id,
						autor_id: Session.user.id,
						nome: element.nome,
						usuario_responsavel_id: element.responsavel
					};

					VisitanteService.updateVisitante(data).then((response) => {
						if(response.data.success) {
							DialogService.dialog("Confirmado com sucesso!");
							$state.reload();
						} else
							DialogService.dialog("Não foi possível confirmar visita de "+element.nome, "error");
					});
				});
			}

			angular.element(document).ready(() => {
				$(".select").select2();
			});
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('VisitanteAutorizadoController', [
		'VisitanteService',
		'DialogService',
		'$state',
		'$scope',
		'Session',
			'$interval',
			'appConfig',
			'$window',
			function (VisitanteService, DialogService, $state, $scope, Session, $interval, appConfig, $window) {
			'use strict';
			var vm = this;
			vm.is_filter = false;
			// vm.data_filter = new Date();
			vm.search = '';
			vm.statusCheckout = '0';
			vm.paginator = 1;
			vm.filter;
			vm.is_downloading = false;

			vm.downloadPdf = function() {
				if(!vm.filter || vm.is_downloading) return;
				vm.is_downloading = true;
				VisitanteService.downloadVisitanteLiberadosPdf(vm.filter).then(function(response) {
					var blob = new Blob([response.data], {type: 'application/pdf'});
					var link = $window.document.createElement('a');
					link.href = $window.URL.createObjectURL(blob);
					link.download = 'visitantes_liberados.pdf';
					link.click();
					$window.URL.revokeObjectURL(link.href);
					vm.is_downloading = false;
				}).catch(function() {
					vm.is_downloading = false;
					toastr.error('Não foi possível gerar o PDF.');
				});
			};

			vm.loadFromPage = function(filter,page) {
				if(!filter)
					filter = Session.empreendimento.id + '&confirmado=1';
				var filters = filter+ '&page=' + page;
				VisitanteService.getVisitanteLiberados(filters).then((response) => {
					vm.visitantes = response.data.visitantes;
					vm.itemsPerPage = response.data.pagination.per_page;
					vm.maxElements = response.data.pagination.total;
					vm.paginator = response.data.pagination.current_page;
				});

			}

			vm.reload = function(filter,refresh) {
				
				if(refresh){
					vm.statusCheckout = '0';
					vm.data_filter = undefined;
				}
				if(!filter)	
					filter = Session.empreendimento.id + '&confirmado=1';
				// filter = Session.empreendimento.id + '&confirmado=1&date_filter=' + now(vm.data_filter);
				if(vm.data_filter !== null && vm.data_filter !== undefined){
					filter += '&date_filter=' + now(vm.data_filter);
				}else{
					var date = new Date();
					var month = date.getMonth() + 1;
					month = month < 10 ? '0'+month : month;
					date = date.getFullYear()+"-"+month+"-"+date.getDate();
					filter +=  "&data_inicio="+vm.subServe(7)+"&data_termino="+date;
				}

				if(vm.search != ''){
					filter += '&q=' + vm.search;
				}
				if(vm.statusCheckout !== '0')
					filter += '&checkout='+vm.statusCheckout;
				if(!vm.is_filter){
					vm.is_filter = true;
					vm.filter = filter;
					VisitanteService.getVisitanteLiberados(filter).then((response) => {
						vm.visitantes = response.data.visitantes;
						vm.itemsPerPage = response.data.pagination.per_page;
						vm.maxElements = response.data.pagination.total;
						vm.paginator = response.data.pagination.current_page;
						vm.is_filter = false;
					})
					.catch(err =>{
						vm.visitantes = [];
						vm.is_filter = false;
						toastr.info('Não há visitantes liberados para o empreendimento '+Session.empreendimento.nome_fantasia);
					});
				}

				// vm.loadFromPage(filter,vm.paginator);
			};

			$scope.$on('empreendimento_has_changed', () => {
				vm.reload();
			});
			vm.subServe = function(days){
				var date = new Date();
				var last = new Date(date.getTime() - (days * 24 * 60 * 60 * 1000));
				var day = last.getDate();
				var month= last.getMonth()+1;
				day = day < 10 ? '0'+day : day;
				month = month < 10 ? '0'+month : month;
				var year= last.getFullYear();
				return year+"-"+month+"-"+day;
			}
			vm.delete = function(element) {
				DialogService.deleteDialog('visita de ' + element.nome, function() {
					VisitanteService.deleteVisitante(element.id).then((response) => {
						if(response.data.success) {
							DialogService.dialog("Deletado com sucesso!");
							$state.reload();
						} else
							DialogService.dialog("Não foi possível deletar visita de "+element.nome, "error");
					});
				});
			}

			vm.checkout = function(element) {
				DialogService.confirmDialog('Confirmar saída de ' + element.nome, function() {
					var data = {
						id: element.id,
						checkout: now()
					};

					VisitanteService.updateVisitante(data).then((response) => {
						if(response.data.success) {
							DialogService.dialog("Saída confirmada com sucesso!");
							$state.reload();
						} else
							DialogService.dialog("Não foi possível gravar a saída da visita de "+element.nome, "error");
					});
				});
			}

			angular.element(document).ready(() => {
			$(".select").select2();
				vm.reload();
			});
		}
	]);
})();

//metronic (4.5.7)
(function() {
	app.controller('VisitanteCadastroController', [
		'VisitanteService',
		'DialogService',
		'UsuarioService',
		'ConjuntoService',
		'$stateParams',
		'$state',
		'Session',
		'$scope',
		'$rootScope',
		function (VisitanteService, DialogService, UsuarioService, ConjuntoService, $stateParams, $state, Session, $scope, $rootScope) {
			'use strict';
			var vm = this;
			vm.isEditing = false;
			vm.visitante = { usuario_responsavel : { nome: '' }, moradia: {}}
			vm.data_visita = new Date().getTime();
			vm.usuarios = [];
			vm.conjuntos = [];
			vm.moradias = [];

			angular.element(document).ready(() => {
				var select2 = $(".select").select2();

				$('.select').on('classChange', function() {
					$select2.data('select2').$container.addClass("wrap")
				});
			});

			vm.terminoHasChanged = function() {
				if(vm.isEditing) return;
				
				let inicio = vm.data_visita;
				let fim = vm.data_visita_termino || vm.data_visita;

				if(fim >= inicio) {
					inicio = inicio.getTime();
					fim = fim.getTime();

					//A operação com Math.ceil calcula a diferença entre dias das datas de início e fim
					vm.data_termino_invalida = Math.ceil((fim - inicio)/(1000 * 3600 * 24)) > 90;
					
					if(vm.data_termino_invalida) {
						vm.data_invalida = true;
						toastr.error("Só é possível agendar visitas com até 90 dias de diferença entre a data de início e fim");
					} else {
						vm.data_invalida = false;
					}
				} else {
					toastr.error("A data de término da visita não pode ser anterior à data de início");
				}
			}

			vm.doFilter = function() {
				var filter = '?empreendimento='
					+ Session.empreendimento.id
					+ '&enabled=true'
					+ '&filter='+vm.visitante.usuario_responsavel.nome;

				if( ! vm.isEditing) {
					UsuarioService.getUsuarios(filter).then((response) => {
						vm.usuarios.length = 0;
						response.data.usuarios.forEach(usuario => {
							usuario.label = '<b>' + usuario.nome + '</b><br />' + usuario.moradias.map(
								moradia => moradia.identificador 
									+ ' (' + moradia.conjunto.titulo + ')').join('<br/>');

							vm.usuarios.push(usuario);
						});
					});	
				}
			}
			vm.loadConjuntos = function() {
				var filter = '?empreendimento='
					+ Session.empreendimento.id
					+ '&enabled=true'
					+ '&com_moradias=true';
				if( ! vm.isEditing) {
					ConjuntoService.getConjuntos(filter).then((response) => {
						vm.conjuntos.length = 0;
						
						response.data.conjuntos.forEach(conjunto => {
							conjunto.label = '<b>' + conjunto.titulo + '</b>';
							vm.conjuntos.push(conjunto);
						});
					});	
				}
			}

			vm.select = function(element) {
				vm.visitante.usuario_responsavel = element;
				vm.moradias = vm.visitante.usuario_responsavel.moradias;
				if(vm.visitante.usuario_responsavel.moradias.length === 1) {
					vm.visitante.moradia = vm.visitante.usuario_responsavel.moradias[0];
				}

				vm.show_box = false;
			}
			vm.selectConjunto = function(conjunto) {
				vm.visitante.conjunto = conjunto;
				conjunto.moradias.map(function(moradia){
					moradia.conjunto = {
						titulo: conjunto.titulo,
						responsavel_nome: Session.user.nome,
						responsavel_id: Session.user.id,
					};
					return moradia;
				});
				vm.visitante.usuario_responsavel = {
					nome: Session.user.nome, 
					id: Session.user.id,
					moradias: conjunto.moradias
				};
				if(vm.visitante.usuario_responsavel.moradias.length === 1) {
					vm.visitante.moradia = vm.visitante.usuario_responsavel.moradias[0];
				}
				vm.show_box = false;
			}

			if($stateParams.id) {
				vm.isEditing = true;

				VisitanteService.getVisitante($stateParams.id).then((response) => {
					vm.visitante = response.data.visitante;
					vm.data_visita = new Date(vm.visitante.data_visita.timestamp);
					vm.conjuntos = [vm.visitante.conjunto];
					if( ! vm.usuarios)
						vm.loadUsuarios();

					vm.doFilter();
				});
			}
			vm.loadConjuntos();
			if($rootScope.isPortaria && !vm.isEditing){
				$('#obs').attr('required','true');
			}
			
			vm.salvar = function(confirmar=false) {
				let stateUrl = 'visitante';
				var data = {
					data_visita: now(vm.data_visita),
					data_visita_termino: now(vm.data_visita_termino || vm.data_visita),
					descricao: vm.visitante.descricao,
					empresa: vm.visitante.empresa,
					atividade: vm.visitante.atividade,
					email: vm.visitante.email,
					nome: vm.visitante.nome,
					placa: vm.visitante.placa,
					qtd_pessoas: vm.visitante.qtd_pessoas,
					responsavel: vm.visitante.usuario_responsavel.id,
					telefone: vm.visitante.telefone,
					moradia_id: vm.visitante.moradia.id,
					responsavel_cadastro_id: Session.user.id,
					observacao: vm.visitante.observacao,
					autorizado_por: vm.visitante.autorizado_por,
					rg: vm.visitante.rg,
					cnh: vm.visitante.cnh
				};
				
				if(Session.empreendimento.id == 17 && Session.user.permissoes_usuario.ver_meu_visitante && Session.user.usuario_tipo_id == 68 ){
					stateUrl = 'meu-visitante';
				}

				if(confirmar){
					data['confirmado'] = true;
					data['responsavel_confirmacao_id'] = Session.user.id;
					data['autor_id'] = Session.user.id;
					data['usuario_responsavel_id'] = vm.visitante.usuario_responsavel.id;
				}

				if(vm.visitante.id)
					data['id'] = vm.visitante.id;

				if(vm.isEditing) {
					delete data.data_visita_termino;

					if(confirmar){
						DialogService.confirmDialog('Confirmar chegada de ' + vm.visitante.nome, function() {
							VisitanteService.updateVisitante(data).then((response) => {
								if(response.data.success) {
									toastr.success('Visitante confirmado e alterado com sucesso!');
									$state.go(stateUrl);
								} else {
									toastr.error('Não foi possível alterar os dados, ou confirmar o Visitante!');
								}
							});
							DialogService.close();
						});
					}else{
						VisitanteService.updateVisitante(data).then((response) => {
							if(response.data.success) {
								toastr.success('Visitante alterado com sucesso!');
								$state.go(stateUrl);
							} else {
								toastr.error('Não foi possível alterar os dados do Visitante!');
							}
						});
					}
				} else {				
					if(
						!$rootScope.isPortaria || 
						$rootScope.isPortaria && data.observacao
					){
						VisitanteService.createVisitante(data).then((response) => {
							if(response.data.success) {
								toastr.success('Visitante cadastrado com sucesso!');
								$state.go(stateUrl);
							} else {
								toastr.error('Não foi possível cadastrar o Visitante!');
							}
						});
					}else{
						toastr.error('Preencha o campo "Autorizado por"');
					}
				}
			}

			vm.deleteAllOcorrence =  function(){
				
				DialogService.confirmDialog('Deseja deletar as visitas de ' + vm.visitante.nome +" com código igual á "+ vm.visitante.codigo_acesso, function() {

					VisitanteService.deleteVisitantes(vm.visitante.id, vm.visitante.codigo_acesso).then((response) => {
							if(response.data.success) {
								toastr.success('visitas deletadas com sucesso!');
								$state.go('visitante');
							} else {
								toastr.error('Não foi deletar as visitas de ' + vm.visitante.nome);
							}
							DialogService.close();
						});
				});
				
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('VisitanteListaCadastroController', [
		'VisitanteService',
		'UsuarioService',
		'ConjuntoService',
		'$stateParams',
		'$state',
		'Session',
		'$scope',
		function (VisitanteService, UsuarioService, ConjuntoService, $stateParams, $state, Session, $scope) {
			'use strict';
			var vm = this;
			vm.isEditing = $stateParams.id;
			vm.visitantes = [{}, {}, {}, {}];
			vm.usuarios = [];
			vm.visitante = {};
			vm.visitantes_ids = [];
			vm.conjuntos = [];
			vm.moradias = [];

			if(vm.isEditing) {
				VisitanteService.getLista($stateParams.id).then(response => {
					let lista = response.data.lista;
					lista.visitantes.map((el) => el.isEditing  = true);
					vm.visitantes = lista.visitantes;
					vm.visitante.local_visita = lista.local;
					vm.data_visita = new Date(lista.data_visita);
					vm.data_visita_termino = new Date(lista.data_visita_termino);
					vm.visitante.usuario_responsavel = lista.usuario_responsavel;
					vm.visitante.moradia = lista.moradia;
					vm.visitante.observacao = lista.observacao;
					vm.visitante.descricao = lista.tipo;
					vm.visitantes_ids = lista.visitante_ids;
				});
			}

			vm.adicionar = function() {
				vm.visitantes.push({});
			}

			vm.remover = function(index) {
				let visitante_removido = vm.visitantes[index];
				for(let i =0 ; i < vm.visitantes_ids.length; i++){
					if(vm.visitantes_ids[i].nome == visitante_removido.nome){
						vm.visitantes_ids[i]= null;
					}
				}
				vm.visitantes_ids = vm.visitantes_ids.filter((el) => el != null);
				vm.visitantes.splice(index, 1);
			}

			vm.terminoHasChanged = function() {
				let inicio = vm.data_visita;
				let fim = vm.data_visita_termino || vm.data_visita;

				if(fim >= inicio) {
					inicio = inicio.getTime();
					fim = fim.getTime();

					//A operação com Math.ceil calcula a diferença entre dias das datas de início e fim
					vm.data_termino_invalida = Math.ceil((fim - inicio)/(1000 * 3600 * 24)) > 90;
					
					if(vm.data_termino_invalida) {
						vm.data_invalida = true;
						toastr.error("Só é possível agendar visitas com até 90 dias de diferença entre a data de início e fim");
					} else {
						vm.data_invalida = false;
					}
				} else {
					toastr.error("A data de término da visita não pode ser anterior à data de início");
				}
			}

			angular.element(document).ready(() => {
				var select2 = $(".select").select2();

				$('.select').on('classChange', function() {
					$select2.data('select2').$container.addClass("wrap")
				});
			});

			vm.doFilter = function() {
				var filter = '?empreendimento='
					+ Session.empreendimento.id
					+ '&enabled=true'
					+ '&filter='+vm.visitante.usuario_responsavel.nome;

				if( ! vm.isEditing) {
					UsuarioService.getUsuarios(filter).then((response) => {
						vm.usuarios.length = 0;

						response.data.usuarios.forEach(usuario => {
							usuario.label = '<b>' + usuario.nome + '</b><br />' + usuario.moradias.map(
								moradia => moradia.identificador 
									+ ' (' + moradia.conjunto.titulo + ')').join('<br/>');

							vm.usuarios.push(usuario);
						});
					});	
				}
			}
			vm.loadConjuntos = function() {
				var filter = '?empreendimento='
					+ Session.empreendimento.id
					+ '&enabled=true'
					+ '&com_moradias=true';
				if( ! vm.isEditing) {
					ConjuntoService.getConjuntos(filter).then((response) => {
						vm.conjuntos.length = 0;
						
						response.data.conjuntos.forEach(conjunto => {
							conjunto.label = '<b>' + conjunto.titulo + '</b>';
							vm.conjuntos.push(conjunto);
						});
						console.log(vm.conjuntos)
					});	
				}
			}

			vm.select = function(element) {
				vm.visitante.usuario_responsavel = element;

				if(vm.visitante.usuario_responsavel.moradias.length === 1) {
					vm.visitante.moradia = vm.visitante.usuario_responsavel.moradias[0];
				}

				vm.show_box = false;
			}

			vm.selectConjunto = function(conjunto) {
				vm.visitante.conjunto = conjunto;
				conjunto.moradias.map(function(moradia){
					moradia.conjunto = {
						titulo: conjunto.titulo,
						responsavel_nome: Session.user.nome,
						responsavel_id: Session.user.id,
					};
					return moradia;
				});
				vm.visitante.usuario_responsavel = {
					nome: Session.user.nome, 
					id: Session.user.id,
					moradias: conjunto.moradias
				};
				if(vm.visitante.usuario_responsavel.moradias.length === 1) {
					vm.visitante.moradia = vm.visitante.usuario_responsavel.moradias[0];
				}
				vm.show_box = false;
			}

			vm.returnObjectVisitante = (object) =>{
				return {
					id: object.id,
					data_visita: now(vm.data_visita),
					data_visita_termino: now(vm.data_visita_termino || vm.data_visita),
					descricao: vm.visitante.descricao,
					responsavel: vm.visitante.usuario_responsavel.id,
					moradia_id: vm.visitante.moradia.id,
					email: object.email,
					nome: object.nome,
					placa: object.placa,
					qtd_pessoas: object.qtd_pessoas,
					telefone: object.telefone,
					responsavel_cadastro_id: Session.user.id,
					observacao: vm.visitante.observacao,
					rg: object.rg,
					cnh: object.cnh
				};
			}

			vm.returnListVisitante = (lista,data) => {
				lista.forEach(visitante => {
					if(visitante.id) {
						data.visitantes_ids.push(visitante.id);
					}
					data.visitantes.push(vm.returnObjectVisitante(visitante));
				});
				return data;
			}
			vm.loadConjuntos();
			vm.salvar = function() {
				let stateUrl = 'visitante-lista';
				var data = {
					visitantes: [],
					local: vm.visitante.local_visita || '',
					responsavel: vm.visitante.usuario_responsavel.id,
					observacao: vm.visitante.observacao || '',
					moradia_id: vm.visitante.moradia.id,
					data_visita: now(vm.data_visita),
					data_visita_termino : now(vm.data_visita_termino),
					tipo: vm.visitante.descricao,
					visitantes_ids: []
				};
				if(vm.visitantes_ids.length > 0){
					data = vm.returnListVisitante(vm.visitantes_ids,data);
					vm.visitantes.map((el)=>{
						if(el.id == undefined){
							data.visitantes.push(vm.returnObjectVisitante(el));
						}else{
							data.visitantes.filter((e) => e.nome == el.nome).map((e)=>{
								e.email = el.email;
								e.placa = el.placa;
								e.qtd_pessoas = el.qtd_pessoas;
								e.telefone = el.telefone;
								e.rg = el.rg;
								e.cnh = el.cnh;
							});
						}
					});
				}else{
					data = vm.returnListVisitante(vm.visitantes,data);
				}

				if(Session.empreendimento.id == 17 && Session.user.permissoes_usuario.ver_meu_visitante && Session.user.usuario_tipo_id == 68 ){
					stateUrl = 'meu-visitante';
				}
				
				if(vm.isEditing) {
					VisitanteService.updateLista({visitantes: data, id: $stateParams.id}).then(response => {
						if(response.data.success) {
							toastr.success('Lista editada com sucesso!');
							$state.go(stateUrl);
						} else {
							toastr.error('Não foi possível editar Lista!');
						}
					});
				} else {
					data.timestamp = Date.now();

					VisitanteService.createVisitante({visitantes: data}).then((response) => {
						if(response.data.success) {
							toastr.success('Lista cadastrada com sucesso!');
							$state.go(stateUrl);
						} else {
							toastr.error('Não foi possível cadastrar Lista!');
						}
					});
				}
			}
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('VisitanteController', [ 
		'VisitanteService',
		'DialogService',
		'$state',
		'$scope',
		'$rootScope',
		'Session',
		'$interval',
		'appConfig',
		function (VisitanteService, DialogService, $state, $scope, $rootScope, Session, $interval, appConfig) { 
			'use strict'; 
			var vm = this;
            //$rootScope.isUserLogged = true;
			vm.data_filter = new Date();
			vm.is_filter = false;
			vm.search = '';
			vm.paginator = 1;

			vm.loadFromPage = function(filter,page) {
				if(!filter)
					filter = Session.empreendimento.id;
				var filters = filter+ '&page=' + page + '&date_filter=' + now(vm.data_filter);
				VisitanteService.getVisitantes(filters).then((response) => {
					vm.visitantes = response.data.visitantes;
					if(response.data.pagination) {
						vm.itemsPerPage = response.data.pagination.per_page;
						vm.maxElements = response.data.pagination.total;
						vm.paginator = response.data.pagination.current_page;
					}
				});

			}

			vm.reload = function(filter) {
				if(!filter)
					filter = Session.empreendimento.id + '&date_filter=' + now(vm.data_filter);
				if(vm.search != ''){
					filter += '&q=' + vm.search;
				}
				if(!vm.is_filter){
					vm.is_filter = true;
					VisitanteService.getVisitantes(filter).then((response) => {
						vm.maxElements = response.data.total; 
						vm.visitantes = response.data.visitantes;
						vm.is_filter = false;
						if(response.data.pagination) {
							vm.itemsPerPage = response.data.pagination.per_page;
							vm.maxElements = response.data.pagination.total;
							vm.paginator = response.data.pagination.current_page;
						}
						if(vm.visitantes.length === 0)
							toastr.info('Não há visitantes agendados para o empreendimento '+Session.empreendimento.nome_fantasia);
					});	
				}
			};

			$scope.$on('empreendimento_has_changed', () => {
				vm.reload();
		    });
			$interval(() => vm.reload(), appConfig.mil_interval_refresh);

			vm.delete = function(element) {
				DialogService.deleteDialog('visita de ' + element.nome, function() {
					VisitanteService.deleteVisitante(element.id).then((response) => {
						if(response.data.success) {
							DialogService.dialog("Deletado com sucesso!");
							$state.reload();
						} else
							DialogService.dialog("Não foi possível deletar visita de "+element.nome, "error");
					});
				});
			}

			vm.confirm = function(element) {
				DialogService.confirmDialog('Confirmar chegada de ' + element.nome, function() {
					var data = {
						id: element.id,
						confirmado: true,
						responsavel_confirmacao_id: Session.user.id,
						autor_id: Session.user.id,
						nome: element.nome,
						usuario_responsavel_id: element.responsavel
					};

					VisitanteService.updateVisitante(data).then((response) => {
						if(response.data.success) {
							DialogService.dialog("Confirmado com sucesso!");
							$state.reload();
						} else
							DialogService.dialog("Não foi possível confirmar visita de "+element.nome, "error");
					});
				});
			}

			angular.element(document).ready(() => {
				$(".select").select2();
			});
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('VisitanteEstatisticaController', [
		'VisitanteService',
		'$scope',
		'$rootScope',
    'Session',
    'ConjuntoService',
		function (VisitanteService,  $scope, $rootScope, Session,ConjuntoService ) {
			'use strict';
      var vm = this;
      vm.ano = '';
      vm.checkout = '';
      vm.totalGeral = {};
      vm.month = undefined;
      vm.conjunto = '0';
      vm.conjuntos = [];

      $scope.labels = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"];
      $scope.series = ['Visitantes', 'Prestadores'];
      $scope.data = [
        [0,0,0,0,0,0,0,0,0,0,0,0],
        [0,0,0,0,0,0,0,0,0,0,0,0]
      ];
      $scope.onClick = function (e,event) {
        // if (e.length > 0) {
        //   let dados = {};
        //   const chart = e[0]._chart.controller;
        //   const activePoints = chart.getElementAtEvent(event);
        //   if ( activePoints.length > 0) {
        //     const clickedElementIndex = activePoints[0]._index;
        //     const label = chart.data.labels[clickedElementIndex];
        //     const value = chart.data.datasets[0].data[clickedElementIndex];
        //     dados = {
        //       mes: label,
        //       visitante: {
        //         valor: value
        //       },
        //       prestador:{
        //         valor: chart.data.datasets[1].data[clickedElementIndex]
        //       }
        //     }
        //   }
        //   vm.month = dados;
        //   $scope.$apply();
        // }
      };
      $scope.options = {};

      vm.init = function(){
        vm.listYear = vm.createListYear();
        var data = new Date();
        vm.ano = String(data.getFullYear());
        vm.reload();
      }

      vm.searchConjunto = function(){
        var filters = '?empreendimento=' + Session.empreendimento.id;
        ConjuntoService.getConjuntos(filters).then((response) => {
					vm.conjuntos = response.data.conjuntos;
				});
      }

      vm.reload = function(filter) {
        vm.month = undefined;
        if(!filter)
          filter = Session.empreendimento.id + '&confirmado=1';
        filter += '&ano='+vm.ano
        filter += vm.conjunto !== '0' ? '&torre='+vm.conjunto : '';

        VisitanteService.getVisitanteEstatistica(filter).then((response)=>{
          vm.totalGeral = response.data.totalGeral[0];
          vm.visitantesGeral = response.data.visitantesGeral;
          vm.createListByMonth(response.data.visitantesGeral);
          if(vm.conjuntos.length === 0){
             vm.searchConjunto();
          }
        })
      }
      vm.createListByMonth = function(inMonth){
        for(var i = 0;i < 12; i++){
          $scope.data[0][i] = inMonth[i].visitante.total_visitante;
          $scope.data[1][i] = inMonth[i].prestador.total_prestador;
        }
      }

      vm.createListYear = function() {
        var data = new Date();
        var list = [];
        for(var i = 2012;i <= data.getFullYear();i++){
          list.push(i);
        }
        return list;
      }
      vm.init();
      // vm.reload();

    }
  ])
})();

//metronic (4.5.7)
(function() {
	app.controller('VisitanteListaController', [ 
		'VisitanteService',
		'DialogService',
		'$state',
		'$scope',
		'$rootScope',
		'Session',
		'$interval',
		'appConfig',
		function (VisitanteService, DialogService, $state, $scope, $rootScope, Session, $interval, appConfig) { 
			'use strict'; 
			var vm = this;
			vm.is_filter = false;
            //$rootScope.isUserLogged = true;
			vm.data_filter = new Date();
			vm.search = '';

			vm.reload = function(filter) {			
				filter = Session.empreendimento.id + '&date_filter=' + now(vm.data_filter);
				if(vm.search != ''){
					filter += '&q=' + vm.search;
				}
				if(!vm.is_filter){
					vm.is_filter = true;
					VisitanteService.getVisitantes(filter + '&from_lista=true').then((response) => {
						vm.maxElements = response.data.total; 
						vm.visitantes = response.data.visitantes;
						vm.is_filter = false;
						if(vm.visitantes.length === 0)
							toastr.info('Não há visitantes agendados para o empreendimento '+Session.empreendimento.nome_fantasia);
					});	
				}
			};
			
			$scope.$on('empreendimento_has_changed', () => {
				vm.reload();
		    });
			//vm.reload();
			
			$interval(() => vm.reload(), appConfig.mil_interval_refresh);

			vm.delete = function(element) {
				DialogService.deleteDialog('visita de ' + element.nome, function() {
					VisitanteService.deleteVisitante(element.id).then((response) => {
						if(response.data.success) {
							DialogService.dialog("Deletado com sucesso!");
							$state.reload();
						} else
							DialogService.dialog("Não foi possível deletar visita de "+element.nome, "error");
					});
				});
			}

			vm.confirm = function(element) {
				DialogService.confirmDialog('Confirmar chegada de ' + element.nome, function() {
					var data = {
						id: element.id,
						confirmado: true,
						responsavel_confirmacao_id: Session.user.id,
						autor_id: Session.user.id,
						nome: element.nome,
						usuario_responsavel_id: element.usuario_responsavel.id
					};

					VisitanteService.updateVisitante(data).then((response) => {
						if(response.data.success) {
							DialogService.dialog("Confirmado com sucesso!");
							$state.reload();
						} else
							DialogService.dialog("Não foi possível confirmar visita de "+element.nome, "error");
					});
				});
			}

			angular.element(document).ready(() => {
				$(".select").select2();
			});
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('ListasController', [ 
		'VisitanteService',
		'DialogService',
		'$state',
		'$scope',
		'$rootScope',
		'Session',
		'$interval',
		'appConfig',
		function (VisitanteService, DialogService, $state, $scope, $rootScope, Session, $interval, appConfig) { 
			'use strict'; 
			var vm = this;
            //$rootScope.isUserLogged = true;
			
			vm.reload = function(){
				VisitanteService.getListas('?empreendimento='+Session.empreendimento.id).then(response => {
					vm.maxElements = response.data.total; 
					vm.lista = response.data.lista;
				});
			}
			
			$scope.$on('empreendimento_has_changed', () => {
				vm.reload();
		    });
			vm.reload();

            vm.delete = element => {
				DialogService.deleteDialog('Lista ' + element.id, function() {
					VisitanteService.deleteLista(element.id).then((response) => {
						if(response.data.success) {
							DialogService.dialog("Deletado com sucesso!");
							$state.reload();
						} else
							DialogService.dialog("Não foi possível deletar lista "+element.id, "error");
					});
				});
            }

			angular.element(document).ready(() => {
				$(".select").select2();
			});
		}
	]);
})();
//metronic (4.5.7)
(function() {
	app.controller('VisitanteRelatorioController', [
		'VisitanteService',
		'DialogService',
		'UsuarioService',
		'$stateParams',
		'$state',
		'Session',
		'$scope',
		'$rootScope',
		function (VisitanteService, DialogService, UsuarioService, $stateParams, $state, Session, $scope, $rootScope) {
			'use strict';
			var vm = this;
			vm.is_filter = false;
			vm.usuarios = [];
			vm.paginator = 1;

			angular.element(document).ready(() => {
				var select2 = $(".select").select2();

				$('.select').on('classChange', function() {
					$select2.data('select2').$container.addClass("wrap")
				});
			});

			vm.doFilter = function() {
				var filter = '?empreendimento='
					+ Session.empreendimento.id
					+ '&enabled=true'
					+ '&filter='+vm.visitante.usuario_responsavel.nome;

				UsuarioService.getUsuarios(filter).then((response) => {
					vm.usuarios.length = 0;
					
					response.data.usuarios.forEach(usuario => {
						usuario.label = '<b>' + usuario.nome + '</b><br />' + usuario.moradias.map(
							moradia => moradia.identificador 
								+ ' (' + moradia.conjunto.titulo + ')').join('<br/>');

						vm.usuarios.push(usuario);
					});
				});	
			}

			vm.select = function(element) {
				vm.visitante.usuario_responsavel = element;

				if(vm.visitante.usuario_responsavel.moradias.length === 1) {
					vm.visitante.moradia = vm.visitante.usuario_responsavel.moradias[0];
				}

				vm.show_box = false;
			}

			vm.loadFromPage = function(filter,page) {
				if(!filter)
					filter = Session.empreendimento.id;
				// var filters = filter+ '&page=' + page + '&date_filter=' + now(vm.data_filter);
				var responsible ='';
				if(vm.visitante) {					
					responsible = "&usuario_id="+vm.visitante.usuario_responsavel.id;
				}
				var descricao = vm.descricao || '';
				var filters = filter+ "&data_inicio="+now(vm.data_inicio)+"&data_termino="+now(vm.data_termino)+responsible+'&busca_geral='+vm.busca_geral+"&confirmado="+vm.confirmado+"&descricao="+descricao+ '&page=' + page+'&search=true';
				VisitanteService.getVisitantes(filters).then((response) => {
					vm.visitantes = response.data.visitantes;
					vm.itemsPerPage = response.data.pagination.per_page;
					vm.maxElements = response.data.pagination.total;
					vm.paginator = response.data.pagination.current_page;
				});

			}
			
			vm.buscar = function() {
				var responsible ='';
				if(vm.visitante) {					
					responsible = "&usuario_id="+vm.visitante.usuario_responsavel.id;
				}
				var descricao = vm.descricao || '';
				var data = "&data_inicio="+now(vm.data_inicio)+"&data_termino="+now(vm.data_termino)+responsible+'&busca_geral='+vm.busca_geral+"&confirmado="+vm.confirmado+"&descricao="+descricao;
				
				if(!vm.is_filter){
					vm.is_filter = true;
					VisitanteService.getSearch(Session.empreendimento.id,data).then((response) => {
						vm.maxElements = response.data.total; 
						vm.visitantes = response.data.visitantes;
						vm.is_filter = false;
						vm.itemsPerPage = response.data.pagination.per_page;
						vm.maxElements = response.data.pagination.total;
						vm.paginator = response.data.pagination.current_page;
						if(vm.visitantes.length === 0)
							toastr.info('Não há visitantes para o empreendimento '+Session.empreendimento.nome_fantasia);
					});
				}
			}
		}
	]);
})();